
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaec4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaec4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("59Y1B", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $3c1c5ab8813d40a7$export$ffb0004e005737fa; }, function (v) { return $3c1c5ab8813d40a7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $3c1c5ab8813d40a7$export$34b9dba7ce09269b; }, function (v) { return $3c1c5ab8813d40a7$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $3c1c5ab8813d40a7$export$25062201e9e25d76; }, function (v) { return $3c1c5ab8813d40a7$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c1c5ab8813d40a7$export$ffb0004e005737fa;
var $3c1c5ab8813d40a7$export$34b9dba7ce09269b;
var $3c1c5ab8813d40a7$export$25062201e9e25d76;
'use strict';

var $9kKA1 = parcelRequire("9kKA1");
var $3c1c5ab8813d40a7$var$k = Symbol.for("react.element"), $3c1c5ab8813d40a7$var$l = Symbol.for("react.fragment"), $3c1c5ab8813d40a7$var$m = Object.prototype.hasOwnProperty, $3c1c5ab8813d40a7$var$n = $9kKA1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $3c1c5ab8813d40a7$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3c1c5ab8813d40a7$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$3c1c5ab8813d40a7$var$m.call(a, b) && !$3c1c5ab8813d40a7$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $3c1c5ab8813d40a7$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $3c1c5ab8813d40a7$var$n.current
    };
}
$3c1c5ab8813d40a7$export$ffb0004e005737fa = $3c1c5ab8813d40a7$var$l;
$3c1c5ab8813d40a7$export$34b9dba7ce09269b = $3c1c5ab8813d40a7$var$q;
$3c1c5ab8813d40a7$export$25062201e9e25d76 = $3c1c5ab8813d40a7$var$q;

});
parcelRegister("9kKA1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fibvM"));

});
parcelRegister("fibvM", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b2217765662b7374$export$dca3b0875bd9a954; }, function (v) { return $b2217765662b7374$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b2217765662b7374$export$16fa2f45be04daa8; }, function (v) { return $b2217765662b7374$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b2217765662b7374$export$ffb0004e005737fa; }, function (v) { return $b2217765662b7374$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b2217765662b7374$export$e2c29f18771995cb; }, function (v) { return $b2217765662b7374$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b2217765662b7374$export$221d75b3f55bb0bd; }, function (v) { return $b2217765662b7374$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b2217765662b7374$export$5f8d39834fd61797; }, function (v) { return $b2217765662b7374$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b2217765662b7374$export$74bf444e3cd11ea5; }, function (v) { return $b2217765662b7374$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b2217765662b7374$export$ae55be85d98224ed; }, function (v) { return $b2217765662b7374$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b2217765662b7374$export$e530037191fcd5d7; }, function (v) { return $b2217765662b7374$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b2217765662b7374$export$fd42f52fd3ae1109; }, function (v) { return $b2217765662b7374$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b2217765662b7374$export$c8a8987d4410bf2d; }, function (v) { return $b2217765662b7374$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b2217765662b7374$export$d38cd72104c1f0e9; }, function (v) { return $b2217765662b7374$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b2217765662b7374$export$7d1e3a5e95ceca43; }, function (v) { return $b2217765662b7374$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b2217765662b7374$export$257a8862b851cb5b; }, function (v) { return $b2217765662b7374$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b2217765662b7374$export$a8257692ac88316c; }, function (v) { return $b2217765662b7374$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b2217765662b7374$export$488013bae63b21da; }, function (v) { return $b2217765662b7374$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b2217765662b7374$export$7c73462e0d25e514; }, function (v) { return $b2217765662b7374$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b2217765662b7374$export$7568632d0d33d16d; }, function (v) { return $b2217765662b7374$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b2217765662b7374$export$88948ce120ea2619; }, function (v) { return $b2217765662b7374$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b2217765662b7374$export$35808ee640e87ca7; }, function (v) { return $b2217765662b7374$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b2217765662b7374$export$fae74005e78b1a27; }, function (v) { return $b2217765662b7374$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b2217765662b7374$export$dc8fbce3eb94dc1e; }, function (v) { return $b2217765662b7374$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b2217765662b7374$export$6a7bc4e911dc01cf; }, function (v) { return $b2217765662b7374$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b2217765662b7374$export$6d9c69b0de29b591; }, function (v) { return $b2217765662b7374$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b2217765662b7374$export$f680877a34711e37; }, function (v) { return $b2217765662b7374$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b2217765662b7374$export$d5a552a76deda3c2; }, function (v) { return $b2217765662b7374$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b2217765662b7374$export$aaabe4eda9ed9969; }, function (v) { return $b2217765662b7374$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b2217765662b7374$export$e5c5a5f917a5871c; }, function (v) { return $b2217765662b7374$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b2217765662b7374$export$1538c33de8887b59; }, function (v) { return $b2217765662b7374$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b2217765662b7374$export$13e3392192263954; }, function (v) { return $b2217765662b7374$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b2217765662b7374$export$b8f5890fc79d6aca; }, function (v) { return $b2217765662b7374$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b2217765662b7374$export$60241385465d0a34; }, function (v) { return $b2217765662b7374$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b2217765662b7374$export$306c0aa65ff9ec16; }, function (v) { return $b2217765662b7374$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b2217765662b7374$export$7b286972b8d8ccbf; }, function (v) { return $b2217765662b7374$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b2217765662b7374$export$83d89fbfd8236492; }, function (v) { return $b2217765662b7374$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b2217765662b7374$export$dca3b0875bd9a954;
var $b2217765662b7374$export$16fa2f45be04daa8;
var $b2217765662b7374$export$ffb0004e005737fa;
var $b2217765662b7374$export$e2c29f18771995cb;
var $b2217765662b7374$export$221d75b3f55bb0bd;
var $b2217765662b7374$export$5f8d39834fd61797;
var $b2217765662b7374$export$74bf444e3cd11ea5;
var $b2217765662b7374$export$ae55be85d98224ed;
var $b2217765662b7374$export$e530037191fcd5d7;
var $b2217765662b7374$export$fd42f52fd3ae1109;
var $b2217765662b7374$export$c8a8987d4410bf2d;
var $b2217765662b7374$export$d38cd72104c1f0e9;
var $b2217765662b7374$export$7d1e3a5e95ceca43;
var $b2217765662b7374$export$257a8862b851cb5b;
var $b2217765662b7374$export$a8257692ac88316c;
var $b2217765662b7374$export$488013bae63b21da;
var $b2217765662b7374$export$7c73462e0d25e514;
var $b2217765662b7374$export$7568632d0d33d16d;
var $b2217765662b7374$export$88948ce120ea2619;
var $b2217765662b7374$export$35808ee640e87ca7;
var $b2217765662b7374$export$fae74005e78b1a27;
var $b2217765662b7374$export$dc8fbce3eb94dc1e;
var $b2217765662b7374$export$6a7bc4e911dc01cf;
var $b2217765662b7374$export$6d9c69b0de29b591;
var $b2217765662b7374$export$f680877a34711e37;
var $b2217765662b7374$export$d5a552a76deda3c2;
var $b2217765662b7374$export$aaabe4eda9ed9969;
var $b2217765662b7374$export$e5c5a5f917a5871c;
var $b2217765662b7374$export$1538c33de8887b59;
var $b2217765662b7374$export$13e3392192263954;
var $b2217765662b7374$export$b8f5890fc79d6aca;
var $b2217765662b7374$export$60241385465d0a34;
var $b2217765662b7374$export$306c0aa65ff9ec16;
var $b2217765662b7374$export$7b286972b8d8ccbf;
var $b2217765662b7374$export$83d89fbfd8236492;
'use strict';
var $b2217765662b7374$var$l = Symbol.for("react.element"), $b2217765662b7374$var$n = Symbol.for("react.portal"), $b2217765662b7374$var$p = Symbol.for("react.fragment"), $b2217765662b7374$var$q = Symbol.for("react.strict_mode"), $b2217765662b7374$var$r = Symbol.for("react.profiler"), $b2217765662b7374$var$t = Symbol.for("react.provider"), $b2217765662b7374$var$u = Symbol.for("react.context"), $b2217765662b7374$var$v = Symbol.for("react.forward_ref"), $b2217765662b7374$var$w = Symbol.for("react.suspense"), $b2217765662b7374$var$x = Symbol.for("react.memo"), $b2217765662b7374$var$y = Symbol.for("react.lazy"), $b2217765662b7374$var$z = Symbol.iterator;
function $b2217765662b7374$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b2217765662b7374$var$z && a[$b2217765662b7374$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b2217765662b7374$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b2217765662b7374$var$C = Object.assign, $b2217765662b7374$var$D = {};
function $b2217765662b7374$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b2217765662b7374$var$D;
    this.updater = e || $b2217765662b7374$var$B;
}
$b2217765662b7374$var$E.prototype.isReactComponent = {};
$b2217765662b7374$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b2217765662b7374$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b2217765662b7374$var$F() {}
$b2217765662b7374$var$F.prototype = $b2217765662b7374$var$E.prototype;
function $b2217765662b7374$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b2217765662b7374$var$D;
    this.updater = e || $b2217765662b7374$var$B;
}
var $b2217765662b7374$var$H = $b2217765662b7374$var$G.prototype = new $b2217765662b7374$var$F;
$b2217765662b7374$var$H.constructor = $b2217765662b7374$var$G;
$b2217765662b7374$var$C($b2217765662b7374$var$H, $b2217765662b7374$var$E.prototype);
$b2217765662b7374$var$H.isPureReactComponent = !0;
var $b2217765662b7374$var$I = Array.isArray, $b2217765662b7374$var$J = Object.prototype.hasOwnProperty, $b2217765662b7374$var$K = {
    current: null
}, $b2217765662b7374$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b2217765662b7374$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b2217765662b7374$var$J.call(b, d) && !$b2217765662b7374$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b2217765662b7374$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b2217765662b7374$var$K.current
    };
}
function $b2217765662b7374$var$N(a, b) {
    return {
        $$typeof: $b2217765662b7374$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b2217765662b7374$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b2217765662b7374$var$l;
}
function $b2217765662b7374$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b2217765662b7374$var$P = /\/+/g;
function $b2217765662b7374$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b2217765662b7374$var$escape("" + a.key) : b.toString(36);
}
function $b2217765662b7374$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b2217765662b7374$var$l:
                case $b2217765662b7374$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b2217765662b7374$var$Q(h, 0) : d, $b2217765662b7374$var$I(c) ? (e = "", null != a && (e = a.replace($b2217765662b7374$var$P, "$&/") + "/"), $b2217765662b7374$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b2217765662b7374$var$O(c) && (c = $b2217765662b7374$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b2217765662b7374$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b2217765662b7374$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b2217765662b7374$var$Q(k, g);
        h += $b2217765662b7374$var$R(k, b, e, f, c);
    }
    else if (f = $b2217765662b7374$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b2217765662b7374$var$Q(k, g++), h += $b2217765662b7374$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b2217765662b7374$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b2217765662b7374$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b2217765662b7374$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b2217765662b7374$var$U = {
    current: null
}, $b2217765662b7374$var$V = {
    transition: null
}, $b2217765662b7374$var$W = {
    ReactCurrentDispatcher: $b2217765662b7374$var$U,
    ReactCurrentBatchConfig: $b2217765662b7374$var$V,
    ReactCurrentOwner: $b2217765662b7374$var$K
};
$b2217765662b7374$export$dca3b0875bd9a954 = {
    map: $b2217765662b7374$var$S,
    forEach: function(a, b, e) {
        $b2217765662b7374$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b2217765662b7374$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b2217765662b7374$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b2217765662b7374$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b2217765662b7374$export$16fa2f45be04daa8 = $b2217765662b7374$var$E;
$b2217765662b7374$export$ffb0004e005737fa = $b2217765662b7374$var$p;
$b2217765662b7374$export$e2c29f18771995cb = $b2217765662b7374$var$r;
$b2217765662b7374$export$221d75b3f55bb0bd = $b2217765662b7374$var$G;
$b2217765662b7374$export$5f8d39834fd61797 = $b2217765662b7374$var$q;
$b2217765662b7374$export$74bf444e3cd11ea5 = $b2217765662b7374$var$w;
$b2217765662b7374$export$ae55be85d98224ed = $b2217765662b7374$var$W;
$b2217765662b7374$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b2217765662b7374$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b2217765662b7374$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b2217765662b7374$var$J.call(b, f) && !$b2217765662b7374$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b2217765662b7374$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b2217765662b7374$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b2217765662b7374$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b2217765662b7374$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b2217765662b7374$export$c8a8987d4410bf2d = $b2217765662b7374$var$M;
$b2217765662b7374$export$d38cd72104c1f0e9 = function(a) {
    var b = $b2217765662b7374$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b2217765662b7374$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b2217765662b7374$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b2217765662b7374$var$v,
        render: a
    };
};
$b2217765662b7374$export$a8257692ac88316c = $b2217765662b7374$var$O;
$b2217765662b7374$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b2217765662b7374$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b2217765662b7374$var$T
    };
};
$b2217765662b7374$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b2217765662b7374$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b2217765662b7374$export$7568632d0d33d16d = function(a) {
    var b = $b2217765662b7374$var$V.transition;
    $b2217765662b7374$var$V.transition = {};
    try {
        a();
    } finally{
        $b2217765662b7374$var$V.transition = b;
    }
};
$b2217765662b7374$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$b2217765662b7374$export$35808ee640e87ca7 = function(a, b) {
    return $b2217765662b7374$var$U.current.useCallback(a, b);
};
$b2217765662b7374$export$fae74005e78b1a27 = function(a) {
    return $b2217765662b7374$var$U.current.useContext(a);
};
$b2217765662b7374$export$dc8fbce3eb94dc1e = function() {};
$b2217765662b7374$export$6a7bc4e911dc01cf = function(a) {
    return $b2217765662b7374$var$U.current.useDeferredValue(a);
};
$b2217765662b7374$export$6d9c69b0de29b591 = function(a, b) {
    return $b2217765662b7374$var$U.current.useEffect(a, b);
};
$b2217765662b7374$export$f680877a34711e37 = function() {
    return $b2217765662b7374$var$U.current.useId();
};
$b2217765662b7374$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b2217765662b7374$var$U.current.useImperativeHandle(a, b, e);
};
$b2217765662b7374$export$aaabe4eda9ed9969 = function(a, b) {
    return $b2217765662b7374$var$U.current.useInsertionEffect(a, b);
};
$b2217765662b7374$export$e5c5a5f917a5871c = function(a, b) {
    return $b2217765662b7374$var$U.current.useLayoutEffect(a, b);
};
$b2217765662b7374$export$1538c33de8887b59 = function(a, b) {
    return $b2217765662b7374$var$U.current.useMemo(a, b);
};
$b2217765662b7374$export$13e3392192263954 = function(a, b, e) {
    return $b2217765662b7374$var$U.current.useReducer(a, b, e);
};
$b2217765662b7374$export$b8f5890fc79d6aca = function(a) {
    return $b2217765662b7374$var$U.current.useRef(a);
};
$b2217765662b7374$export$60241385465d0a34 = function(a) {
    return $b2217765662b7374$var$U.current.useState(a);
};
$b2217765662b7374$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b2217765662b7374$var$U.current.useSyncExternalStore(a, b, e);
};
$b2217765662b7374$export$7b286972b8d8ccbf = function() {
    return $b2217765662b7374$var$U.current.useTransition();
};
$b2217765662b7374$export$83d89fbfd8236492 = "18.0.0-fc46dba67-20220329";

});



parcelRegister("ePSVh", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $acd06eaa94858840$export$ae55be85d98224ed; }, function (v) { return $acd06eaa94858840$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $acd06eaa94858840$export$d39a5bbd09211389; }, function (v) { return $acd06eaa94858840$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $acd06eaa94858840$export$882461b6382ed46c; }, function (v) { return $acd06eaa94858840$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $acd06eaa94858840$export$466bfc07425424d5; }, function (v) { return $acd06eaa94858840$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $acd06eaa94858840$export$cd75ccfd720a3cd4; }, function (v) { return $acd06eaa94858840$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $acd06eaa94858840$export$fa8d919ba61d84db; }, function (v) { return $acd06eaa94858840$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $acd06eaa94858840$export$757ceba2d55c277e; }, function (v) { return $acd06eaa94858840$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $acd06eaa94858840$export$b3890eb0ae9dca99; }, function (v) { return $acd06eaa94858840$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $acd06eaa94858840$export$502457920280e6be; }, function (v) { return $acd06eaa94858840$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $acd06eaa94858840$export$c78a37762a8d58e1; }, function (v) { return $acd06eaa94858840$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $acd06eaa94858840$export$dc54d992c10e8a18; }, function (v) { return $acd06eaa94858840$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $acd06eaa94858840$export$83d89fbfd8236492; }, function (v) { return $acd06eaa94858840$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $acd06eaa94858840$export$ae55be85d98224ed;
var $acd06eaa94858840$export$d39a5bbd09211389;
var $acd06eaa94858840$export$882461b6382ed46c;
var $acd06eaa94858840$export$466bfc07425424d5;
var $acd06eaa94858840$export$cd75ccfd720a3cd4;
var $acd06eaa94858840$export$fa8d919ba61d84db;
var $acd06eaa94858840$export$757ceba2d55c277e;
var $acd06eaa94858840$export$b3890eb0ae9dca99;
var $acd06eaa94858840$export$502457920280e6be;
var $acd06eaa94858840$export$c78a37762a8d58e1;
var $acd06eaa94858840$export$dc54d992c10e8a18;
var $acd06eaa94858840$export$83d89fbfd8236492;
'use strict';

var $9kKA1 = parcelRequire("9kKA1");

var $f435U = parcelRequire("f435U");
function $acd06eaa94858840$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $acd06eaa94858840$var$ca = new Set, $acd06eaa94858840$var$da = {};
function $acd06eaa94858840$var$ea(a, b) {
    $acd06eaa94858840$var$fa(a, b);
    $acd06eaa94858840$var$fa(a + "Capture", b);
}
function $acd06eaa94858840$var$fa(a, b) {
    $acd06eaa94858840$var$da[a] = b;
    for(a = 0; a < b.length; a++)$acd06eaa94858840$var$ca.add(b[a]);
}
var $acd06eaa94858840$var$ha = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $acd06eaa94858840$var$ia = Object.prototype.hasOwnProperty, $acd06eaa94858840$var$ja = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $acd06eaa94858840$var$ka = {}, $acd06eaa94858840$var$la = {};
function $acd06eaa94858840$var$ma(a) {
    if ($acd06eaa94858840$var$ia.call($acd06eaa94858840$var$la, a)) return !0;
    if ($acd06eaa94858840$var$ia.call($acd06eaa94858840$var$ka, a)) return !1;
    if ($acd06eaa94858840$var$ja.test(a)) return $acd06eaa94858840$var$la[a] = !0;
    $acd06eaa94858840$var$ka[a] = !0;
    return !1;
}
function $acd06eaa94858840$var$na(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $acd06eaa94858840$var$oa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $acd06eaa94858840$var$na(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $acd06eaa94858840$var$q(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $acd06eaa94858840$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $acd06eaa94858840$var$z[b] = new $acd06eaa94858840$var$q(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $acd06eaa94858840$var$pa = /[\-:]([a-z])/g;
function $acd06eaa94858840$var$qa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($acd06eaa94858840$var$pa, $acd06eaa94858840$var$qa);
    $acd06eaa94858840$var$z[b] = new $acd06eaa94858840$var$q(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($acd06eaa94858840$var$pa, $acd06eaa94858840$var$qa);
    $acd06eaa94858840$var$z[b] = new $acd06eaa94858840$var$q(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($acd06eaa94858840$var$pa, $acd06eaa94858840$var$qa);
    $acd06eaa94858840$var$z[b] = new $acd06eaa94858840$var$q(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$acd06eaa94858840$var$z.xlinkHref = new $acd06eaa94858840$var$q("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $acd06eaa94858840$var$z[a] = new $acd06eaa94858840$var$q(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $acd06eaa94858840$var$ra(a, b, c, d) {
    var e = $acd06eaa94858840$var$z.hasOwnProperty(b) ? $acd06eaa94858840$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $acd06eaa94858840$var$oa(b, c, e, d) && (c = null), d || null === e ? $acd06eaa94858840$var$ma(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $acd06eaa94858840$var$sa = $9kKA1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $acd06eaa94858840$var$ta = Symbol.for("react.element"), $acd06eaa94858840$var$ua = Symbol.for("react.portal"), $acd06eaa94858840$var$va = Symbol.for("react.fragment"), $acd06eaa94858840$var$wa = Symbol.for("react.strict_mode"), $acd06eaa94858840$var$xa = Symbol.for("react.profiler"), $acd06eaa94858840$var$ya = Symbol.for("react.provider"), $acd06eaa94858840$var$Aa = Symbol.for("react.context"), $acd06eaa94858840$var$Ba = Symbol.for("react.forward_ref"), $acd06eaa94858840$var$Ca = Symbol.for("react.suspense"), $acd06eaa94858840$var$Da = Symbol.for("react.suspense_list"), $acd06eaa94858840$var$Ea = Symbol.for("react.memo"), $acd06eaa94858840$var$Fa = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $acd06eaa94858840$var$Ga = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $acd06eaa94858840$var$Ha = Symbol.iterator;
function $acd06eaa94858840$var$Ia(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $acd06eaa94858840$var$Ha && a[$acd06eaa94858840$var$Ha] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $acd06eaa94858840$var$A = Object.assign, $acd06eaa94858840$var$Ja;
function $acd06eaa94858840$var$Ka(a) {
    if (void 0 === $acd06eaa94858840$var$Ja) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $acd06eaa94858840$var$Ja = b && b[1] || "";
    }
    return "\n" + $acd06eaa94858840$var$Ja + a;
}
var $acd06eaa94858840$var$La = !1;
function $acd06eaa94858840$var$Ma(a, b) {
    if (!a || $acd06eaa94858840$var$La) return "";
    $acd06eaa94858840$var$La = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $acd06eaa94858840$var$La = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $acd06eaa94858840$var$Ka(a) : "";
}
function $acd06eaa94858840$var$Na(a) {
    switch(a.tag){
        case 5:
            return $acd06eaa94858840$var$Ka(a.type);
        case 16:
            return $acd06eaa94858840$var$Ka("Lazy");
        case 13:
            return $acd06eaa94858840$var$Ka("Suspense");
        case 19:
            return $acd06eaa94858840$var$Ka("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $acd06eaa94858840$var$Ma(a.type, !1), a;
        case 11:
            return a = $acd06eaa94858840$var$Ma(a.type.render, !1), a;
        case 1:
            return a = $acd06eaa94858840$var$Ma(a.type, !0), a;
        default:
            return "";
    }
}
function $acd06eaa94858840$var$Oa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $acd06eaa94858840$var$va:
            return "Fragment";
        case $acd06eaa94858840$var$ua:
            return "Portal";
        case $acd06eaa94858840$var$xa:
            return "Profiler";
        case $acd06eaa94858840$var$wa:
            return "StrictMode";
        case $acd06eaa94858840$var$Ca:
            return "Suspense";
        case $acd06eaa94858840$var$Da:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $acd06eaa94858840$var$Aa:
            return (a.displayName || "Context") + ".Consumer";
        case $acd06eaa94858840$var$ya:
            return (a._context.displayName || "Context") + ".Provider";
        case $acd06eaa94858840$var$Ba:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $acd06eaa94858840$var$Ea:
            return b = a.displayName || null, null !== b ? b : $acd06eaa94858840$var$Oa(a.type) || "Memo";
        case $acd06eaa94858840$var$Fa:
            b = a._payload;
            a = a._init;
            try {
                return $acd06eaa94858840$var$Oa(a(b));
            } catch (c) {}
    }
    return null;
}
function $acd06eaa94858840$var$Pa(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $acd06eaa94858840$var$Oa(b);
        case 8:
            return b === $acd06eaa94858840$var$wa ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $acd06eaa94858840$var$Qa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $acd06eaa94858840$var$Ra(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $acd06eaa94858840$var$Sa(a) {
    var b = $acd06eaa94858840$var$Ra(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $acd06eaa94858840$var$Ta(a) {
    a._valueTracker || (a._valueTracker = $acd06eaa94858840$var$Sa(a));
}
function $acd06eaa94858840$var$Ua(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $acd06eaa94858840$var$Ra(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $acd06eaa94858840$var$Va(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $acd06eaa94858840$var$Wa(a, b) {
    var c = b.checked;
    return $acd06eaa94858840$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $acd06eaa94858840$var$Xa(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $acd06eaa94858840$var$Qa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $acd06eaa94858840$var$Ya(a, b) {
    b = b.checked;
    null != b && $acd06eaa94858840$var$ra(a, "checked", b, !1);
}
function $acd06eaa94858840$var$Za(a, b) {
    $acd06eaa94858840$var$Ya(a, b);
    var c = $acd06eaa94858840$var$Qa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $acd06eaa94858840$var$$a(a, b.type, c) : b.hasOwnProperty("defaultValue") && $acd06eaa94858840$var$$a(a, b.type, $acd06eaa94858840$var$Qa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $acd06eaa94858840$var$ab(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $acd06eaa94858840$var$$a(a, b, c) {
    if ("number" !== b || $acd06eaa94858840$var$Va(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $acd06eaa94858840$var$bb = Array.isArray;
function $acd06eaa94858840$var$cb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $acd06eaa94858840$var$Qa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $acd06eaa94858840$var$db(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($acd06eaa94858840$var$p(91));
    return $acd06eaa94858840$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $acd06eaa94858840$var$eb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($acd06eaa94858840$var$p(92));
            if ($acd06eaa94858840$var$bb(c)) {
                if (1 < c.length) throw Error($acd06eaa94858840$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $acd06eaa94858840$var$Qa(c)
    };
}
function $acd06eaa94858840$var$fb(a, b) {
    var c = $acd06eaa94858840$var$Qa(b.value), d = $acd06eaa94858840$var$Qa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $acd06eaa94858840$var$gb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $acd06eaa94858840$var$hb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $acd06eaa94858840$var$ib(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $acd06eaa94858840$var$hb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $acd06eaa94858840$var$jb, $acd06eaa94858840$var$kb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $acd06eaa94858840$var$jb = $acd06eaa94858840$var$jb || document.createElement("div");
        $acd06eaa94858840$var$jb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $acd06eaa94858840$var$jb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $acd06eaa94858840$var$lb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $acd06eaa94858840$var$mb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $acd06eaa94858840$var$nb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($acd06eaa94858840$var$mb).forEach(function(a) {
    $acd06eaa94858840$var$nb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $acd06eaa94858840$var$mb[b] = $acd06eaa94858840$var$mb[a];
    });
});
function $acd06eaa94858840$var$ob(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $acd06eaa94858840$var$mb.hasOwnProperty(a) && $acd06eaa94858840$var$mb[a] ? ("" + b).trim() : b + "px";
}
function $acd06eaa94858840$var$pb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $acd06eaa94858840$var$ob(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $acd06eaa94858840$var$qb = $acd06eaa94858840$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $acd06eaa94858840$var$rb(a, b) {
    if (b) {
        if ($acd06eaa94858840$var$qb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($acd06eaa94858840$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($acd06eaa94858840$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($acd06eaa94858840$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($acd06eaa94858840$var$p(62));
    }
}
function $acd06eaa94858840$var$sb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $acd06eaa94858840$var$tb = null;
function $acd06eaa94858840$var$ub(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $acd06eaa94858840$var$vb = null, $acd06eaa94858840$var$wb = null, $acd06eaa94858840$var$xb = null;
function $acd06eaa94858840$var$yb(a) {
    if (a = $acd06eaa94858840$var$zb(a)) {
        if ("function" !== typeof $acd06eaa94858840$var$vb) throw Error($acd06eaa94858840$var$p(280));
        var b = a.stateNode;
        b && (b = $acd06eaa94858840$var$Ab(b), $acd06eaa94858840$var$vb(a.stateNode, a.type, b));
    }
}
function $acd06eaa94858840$var$Bb(a) {
    $acd06eaa94858840$var$wb ? $acd06eaa94858840$var$xb ? $acd06eaa94858840$var$xb.push(a) : $acd06eaa94858840$var$xb = [
        a
    ] : $acd06eaa94858840$var$wb = a;
}
function $acd06eaa94858840$var$Cb() {
    if ($acd06eaa94858840$var$wb) {
        var a = $acd06eaa94858840$var$wb, b = $acd06eaa94858840$var$xb;
        $acd06eaa94858840$var$xb = $acd06eaa94858840$var$wb = null;
        $acd06eaa94858840$var$yb(a);
        if (b) for(a = 0; a < b.length; a++)$acd06eaa94858840$var$yb(b[a]);
    }
}
function $acd06eaa94858840$var$Db(a, b) {
    return a(b);
}
function $acd06eaa94858840$var$Eb() {}
var $acd06eaa94858840$var$Fb = !1;
function $acd06eaa94858840$var$Gb(a, b, c) {
    if ($acd06eaa94858840$var$Fb) return a(b, c);
    $acd06eaa94858840$var$Fb = !0;
    try {
        return $acd06eaa94858840$var$Db(a, b, c);
    } finally{
        if ($acd06eaa94858840$var$Fb = !1, null !== $acd06eaa94858840$var$wb || null !== $acd06eaa94858840$var$xb) $acd06eaa94858840$var$Eb(), $acd06eaa94858840$var$Cb();
    }
}
function $acd06eaa94858840$var$Hb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $acd06eaa94858840$var$Ab(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($acd06eaa94858840$var$p(231, b, typeof c));
    return c;
}
var $acd06eaa94858840$var$Ib = !1;
if ($acd06eaa94858840$var$ha) try {
    var $acd06eaa94858840$var$Jb = {};
    Object.defineProperty($acd06eaa94858840$var$Jb, "passive", {
        get: function() {
            $acd06eaa94858840$var$Ib = !0;
        }
    });
    window.addEventListener("test", $acd06eaa94858840$var$Jb, $acd06eaa94858840$var$Jb);
    window.removeEventListener("test", $acd06eaa94858840$var$Jb, $acd06eaa94858840$var$Jb);
} catch (a) {
    $acd06eaa94858840$var$Ib = !1;
}
function $acd06eaa94858840$var$Kb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $acd06eaa94858840$var$Lb = !1, $acd06eaa94858840$var$Mb = null, $acd06eaa94858840$var$Nb = !1, $acd06eaa94858840$var$Ob = null, $acd06eaa94858840$var$Pb = {
    onError: function(a) {
        $acd06eaa94858840$var$Lb = !0;
        $acd06eaa94858840$var$Mb = a;
    }
};
function $acd06eaa94858840$var$Qb(a, b, c, d, e, f, g, h, k) {
    $acd06eaa94858840$var$Lb = !1;
    $acd06eaa94858840$var$Mb = null;
    $acd06eaa94858840$var$Kb.apply($acd06eaa94858840$var$Pb, arguments);
}
function $acd06eaa94858840$var$Rb(a, b, c, d, e, f, g, h, k) {
    $acd06eaa94858840$var$Qb.apply(this, arguments);
    if ($acd06eaa94858840$var$Lb) {
        if ($acd06eaa94858840$var$Lb) {
            var l = $acd06eaa94858840$var$Mb;
            $acd06eaa94858840$var$Lb = !1;
            $acd06eaa94858840$var$Mb = null;
        } else throw Error($acd06eaa94858840$var$p(198));
        $acd06eaa94858840$var$Nb || ($acd06eaa94858840$var$Nb = !0, $acd06eaa94858840$var$Ob = l);
    }
}
function $acd06eaa94858840$var$Sb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $acd06eaa94858840$var$Tb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $acd06eaa94858840$var$Ub(a) {
    if ($acd06eaa94858840$var$Sb(a) !== a) throw Error($acd06eaa94858840$var$p(188));
}
function $acd06eaa94858840$var$Vb(a) {
    var b = a.alternate;
    if (!b) {
        b = $acd06eaa94858840$var$Sb(a);
        if (null === b) throw Error($acd06eaa94858840$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $acd06eaa94858840$var$Ub(e), a;
                if (f === d) return $acd06eaa94858840$var$Ub(e), b;
                f = f.sibling;
            }
            throw Error($acd06eaa94858840$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($acd06eaa94858840$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($acd06eaa94858840$var$p(190));
    }
    if (3 !== c.tag) throw Error($acd06eaa94858840$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $acd06eaa94858840$var$Wb(a) {
    a = $acd06eaa94858840$var$Vb(a);
    return null !== a ? $acd06eaa94858840$var$Xb(a) : null;
}
function $acd06eaa94858840$var$Xb(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $acd06eaa94858840$var$Xb(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $acd06eaa94858840$var$Yb = $f435U.unstable_scheduleCallback, $acd06eaa94858840$var$Zb = $f435U.unstable_cancelCallback, $acd06eaa94858840$var$$b = $f435U.unstable_shouldYield, $acd06eaa94858840$var$ac = $f435U.unstable_requestPaint, $acd06eaa94858840$var$D = $f435U.unstable_now, $acd06eaa94858840$var$bc = $f435U.unstable_getCurrentPriorityLevel, $acd06eaa94858840$var$cc = $f435U.unstable_ImmediatePriority, $acd06eaa94858840$var$dc = $f435U.unstable_UserBlockingPriority, $acd06eaa94858840$var$ec = $f435U.unstable_NormalPriority, $acd06eaa94858840$var$fc = $f435U.unstable_LowPriority, $acd06eaa94858840$var$gc = $f435U.unstable_IdlePriority, $acd06eaa94858840$var$hc = null, $acd06eaa94858840$var$ic = null;
function $acd06eaa94858840$var$jc(a) {
    if ($acd06eaa94858840$var$ic && "function" === typeof $acd06eaa94858840$var$ic.onCommitFiberRoot) try {
        $acd06eaa94858840$var$ic.onCommitFiberRoot($acd06eaa94858840$var$hc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $acd06eaa94858840$var$lc = Math.clz32 ? Math.clz32 : $acd06eaa94858840$var$kc, $acd06eaa94858840$var$mc = Math.log, $acd06eaa94858840$var$nc = Math.LN2;
function $acd06eaa94858840$var$kc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($acd06eaa94858840$var$mc(a) / $acd06eaa94858840$var$nc | 0) | 0;
}
var $acd06eaa94858840$var$oc = 64, $acd06eaa94858840$var$pc = 4194304;
function $acd06eaa94858840$var$qc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $acd06eaa94858840$var$rc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $acd06eaa94858840$var$qc(h) : (f &= g, 0 !== f && (d = $acd06eaa94858840$var$qc(f)));
    } else g = c & ~e, 0 !== g ? d = $acd06eaa94858840$var$qc(g) : 0 !== f && (d = $acd06eaa94858840$var$qc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $acd06eaa94858840$var$lc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $acd06eaa94858840$var$sc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $acd06eaa94858840$var$tc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $acd06eaa94858840$var$lc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $acd06eaa94858840$var$sc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $acd06eaa94858840$var$uc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $acd06eaa94858840$var$vc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $acd06eaa94858840$var$wc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $acd06eaa94858840$var$lc(b);
    a[b] = c;
}
function $acd06eaa94858840$var$xc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $acd06eaa94858840$var$lc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $acd06eaa94858840$var$yc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $acd06eaa94858840$var$lc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $acd06eaa94858840$var$E = 0;
function $acd06eaa94858840$var$zc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $acd06eaa94858840$var$Ac, $acd06eaa94858840$var$Bc, $acd06eaa94858840$var$Cc, $acd06eaa94858840$var$Dc, $acd06eaa94858840$var$Ec, $acd06eaa94858840$var$Fc = !1, $acd06eaa94858840$var$Gc = [], $acd06eaa94858840$var$Hc = null, $acd06eaa94858840$var$Ic = null, $acd06eaa94858840$var$Jc = null, $acd06eaa94858840$var$Kc = new Map, $acd06eaa94858840$var$Lc = new Map, $acd06eaa94858840$var$Mc = [], $acd06eaa94858840$var$Nc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $acd06eaa94858840$var$Oc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $acd06eaa94858840$var$Hc = null;
            break;
        case "dragenter":
        case "dragleave":
            $acd06eaa94858840$var$Ic = null;
            break;
        case "mouseover":
        case "mouseout":
            $acd06eaa94858840$var$Jc = null;
            break;
        case "pointerover":
        case "pointerout":
            $acd06eaa94858840$var$Kc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $acd06eaa94858840$var$Lc.delete(b.pointerId);
    }
}
function $acd06eaa94858840$var$Pc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $acd06eaa94858840$var$zb(b), null !== b && $acd06eaa94858840$var$Bc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $acd06eaa94858840$var$Qc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $acd06eaa94858840$var$Hc = $acd06eaa94858840$var$Pc($acd06eaa94858840$var$Hc, a, b, c, d, e), !0;
        case "dragenter":
            return $acd06eaa94858840$var$Ic = $acd06eaa94858840$var$Pc($acd06eaa94858840$var$Ic, a, b, c, d, e), !0;
        case "mouseover":
            return $acd06eaa94858840$var$Jc = $acd06eaa94858840$var$Pc($acd06eaa94858840$var$Jc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $acd06eaa94858840$var$Kc.set(f, $acd06eaa94858840$var$Pc($acd06eaa94858840$var$Kc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $acd06eaa94858840$var$Lc.set(f, $acd06eaa94858840$var$Pc($acd06eaa94858840$var$Lc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $acd06eaa94858840$var$Rc(a) {
    var b = $acd06eaa94858840$var$Sc(a.target);
    if (null !== b) {
        var c = $acd06eaa94858840$var$Sb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $acd06eaa94858840$var$Tb(c), null !== b) {
                    a.blockedOn = b;
                    $acd06eaa94858840$var$Ec(a.priority, function() {
                        $acd06eaa94858840$var$Cc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $acd06eaa94858840$var$Tc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $acd06eaa94858840$var$Uc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $acd06eaa94858840$var$tb = d;
            c.target.dispatchEvent(d);
            $acd06eaa94858840$var$tb = null;
        } else return b = $acd06eaa94858840$var$zb(c), null !== b && $acd06eaa94858840$var$Bc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $acd06eaa94858840$var$Vc(a, b, c) {
    $acd06eaa94858840$var$Tc(a) && c.delete(b);
}
function $acd06eaa94858840$var$Wc() {
    $acd06eaa94858840$var$Fc = !1;
    null !== $acd06eaa94858840$var$Hc && $acd06eaa94858840$var$Tc($acd06eaa94858840$var$Hc) && ($acd06eaa94858840$var$Hc = null);
    null !== $acd06eaa94858840$var$Ic && $acd06eaa94858840$var$Tc($acd06eaa94858840$var$Ic) && ($acd06eaa94858840$var$Ic = null);
    null !== $acd06eaa94858840$var$Jc && $acd06eaa94858840$var$Tc($acd06eaa94858840$var$Jc) && ($acd06eaa94858840$var$Jc = null);
    $acd06eaa94858840$var$Kc.forEach($acd06eaa94858840$var$Vc);
    $acd06eaa94858840$var$Lc.forEach($acd06eaa94858840$var$Vc);
}
function $acd06eaa94858840$var$Xc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $acd06eaa94858840$var$Fc || ($acd06eaa94858840$var$Fc = !0, $f435U.unstable_scheduleCallback($f435U.unstable_NormalPriority, $acd06eaa94858840$var$Wc)));
}
function $acd06eaa94858840$var$Yc(a) {
    function b(b) {
        return $acd06eaa94858840$var$Xc(b, a);
    }
    if (0 < $acd06eaa94858840$var$Gc.length) {
        $acd06eaa94858840$var$Xc($acd06eaa94858840$var$Gc[0], a);
        for(var c = 1; c < $acd06eaa94858840$var$Gc.length; c++){
            var d = $acd06eaa94858840$var$Gc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $acd06eaa94858840$var$Hc && $acd06eaa94858840$var$Xc($acd06eaa94858840$var$Hc, a);
    null !== $acd06eaa94858840$var$Ic && $acd06eaa94858840$var$Xc($acd06eaa94858840$var$Ic, a);
    null !== $acd06eaa94858840$var$Jc && $acd06eaa94858840$var$Xc($acd06eaa94858840$var$Jc, a);
    $acd06eaa94858840$var$Kc.forEach(b);
    $acd06eaa94858840$var$Lc.forEach(b);
    for(c = 0; c < $acd06eaa94858840$var$Mc.length; c++)d = $acd06eaa94858840$var$Mc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $acd06eaa94858840$var$Mc.length && (c = $acd06eaa94858840$var$Mc[0], null === c.blockedOn);)$acd06eaa94858840$var$Rc(c), null === c.blockedOn && $acd06eaa94858840$var$Mc.shift();
}
var $acd06eaa94858840$var$Zc = $acd06eaa94858840$var$sa.ReactCurrentBatchConfig;
function $acd06eaa94858840$var$$c(a, b, c, d) {
    var e = $acd06eaa94858840$var$E, f = $acd06eaa94858840$var$Zc.transition;
    $acd06eaa94858840$var$Zc.transition = null;
    try {
        $acd06eaa94858840$var$E = 1, $acd06eaa94858840$var$ad(a, b, c, d);
    } finally{
        $acd06eaa94858840$var$E = e, $acd06eaa94858840$var$Zc.transition = f;
    }
}
function $acd06eaa94858840$var$bd(a, b, c, d) {
    var e = $acd06eaa94858840$var$E, f = $acd06eaa94858840$var$Zc.transition;
    $acd06eaa94858840$var$Zc.transition = null;
    try {
        $acd06eaa94858840$var$E = 4, $acd06eaa94858840$var$ad(a, b, c, d);
    } finally{
        $acd06eaa94858840$var$E = e, $acd06eaa94858840$var$Zc.transition = f;
    }
}
function $acd06eaa94858840$var$ad(a, b, c, d) {
    var e = $acd06eaa94858840$var$Uc(a, b, c, d);
    if (null === e) $acd06eaa94858840$var$cd(a, b, d, $acd06eaa94858840$var$dd, c), $acd06eaa94858840$var$Oc(a, d);
    else if ($acd06eaa94858840$var$Qc(e, a, b, c, d)) d.stopPropagation();
    else if ($acd06eaa94858840$var$Oc(a, d), b & 4 && -1 < $acd06eaa94858840$var$Nc.indexOf(a)) {
        for(; null !== e;){
            var f = $acd06eaa94858840$var$zb(e);
            null !== f && $acd06eaa94858840$var$Ac(f);
            f = $acd06eaa94858840$var$Uc(a, b, c, d);
            null === f && $acd06eaa94858840$var$cd(a, b, d, $acd06eaa94858840$var$dd, c);
            if (f === e) break;
            e = f;
        }
        null !== e && d.stopPropagation();
    } else $acd06eaa94858840$var$cd(a, b, d, null, c);
}
var $acd06eaa94858840$var$dd = null;
function $acd06eaa94858840$var$Uc(a, b, c, d) {
    $acd06eaa94858840$var$dd = null;
    a = $acd06eaa94858840$var$ub(d);
    a = $acd06eaa94858840$var$Sc(a);
    if (null !== a) {
        if (b = $acd06eaa94858840$var$Sb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $acd06eaa94858840$var$Tb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $acd06eaa94858840$var$dd = a;
    return null;
}
function $acd06eaa94858840$var$ed(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($acd06eaa94858840$var$bc()){
                case $acd06eaa94858840$var$cc:
                    return 1;
                case $acd06eaa94858840$var$dc:
                    return 4;
                case $acd06eaa94858840$var$ec:
                case $acd06eaa94858840$var$fc:
                    return 16;
                case $acd06eaa94858840$var$gc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $acd06eaa94858840$var$fd = null, $acd06eaa94858840$var$gd = null, $acd06eaa94858840$var$hd = null;
function $acd06eaa94858840$var$id() {
    if ($acd06eaa94858840$var$hd) return $acd06eaa94858840$var$hd;
    var a, b = $acd06eaa94858840$var$gd, c = b.length, d, e = "value" in $acd06eaa94858840$var$fd ? $acd06eaa94858840$var$fd.value : $acd06eaa94858840$var$fd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $acd06eaa94858840$var$hd = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $acd06eaa94858840$var$jd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $acd06eaa94858840$var$kd() {
    return !0;
}
function $acd06eaa94858840$var$ld() {
    return !1;
}
function $acd06eaa94858840$var$md(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $acd06eaa94858840$var$kd : $acd06eaa94858840$var$ld;
        this.isPropagationStopped = $acd06eaa94858840$var$ld;
        return this;
    }
    $acd06eaa94858840$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $acd06eaa94858840$var$kd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $acd06eaa94858840$var$kd);
        },
        persist: function() {},
        isPersistent: $acd06eaa94858840$var$kd
    });
    return b;
}
var $acd06eaa94858840$var$nd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $acd06eaa94858840$var$od = $acd06eaa94858840$var$md($acd06eaa94858840$var$nd), $acd06eaa94858840$var$pd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$nd, {
    view: 0,
    detail: 0
}), $acd06eaa94858840$var$qd = $acd06eaa94858840$var$md($acd06eaa94858840$var$pd), $acd06eaa94858840$var$rd, $acd06eaa94858840$var$sd, $acd06eaa94858840$var$td, $acd06eaa94858840$var$vd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$pd, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $acd06eaa94858840$var$ud,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $acd06eaa94858840$var$td && ($acd06eaa94858840$var$td && "mousemove" === a.type ? ($acd06eaa94858840$var$rd = a.screenX - $acd06eaa94858840$var$td.screenX, $acd06eaa94858840$var$sd = a.screenY - $acd06eaa94858840$var$td.screenY) : $acd06eaa94858840$var$sd = $acd06eaa94858840$var$rd = 0, $acd06eaa94858840$var$td = a);
        return $acd06eaa94858840$var$rd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $acd06eaa94858840$var$sd;
    }
}), $acd06eaa94858840$var$wd = $acd06eaa94858840$var$md($acd06eaa94858840$var$vd), $acd06eaa94858840$var$xd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$vd, {
    dataTransfer: 0
}), $acd06eaa94858840$var$yd = $acd06eaa94858840$var$md($acd06eaa94858840$var$xd), $acd06eaa94858840$var$zd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$pd, {
    relatedTarget: 0
}), $acd06eaa94858840$var$Ad = $acd06eaa94858840$var$md($acd06eaa94858840$var$zd), $acd06eaa94858840$var$Bd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$nd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $acd06eaa94858840$var$Cd = $acd06eaa94858840$var$md($acd06eaa94858840$var$Bd), $acd06eaa94858840$var$Dd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$nd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $acd06eaa94858840$var$Ed = $acd06eaa94858840$var$md($acd06eaa94858840$var$Dd), $acd06eaa94858840$var$Fd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$nd, {
    data: 0
}), $acd06eaa94858840$var$Gd = $acd06eaa94858840$var$md($acd06eaa94858840$var$Fd), $acd06eaa94858840$var$Hd = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $acd06eaa94858840$var$Id = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $acd06eaa94858840$var$Jd = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $acd06eaa94858840$var$Kd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $acd06eaa94858840$var$Jd[a]) ? !!b[a] : !1;
}
function $acd06eaa94858840$var$ud() {
    return $acd06eaa94858840$var$Kd;
}
var $acd06eaa94858840$var$Ld = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$pd, {
    key: function(a) {
        if (a.key) {
            var b = $acd06eaa94858840$var$Hd[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $acd06eaa94858840$var$jd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $acd06eaa94858840$var$Id[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $acd06eaa94858840$var$ud,
    charCode: function(a) {
        return "keypress" === a.type ? $acd06eaa94858840$var$jd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $acd06eaa94858840$var$jd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $acd06eaa94858840$var$Md = $acd06eaa94858840$var$md($acd06eaa94858840$var$Ld), $acd06eaa94858840$var$Nd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$vd, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $acd06eaa94858840$var$Od = $acd06eaa94858840$var$md($acd06eaa94858840$var$Nd), $acd06eaa94858840$var$Pd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$pd, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $acd06eaa94858840$var$ud
}), $acd06eaa94858840$var$Qd = $acd06eaa94858840$var$md($acd06eaa94858840$var$Pd), $acd06eaa94858840$var$Rd = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$nd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $acd06eaa94858840$var$Sd = $acd06eaa94858840$var$md($acd06eaa94858840$var$Rd), $acd06eaa94858840$var$Td = $acd06eaa94858840$var$A({}, $acd06eaa94858840$var$vd, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $acd06eaa94858840$var$Ud = $acd06eaa94858840$var$md($acd06eaa94858840$var$Td), $acd06eaa94858840$var$Vd = [
    9,
    13,
    27,
    32
], $acd06eaa94858840$var$Wd = $acd06eaa94858840$var$ha && "CompositionEvent" in window, $acd06eaa94858840$var$Xd = null;
$acd06eaa94858840$var$ha && "documentMode" in document && ($acd06eaa94858840$var$Xd = document.documentMode);
var $acd06eaa94858840$var$Yd = $acd06eaa94858840$var$ha && "TextEvent" in window && !$acd06eaa94858840$var$Xd, $acd06eaa94858840$var$Zd = $acd06eaa94858840$var$ha && (!$acd06eaa94858840$var$Wd || $acd06eaa94858840$var$Xd && 8 < $acd06eaa94858840$var$Xd && 11 >= $acd06eaa94858840$var$Xd), $acd06eaa94858840$var$$d = String.fromCharCode(32), $acd06eaa94858840$var$ae = !1;
function $acd06eaa94858840$var$be(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $acd06eaa94858840$var$Vd.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $acd06eaa94858840$var$ce(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $acd06eaa94858840$var$de = !1;
function $acd06eaa94858840$var$ee(a, b) {
    switch(a){
        case "compositionend":
            return $acd06eaa94858840$var$ce(b);
        case "keypress":
            if (32 !== b.which) return null;
            $acd06eaa94858840$var$ae = !0;
            return $acd06eaa94858840$var$$d;
        case "textInput":
            return a = b.data, a === $acd06eaa94858840$var$$d && $acd06eaa94858840$var$ae ? null : a;
        default:
            return null;
    }
}
function $acd06eaa94858840$var$fe(a, b) {
    if ($acd06eaa94858840$var$de) return "compositionend" === a || !$acd06eaa94858840$var$Wd && $acd06eaa94858840$var$be(a, b) ? (a = $acd06eaa94858840$var$id(), $acd06eaa94858840$var$hd = $acd06eaa94858840$var$gd = $acd06eaa94858840$var$fd = null, $acd06eaa94858840$var$de = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $acd06eaa94858840$var$Zd && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $acd06eaa94858840$var$ge = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $acd06eaa94858840$var$he(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$acd06eaa94858840$var$ge[a.type] : "textarea" === b ? !0 : !1;
}
function $acd06eaa94858840$var$ie(a, b, c, d) {
    $acd06eaa94858840$var$Bb(d);
    b = $acd06eaa94858840$var$je(b, "onChange");
    0 < b.length && (c = new $acd06eaa94858840$var$od("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $acd06eaa94858840$var$ke = null, $acd06eaa94858840$var$le = null;
function $acd06eaa94858840$var$me(a) {
    $acd06eaa94858840$var$ne(a, 0);
}
function $acd06eaa94858840$var$oe(a) {
    var b = $acd06eaa94858840$var$pe(a);
    if ($acd06eaa94858840$var$Ua(b)) return a;
}
function $acd06eaa94858840$var$qe(a, b) {
    if ("change" === a) return b;
}
var $acd06eaa94858840$var$re = !1;
if ($acd06eaa94858840$var$ha) {
    var $acd06eaa94858840$var$se;
    if ($acd06eaa94858840$var$ha) {
        var $acd06eaa94858840$var$te = "oninput" in document;
        if (!$acd06eaa94858840$var$te) {
            var $acd06eaa94858840$var$ue = document.createElement("div");
            $acd06eaa94858840$var$ue.setAttribute("oninput", "return;");
            $acd06eaa94858840$var$te = "function" === typeof $acd06eaa94858840$var$ue.oninput;
        }
        $acd06eaa94858840$var$se = $acd06eaa94858840$var$te;
    } else $acd06eaa94858840$var$se = !1;
    $acd06eaa94858840$var$re = $acd06eaa94858840$var$se && (!document.documentMode || 9 < document.documentMode);
}
function $acd06eaa94858840$var$ve() {
    $acd06eaa94858840$var$ke && ($acd06eaa94858840$var$ke.detachEvent("onpropertychange", $acd06eaa94858840$var$we), $acd06eaa94858840$var$le = $acd06eaa94858840$var$ke = null);
}
function $acd06eaa94858840$var$we(a) {
    if ("value" === a.propertyName && $acd06eaa94858840$var$oe($acd06eaa94858840$var$le)) {
        var b = [];
        $acd06eaa94858840$var$ie(b, $acd06eaa94858840$var$le, a, $acd06eaa94858840$var$ub(a));
        $acd06eaa94858840$var$Gb($acd06eaa94858840$var$me, b);
    }
}
function $acd06eaa94858840$var$xe(a, b, c) {
    "focusin" === a ? ($acd06eaa94858840$var$ve(), $acd06eaa94858840$var$ke = b, $acd06eaa94858840$var$le = c, $acd06eaa94858840$var$ke.attachEvent("onpropertychange", $acd06eaa94858840$var$we)) : "focusout" === a && $acd06eaa94858840$var$ve();
}
function $acd06eaa94858840$var$ye(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $acd06eaa94858840$var$oe($acd06eaa94858840$var$le);
}
function $acd06eaa94858840$var$ze(a, b) {
    if ("click" === a) return $acd06eaa94858840$var$oe(b);
}
function $acd06eaa94858840$var$Ae(a, b) {
    if ("input" === a || "change" === a) return $acd06eaa94858840$var$oe(b);
}
function $acd06eaa94858840$var$Be(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $acd06eaa94858840$var$Ce = "function" === typeof Object.is ? Object.is : $acd06eaa94858840$var$Be;
function $acd06eaa94858840$var$De(a, b) {
    if ($acd06eaa94858840$var$Ce(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$acd06eaa94858840$var$ia.call(b, e) || !$acd06eaa94858840$var$Ce(a[e], b[e])) return !1;
    }
    return !0;
}
function $acd06eaa94858840$var$Ee(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $acd06eaa94858840$var$Fe(a, b) {
    var c = $acd06eaa94858840$var$Ee(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $acd06eaa94858840$var$Ee(c);
    }
}
function $acd06eaa94858840$var$Ge(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $acd06eaa94858840$var$Ge(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $acd06eaa94858840$var$He() {
    for(var a = window, b = $acd06eaa94858840$var$Va(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $acd06eaa94858840$var$Va(a.document);
    }
    return b;
}
function $acd06eaa94858840$var$Ie(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $acd06eaa94858840$var$Je(a) {
    var b = $acd06eaa94858840$var$He(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $acd06eaa94858840$var$Ge(c.ownerDocument.documentElement, c)) {
        if (null !== d && $acd06eaa94858840$var$Ie(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $acd06eaa94858840$var$Fe(c, f);
                var g = $acd06eaa94858840$var$Fe(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $acd06eaa94858840$var$Ke = $acd06eaa94858840$var$ha && "documentMode" in document && 11 >= document.documentMode, $acd06eaa94858840$var$Le = null, $acd06eaa94858840$var$Me = null, $acd06eaa94858840$var$Ne = null, $acd06eaa94858840$var$Oe = !1;
function $acd06eaa94858840$var$Pe(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $acd06eaa94858840$var$Oe || null == $acd06eaa94858840$var$Le || $acd06eaa94858840$var$Le !== $acd06eaa94858840$var$Va(d) || (d = $acd06eaa94858840$var$Le, "selectionStart" in d && $acd06eaa94858840$var$Ie(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $acd06eaa94858840$var$Ne && $acd06eaa94858840$var$De($acd06eaa94858840$var$Ne, d) || ($acd06eaa94858840$var$Ne = d, d = $acd06eaa94858840$var$je($acd06eaa94858840$var$Me, "onSelect"), 0 < d.length && (b = new $acd06eaa94858840$var$od("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $acd06eaa94858840$var$Le)));
}
function $acd06eaa94858840$var$Qe(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $acd06eaa94858840$var$Re = {
    animationend: $acd06eaa94858840$var$Qe("Animation", "AnimationEnd"),
    animationiteration: $acd06eaa94858840$var$Qe("Animation", "AnimationIteration"),
    animationstart: $acd06eaa94858840$var$Qe("Animation", "AnimationStart"),
    transitionend: $acd06eaa94858840$var$Qe("Transition", "TransitionEnd")
}, $acd06eaa94858840$var$Se = {}, $acd06eaa94858840$var$Te = {};
$acd06eaa94858840$var$ha && ($acd06eaa94858840$var$Te = document.createElement("div").style, "AnimationEvent" in window || (delete $acd06eaa94858840$var$Re.animationend.animation, delete $acd06eaa94858840$var$Re.animationiteration.animation, delete $acd06eaa94858840$var$Re.animationstart.animation), "TransitionEvent" in window || delete $acd06eaa94858840$var$Re.transitionend.transition);
function $acd06eaa94858840$var$Ue(a) {
    if ($acd06eaa94858840$var$Se[a]) return $acd06eaa94858840$var$Se[a];
    if (!$acd06eaa94858840$var$Re[a]) return a;
    var b = $acd06eaa94858840$var$Re[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $acd06eaa94858840$var$Te) return $acd06eaa94858840$var$Se[a] = b[c];
    return a;
}
var $acd06eaa94858840$var$Ve = $acd06eaa94858840$var$Ue("animationend"), $acd06eaa94858840$var$We = $acd06eaa94858840$var$Ue("animationiteration"), $acd06eaa94858840$var$Xe = $acd06eaa94858840$var$Ue("animationstart"), $acd06eaa94858840$var$Ye = $acd06eaa94858840$var$Ue("transitionend"), $acd06eaa94858840$var$Ze = new Map, $acd06eaa94858840$var$$e = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $acd06eaa94858840$var$af(a, b) {
    $acd06eaa94858840$var$Ze.set(a, b);
    $acd06eaa94858840$var$ea(b, [
        a
    ]);
}
for(var $acd06eaa94858840$var$bf = 0; $acd06eaa94858840$var$bf < $acd06eaa94858840$var$$e.length; $acd06eaa94858840$var$bf++){
    var $acd06eaa94858840$var$cf = $acd06eaa94858840$var$$e[$acd06eaa94858840$var$bf], $acd06eaa94858840$var$df = $acd06eaa94858840$var$cf.toLowerCase(), $acd06eaa94858840$var$ef = $acd06eaa94858840$var$cf[0].toUpperCase() + $acd06eaa94858840$var$cf.slice(1);
    $acd06eaa94858840$var$af($acd06eaa94858840$var$df, "on" + $acd06eaa94858840$var$ef);
}
$acd06eaa94858840$var$af($acd06eaa94858840$var$Ve, "onAnimationEnd");
$acd06eaa94858840$var$af($acd06eaa94858840$var$We, "onAnimationIteration");
$acd06eaa94858840$var$af($acd06eaa94858840$var$Xe, "onAnimationStart");
$acd06eaa94858840$var$af("dblclick", "onDoubleClick");
$acd06eaa94858840$var$af("focusin", "onFocus");
$acd06eaa94858840$var$af("focusout", "onBlur");
$acd06eaa94858840$var$af($acd06eaa94858840$var$Ye, "onTransitionEnd");
$acd06eaa94858840$var$fa("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$acd06eaa94858840$var$fa("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$acd06eaa94858840$var$fa("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$acd06eaa94858840$var$fa("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$acd06eaa94858840$var$ea("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$acd06eaa94858840$var$ea("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$acd06eaa94858840$var$ea("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$acd06eaa94858840$var$ea("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$acd06eaa94858840$var$ea("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$acd06eaa94858840$var$ea("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $acd06eaa94858840$var$ff = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $acd06eaa94858840$var$gf = new Set("cancel close invalid load scroll toggle".split(" ").concat($acd06eaa94858840$var$ff));
function $acd06eaa94858840$var$hf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $acd06eaa94858840$var$Rb(d, b, void 0, a);
    a.currentTarget = null;
}
function $acd06eaa94858840$var$ne(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $acd06eaa94858840$var$hf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $acd06eaa94858840$var$hf(e, h, l);
                f = k;
            }
        }
    }
    if ($acd06eaa94858840$var$Nb) throw a = $acd06eaa94858840$var$Ob, $acd06eaa94858840$var$Nb = !1, $acd06eaa94858840$var$Ob = null, a;
}
function $acd06eaa94858840$var$F(a, b) {
    var c = b[$acd06eaa94858840$var$jf];
    void 0 === c && (c = b[$acd06eaa94858840$var$jf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($acd06eaa94858840$var$kf(b, a, 2, !1), c.add(d));
}
function $acd06eaa94858840$var$lf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $acd06eaa94858840$var$kf(c, a, d, b);
}
var $acd06eaa94858840$var$mf = "_reactListening" + Math.random().toString(36).slice(2);
function $acd06eaa94858840$var$nf(a) {
    if (!a[$acd06eaa94858840$var$mf]) {
        a[$acd06eaa94858840$var$mf] = !0;
        $acd06eaa94858840$var$ca.forEach(function(b) {
            "selectionchange" !== b && ($acd06eaa94858840$var$gf.has(b) || $acd06eaa94858840$var$lf(b, !1, a), $acd06eaa94858840$var$lf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$acd06eaa94858840$var$mf] || (b[$acd06eaa94858840$var$mf] = !0, $acd06eaa94858840$var$lf("selectionchange", !1, b));
    }
}
function $acd06eaa94858840$var$kf(a, b, c, d) {
    switch($acd06eaa94858840$var$ed(b)){
        case 1:
            var e = $acd06eaa94858840$var$$c;
            break;
        case 4:
            e = $acd06eaa94858840$var$bd;
            break;
        default:
            e = $acd06eaa94858840$var$ad;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$acd06eaa94858840$var$Ib || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $acd06eaa94858840$var$cd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $acd06eaa94858840$var$Sc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $acd06eaa94858840$var$Gb(function() {
        var d = f, e = $acd06eaa94858840$var$ub(c), g = [];
        a: {
            var h = $acd06eaa94858840$var$Ze.get(a);
            if (void 0 !== h) {
                var k = $acd06eaa94858840$var$od, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $acd06eaa94858840$var$jd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $acd06eaa94858840$var$Md;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $acd06eaa94858840$var$Ad;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $acd06eaa94858840$var$Ad;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $acd06eaa94858840$var$Ad;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $acd06eaa94858840$var$wd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $acd06eaa94858840$var$yd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $acd06eaa94858840$var$Qd;
                        break;
                    case $acd06eaa94858840$var$Ve:
                    case $acd06eaa94858840$var$We:
                    case $acd06eaa94858840$var$Xe:
                        k = $acd06eaa94858840$var$Cd;
                        break;
                    case $acd06eaa94858840$var$Ye:
                        k = $acd06eaa94858840$var$Sd;
                        break;
                    case "scroll":
                        k = $acd06eaa94858840$var$qd;
                        break;
                    case "wheel":
                        k = $acd06eaa94858840$var$Ud;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $acd06eaa94858840$var$Ed;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $acd06eaa94858840$var$Od;
                }
                var v = 0 !== (b & 4), C = !v && "scroll" === a, t = v ? null !== h ? h + "Capture" : null : h;
                v = [];
                for(var r = d, x; null !== r;){
                    x = r;
                    var B = x.stateNode;
                    5 === x.tag && null !== B && (x = B, null !== t && (B = $acd06eaa94858840$var$Hb(r, t), null != B && v.push($acd06eaa94858840$var$of(r, B, x))));
                    if (C) break;
                    r = r.return;
                }
                0 < v.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: v
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $acd06eaa94858840$var$tb && (n = c.relatedTarget || c.fromElement) && ($acd06eaa94858840$var$Sc(n) || n[$acd06eaa94858840$var$pf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $acd06eaa94858840$var$Sc(n) : null, null !== n && (C = $acd06eaa94858840$var$Sb(n), n !== C || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        v = $acd06eaa94858840$var$wd;
                        B = "onMouseLeave";
                        t = "onMouseEnter";
                        r = "mouse";
                        if ("pointerout" === a || "pointerover" === a) v = $acd06eaa94858840$var$Od, B = "onPointerLeave", t = "onPointerEnter", r = "pointer";
                        C = null == k ? h : $acd06eaa94858840$var$pe(k);
                        x = null == n ? h : $acd06eaa94858840$var$pe(n);
                        h = new v(B, r + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = x;
                        B = null;
                        $acd06eaa94858840$var$Sc(e) === d && (v = new v(t, r + "enter", n, c, e), v.target = x, v.relatedTarget = C, B = v);
                        C = B;
                        if (k && n) b: {
                            v = k;
                            t = n;
                            r = 0;
                            for(x = v; x; x = $acd06eaa94858840$var$qf(x))r++;
                            x = 0;
                            for(B = t; B; B = $acd06eaa94858840$var$qf(B))x++;
                            for(; 0 < r - x;)v = $acd06eaa94858840$var$qf(v), r--;
                            for(; 0 < x - r;)t = $acd06eaa94858840$var$qf(t), x--;
                            for(; r--;){
                                if (v === t || null !== t && v === t.alternate) break b;
                                v = $acd06eaa94858840$var$qf(v);
                                t = $acd06eaa94858840$var$qf(t);
                            }
                            v = null;
                        }
                        else v = null;
                        null !== k && $acd06eaa94858840$var$rf(g, h, k, v, !1);
                        null !== n && null !== C && $acd06eaa94858840$var$rf(g, C, n, v, !0);
                    }
                }
            }
            a: {
                h = d ? $acd06eaa94858840$var$pe(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var O = $acd06eaa94858840$var$qe;
                else if ($acd06eaa94858840$var$he(h)) {
                    if ($acd06eaa94858840$var$re) O = $acd06eaa94858840$var$Ae;
                    else {
                        O = $acd06eaa94858840$var$ye;
                        var T = $acd06eaa94858840$var$xe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (O = $acd06eaa94858840$var$ze);
                if (O && (O = O(a, d))) {
                    $acd06eaa94858840$var$ie(g, O, c, e);
                    break a;
                }
                T && T(a, h, d);
                "focusout" === a && (T = h._wrapperState) && T.controlled && "number" === h.type && $acd06eaa94858840$var$$a(h, "number", h.value);
            }
            T = d ? $acd06eaa94858840$var$pe(d) : window;
            switch(a){
                case "focusin":
                    if ($acd06eaa94858840$var$he(T) || "true" === T.contentEditable) $acd06eaa94858840$var$Le = T, $acd06eaa94858840$var$Me = d, $acd06eaa94858840$var$Ne = null;
                    break;
                case "focusout":
                    $acd06eaa94858840$var$Ne = $acd06eaa94858840$var$Me = $acd06eaa94858840$var$Le = null;
                    break;
                case "mousedown":
                    $acd06eaa94858840$var$Oe = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $acd06eaa94858840$var$Oe = !1;
                    $acd06eaa94858840$var$Pe(g, c, e);
                    break;
                case "selectionchange":
                    if ($acd06eaa94858840$var$Ke) break;
                case "keydown":
                case "keyup":
                    $acd06eaa94858840$var$Pe(g, c, e);
            }
            var za;
            if ($acd06eaa94858840$var$Wd) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else $acd06eaa94858840$var$de ? $acd06eaa94858840$var$be(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && ($acd06eaa94858840$var$Zd && "ko" !== c.locale && ($acd06eaa94858840$var$de || "onCompositionStart" !== L ? "onCompositionEnd" === L && $acd06eaa94858840$var$de && (za = $acd06eaa94858840$var$id()) : ($acd06eaa94858840$var$fd = e, $acd06eaa94858840$var$gd = "value" in $acd06eaa94858840$var$fd ? $acd06eaa94858840$var$fd.value : $acd06eaa94858840$var$fd.textContent, $acd06eaa94858840$var$de = !0)), T = $acd06eaa94858840$var$je(d, L), 0 < T.length && (L = new $acd06eaa94858840$var$Gd(L, a, null, c, e), g.push({
                event: L,
                listeners: T
            }), za ? L.data = za : (za = $acd06eaa94858840$var$ce(c), null !== za && (L.data = za))));
            if (za = $acd06eaa94858840$var$Yd ? $acd06eaa94858840$var$ee(a, c) : $acd06eaa94858840$var$fe(a, c)) d = $acd06eaa94858840$var$je(d, "onBeforeInput"), 0 < d.length && (e = new $acd06eaa94858840$var$Gd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = za);
        }
        $acd06eaa94858840$var$ne(g, b);
    });
}
function $acd06eaa94858840$var$of(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $acd06eaa94858840$var$je(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $acd06eaa94858840$var$Hb(a, c), null != f && d.unshift($acd06eaa94858840$var$of(a, f, e)), f = $acd06eaa94858840$var$Hb(a, b), null != f && d.push($acd06eaa94858840$var$of(a, f, e)));
        a = a.return;
    }
    return d;
}
function $acd06eaa94858840$var$qf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $acd06eaa94858840$var$rf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $acd06eaa94858840$var$Hb(c, f), null != k && g.unshift($acd06eaa94858840$var$of(c, k, h))) : e || (k = $acd06eaa94858840$var$Hb(c, f), null != k && g.push($acd06eaa94858840$var$of(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $acd06eaa94858840$var$sf = /\r\n?/g, $acd06eaa94858840$var$tf = /\u0000|\uFFFD/g;
function $acd06eaa94858840$var$uf(a) {
    return ("string" === typeof a ? a : "" + a).replace($acd06eaa94858840$var$sf, "\n").replace($acd06eaa94858840$var$tf, "");
}
function $acd06eaa94858840$var$vf(a, b, c) {
    b = $acd06eaa94858840$var$uf(b);
    if ($acd06eaa94858840$var$uf(a) !== b && c) throw Error($acd06eaa94858840$var$p(425));
}
function $acd06eaa94858840$var$wf() {}
var $acd06eaa94858840$var$xf = null;
function $acd06eaa94858840$var$yf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $acd06eaa94858840$var$zf = "function" === typeof setTimeout ? setTimeout : void 0, $acd06eaa94858840$var$Af = "function" === typeof clearTimeout ? clearTimeout : void 0, $acd06eaa94858840$var$Bf = "function" === typeof Promise ? Promise : void 0, $acd06eaa94858840$var$Df = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $acd06eaa94858840$var$Bf ? function(a) {
    return $acd06eaa94858840$var$Bf.resolve(null).then(a).catch($acd06eaa94858840$var$Cf);
} : $acd06eaa94858840$var$zf;
function $acd06eaa94858840$var$Cf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $acd06eaa94858840$var$Ef(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $acd06eaa94858840$var$Yc(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $acd06eaa94858840$var$Yc(b);
}
function $acd06eaa94858840$var$Ff(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $acd06eaa94858840$var$Gf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $acd06eaa94858840$var$Hf = Math.random().toString(36).slice(2), $acd06eaa94858840$var$If = "__reactFiber$" + $acd06eaa94858840$var$Hf, $acd06eaa94858840$var$Jf = "__reactProps$" + $acd06eaa94858840$var$Hf, $acd06eaa94858840$var$pf = "__reactContainer$" + $acd06eaa94858840$var$Hf, $acd06eaa94858840$var$jf = "__reactEvents$" + $acd06eaa94858840$var$Hf, $acd06eaa94858840$var$Kf = "__reactListeners$" + $acd06eaa94858840$var$Hf, $acd06eaa94858840$var$Lf = "__reactHandles$" + $acd06eaa94858840$var$Hf;
function $acd06eaa94858840$var$Sc(a) {
    var b = a[$acd06eaa94858840$var$If];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$acd06eaa94858840$var$pf] || c[$acd06eaa94858840$var$If]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $acd06eaa94858840$var$Gf(a); null !== a;){
                if (c = a[$acd06eaa94858840$var$If]) return c;
                a = $acd06eaa94858840$var$Gf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $acd06eaa94858840$var$zb(a) {
    a = a[$acd06eaa94858840$var$If] || a[$acd06eaa94858840$var$pf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $acd06eaa94858840$var$pe(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($acd06eaa94858840$var$p(33));
}
function $acd06eaa94858840$var$Ab(a) {
    return a[$acd06eaa94858840$var$Jf] || null;
}
var $acd06eaa94858840$var$Mf = [], $acd06eaa94858840$var$Nf = -1;
function $acd06eaa94858840$var$Of(a) {
    return {
        current: a
    };
}
function $acd06eaa94858840$var$G(a) {
    0 > $acd06eaa94858840$var$Nf || (a.current = $acd06eaa94858840$var$Mf[$acd06eaa94858840$var$Nf], $acd06eaa94858840$var$Mf[$acd06eaa94858840$var$Nf] = null, $acd06eaa94858840$var$Nf--);
}
function $acd06eaa94858840$var$H(a, b) {
    $acd06eaa94858840$var$Nf++;
    $acd06eaa94858840$var$Mf[$acd06eaa94858840$var$Nf] = a.current;
    a.current = b;
}
var $acd06eaa94858840$var$Pf = {}, $acd06eaa94858840$var$I = $acd06eaa94858840$var$Of($acd06eaa94858840$var$Pf), $acd06eaa94858840$var$Qf = $acd06eaa94858840$var$Of(!1), $acd06eaa94858840$var$Rf = $acd06eaa94858840$var$Pf;
function $acd06eaa94858840$var$Sf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $acd06eaa94858840$var$Pf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $acd06eaa94858840$var$Tf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $acd06eaa94858840$var$Uf() {
    $acd06eaa94858840$var$G($acd06eaa94858840$var$Qf);
    $acd06eaa94858840$var$G($acd06eaa94858840$var$I);
}
function $acd06eaa94858840$var$Vf(a, b, c) {
    if ($acd06eaa94858840$var$I.current !== $acd06eaa94858840$var$Pf) throw Error($acd06eaa94858840$var$p(168));
    $acd06eaa94858840$var$H($acd06eaa94858840$var$I, b);
    $acd06eaa94858840$var$H($acd06eaa94858840$var$Qf, c);
}
function $acd06eaa94858840$var$Wf(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($acd06eaa94858840$var$p(108, $acd06eaa94858840$var$Pa(a) || "Unknown", e));
    return $acd06eaa94858840$var$A({}, c, d);
}
function $acd06eaa94858840$var$Xf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $acd06eaa94858840$var$Pf;
    $acd06eaa94858840$var$Rf = $acd06eaa94858840$var$I.current;
    $acd06eaa94858840$var$H($acd06eaa94858840$var$I, a);
    $acd06eaa94858840$var$H($acd06eaa94858840$var$Qf, $acd06eaa94858840$var$Qf.current);
    return !0;
}
function $acd06eaa94858840$var$Yf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($acd06eaa94858840$var$p(169));
    c ? (a = $acd06eaa94858840$var$Wf(a, b, $acd06eaa94858840$var$Rf), d.__reactInternalMemoizedMergedChildContext = a, $acd06eaa94858840$var$G($acd06eaa94858840$var$Qf), $acd06eaa94858840$var$G($acd06eaa94858840$var$I), $acd06eaa94858840$var$H($acd06eaa94858840$var$I, a)) : $acd06eaa94858840$var$G($acd06eaa94858840$var$Qf);
    $acd06eaa94858840$var$H($acd06eaa94858840$var$Qf, c);
}
var $acd06eaa94858840$var$Zf = null, $acd06eaa94858840$var$$f = !1, $acd06eaa94858840$var$ag = !1;
function $acd06eaa94858840$var$bg(a) {
    null === $acd06eaa94858840$var$Zf ? $acd06eaa94858840$var$Zf = [
        a
    ] : $acd06eaa94858840$var$Zf.push(a);
}
function $acd06eaa94858840$var$cg(a) {
    $acd06eaa94858840$var$$f = !0;
    $acd06eaa94858840$var$bg(a);
}
function $acd06eaa94858840$var$dg() {
    if (!$acd06eaa94858840$var$ag && null !== $acd06eaa94858840$var$Zf) {
        $acd06eaa94858840$var$ag = !0;
        var a = 0, b = $acd06eaa94858840$var$E;
        try {
            var c = $acd06eaa94858840$var$Zf;
            for($acd06eaa94858840$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $acd06eaa94858840$var$Zf = null;
            $acd06eaa94858840$var$$f = !1;
        } catch (e) {
            throw null !== $acd06eaa94858840$var$Zf && ($acd06eaa94858840$var$Zf = $acd06eaa94858840$var$Zf.slice(a + 1)), $acd06eaa94858840$var$Yb($acd06eaa94858840$var$cc, $acd06eaa94858840$var$dg), e;
        } finally{
            $acd06eaa94858840$var$E = b, $acd06eaa94858840$var$ag = !1;
        }
    }
    return null;
}
var $acd06eaa94858840$var$eg = $acd06eaa94858840$var$sa.ReactCurrentBatchConfig;
function $acd06eaa94858840$var$fg(a, b) {
    if (a && a.defaultProps) {
        b = $acd06eaa94858840$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $acd06eaa94858840$var$gg = $acd06eaa94858840$var$Of(null), $acd06eaa94858840$var$hg = null, $acd06eaa94858840$var$ig = null, $acd06eaa94858840$var$jg = null;
function $acd06eaa94858840$var$kg() {
    $acd06eaa94858840$var$jg = $acd06eaa94858840$var$ig = $acd06eaa94858840$var$hg = null;
}
function $acd06eaa94858840$var$lg(a) {
    var b = $acd06eaa94858840$var$gg.current;
    $acd06eaa94858840$var$G($acd06eaa94858840$var$gg);
    a._currentValue = b;
}
function $acd06eaa94858840$var$mg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $acd06eaa94858840$var$ng(a, b) {
    $acd06eaa94858840$var$hg = a;
    $acd06eaa94858840$var$jg = $acd06eaa94858840$var$ig = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($acd06eaa94858840$var$og = !0), a.firstContext = null);
}
function $acd06eaa94858840$var$pg(a) {
    var b = a._currentValue;
    if ($acd06eaa94858840$var$jg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $acd06eaa94858840$var$ig) {
            if (null === $acd06eaa94858840$var$hg) throw Error($acd06eaa94858840$var$p(308));
            $acd06eaa94858840$var$ig = a;
            $acd06eaa94858840$var$hg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $acd06eaa94858840$var$ig = $acd06eaa94858840$var$ig.next = a;
    }
    return b;
}
var $acd06eaa94858840$var$qg = null, $acd06eaa94858840$var$rg = !1;
function $acd06eaa94858840$var$sg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $acd06eaa94858840$var$tg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $acd06eaa94858840$var$ug(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $acd06eaa94858840$var$vg(a, b) {
    var c = a.updateQueue;
    null !== c && (c = c.shared, null !== $acd06eaa94858840$var$J && 0 !== (a.mode & 1) && 0 === ($acd06eaa94858840$var$K & 2) ? (a = c.interleaved, null === a ? (b.next = b, null === $acd06eaa94858840$var$qg ? $acd06eaa94858840$var$qg = [
        c
    ] : $acd06eaa94858840$var$qg.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
}
function $acd06eaa94858840$var$wg(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $acd06eaa94858840$var$yc(a, c);
    }
}
function $acd06eaa94858840$var$xg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $acd06eaa94858840$var$yg(a, b, c, d) {
    var e = a.updateQueue;
    $acd06eaa94858840$var$rg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var w = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var u = h.lane, y = h.eventTime;
            if ((d & u) === u) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, v = h;
                    u = b;
                    y = c;
                    switch(v.tag){
                        case 1:
                            n = v.payload;
                            if ("function" === typeof n) {
                                w = n.call(y, w, u);
                                break a;
                            }
                            w = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = v.payload;
                            u = "function" === typeof n ? n.call(y, w, u) : n;
                            if (null === u || void 0 === u) break a;
                            w = $acd06eaa94858840$var$A({}, w, u);
                            break a;
                        case 2:
                            $acd06eaa94858840$var$rg = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, u = e.effects, null === u ? e.effects = [
                    h
                ] : u.push(h));
            } else y = {
                eventTime: y,
                lane: u,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = w) : m = m.next = y, g |= u;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else u = h, h = u.next, u.next = null, e.lastBaseUpdate = u, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = w);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $acd06eaa94858840$var$zg |= g;
        a.lanes = g;
        a.memoizedState = w;
    }
}
function $acd06eaa94858840$var$Ag(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($acd06eaa94858840$var$p(191, e));
            e.call(d);
        }
    }
}
var $acd06eaa94858840$var$Bg = (new $9kKA1.Component).refs;
function $acd06eaa94858840$var$Cg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $acd06eaa94858840$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $acd06eaa94858840$var$Fg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $acd06eaa94858840$var$Sb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $acd06eaa94858840$var$M(), e = $acd06eaa94858840$var$Dg(a), f = $acd06eaa94858840$var$ug(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $acd06eaa94858840$var$vg(a, f);
        b = $acd06eaa94858840$var$Eg(a, e, d);
        null !== b && $acd06eaa94858840$var$wg(b, a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $acd06eaa94858840$var$M(), e = $acd06eaa94858840$var$Dg(a), f = $acd06eaa94858840$var$ug(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $acd06eaa94858840$var$vg(a, f);
        b = $acd06eaa94858840$var$Eg(a, e, d);
        null !== b && $acd06eaa94858840$var$wg(b, a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $acd06eaa94858840$var$M(), d = $acd06eaa94858840$var$Dg(a), e = $acd06eaa94858840$var$ug(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $acd06eaa94858840$var$vg(a, e);
        b = $acd06eaa94858840$var$Eg(a, d, c);
        null !== b && $acd06eaa94858840$var$wg(b, a, d);
    }
};
function $acd06eaa94858840$var$Gg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$acd06eaa94858840$var$De(c, d) || !$acd06eaa94858840$var$De(e, f) : !0;
}
function $acd06eaa94858840$var$Hg(a, b, c) {
    var d = !1, e = $acd06eaa94858840$var$Pf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $acd06eaa94858840$var$pg(f) : (e = $acd06eaa94858840$var$Tf(b) ? $acd06eaa94858840$var$Rf : $acd06eaa94858840$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $acd06eaa94858840$var$Sf(a, e) : $acd06eaa94858840$var$Pf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $acd06eaa94858840$var$Fg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $acd06eaa94858840$var$Ig(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $acd06eaa94858840$var$Fg.enqueueReplaceState(b, b.state, null);
}
function $acd06eaa94858840$var$Jg(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $acd06eaa94858840$var$Bg;
    $acd06eaa94858840$var$sg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $acd06eaa94858840$var$pg(f) : (f = $acd06eaa94858840$var$Tf(b) ? $acd06eaa94858840$var$Rf : $acd06eaa94858840$var$I.current, e.context = $acd06eaa94858840$var$Sf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($acd06eaa94858840$var$Cg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $acd06eaa94858840$var$Fg.enqueueReplaceState(e, e.state, null), $acd06eaa94858840$var$yg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
var $acd06eaa94858840$var$Kg = [], $acd06eaa94858840$var$Lg = 0, $acd06eaa94858840$var$Mg = null, $acd06eaa94858840$var$Ng = 0, $acd06eaa94858840$var$Og = [], $acd06eaa94858840$var$Pg = 0, $acd06eaa94858840$var$Qg = null, $acd06eaa94858840$var$Rg = 1, $acd06eaa94858840$var$Sg = "";
function $acd06eaa94858840$var$Tg(a, b) {
    $acd06eaa94858840$var$Kg[$acd06eaa94858840$var$Lg++] = $acd06eaa94858840$var$Ng;
    $acd06eaa94858840$var$Kg[$acd06eaa94858840$var$Lg++] = $acd06eaa94858840$var$Mg;
    $acd06eaa94858840$var$Mg = a;
    $acd06eaa94858840$var$Ng = b;
}
function $acd06eaa94858840$var$Ug(a, b, c) {
    $acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg++] = $acd06eaa94858840$var$Rg;
    $acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg++] = $acd06eaa94858840$var$Sg;
    $acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg++] = $acd06eaa94858840$var$Qg;
    $acd06eaa94858840$var$Qg = a;
    var d = $acd06eaa94858840$var$Rg;
    a = $acd06eaa94858840$var$Sg;
    var e = 32 - $acd06eaa94858840$var$lc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $acd06eaa94858840$var$lc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $acd06eaa94858840$var$Rg = 1 << 32 - $acd06eaa94858840$var$lc(b) + e | c << e | d;
        $acd06eaa94858840$var$Sg = f + a;
    } else $acd06eaa94858840$var$Rg = 1 << f | c << e | d, $acd06eaa94858840$var$Sg = a;
}
function $acd06eaa94858840$var$Vg(a) {
    null !== a.return && ($acd06eaa94858840$var$Tg(a, 1), $acd06eaa94858840$var$Ug(a, 1, 0));
}
function $acd06eaa94858840$var$Wg(a) {
    for(; a === $acd06eaa94858840$var$Mg;)$acd06eaa94858840$var$Mg = $acd06eaa94858840$var$Kg[--$acd06eaa94858840$var$Lg], $acd06eaa94858840$var$Kg[$acd06eaa94858840$var$Lg] = null, $acd06eaa94858840$var$Ng = $acd06eaa94858840$var$Kg[--$acd06eaa94858840$var$Lg], $acd06eaa94858840$var$Kg[$acd06eaa94858840$var$Lg] = null;
    for(; a === $acd06eaa94858840$var$Qg;)$acd06eaa94858840$var$Qg = $acd06eaa94858840$var$Og[--$acd06eaa94858840$var$Pg], $acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg] = null, $acd06eaa94858840$var$Sg = $acd06eaa94858840$var$Og[--$acd06eaa94858840$var$Pg], $acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg] = null, $acd06eaa94858840$var$Rg = $acd06eaa94858840$var$Og[--$acd06eaa94858840$var$Pg], $acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg] = null;
}
var $acd06eaa94858840$var$Xg = null, $acd06eaa94858840$var$Yg = null, $acd06eaa94858840$var$N = !1, $acd06eaa94858840$var$Zg = null;
function $acd06eaa94858840$var$$g(a, b) {
    var c = $acd06eaa94858840$var$ah(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $acd06eaa94858840$var$bh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $acd06eaa94858840$var$Xg = a, $acd06eaa94858840$var$Yg = $acd06eaa94858840$var$Ff(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $acd06eaa94858840$var$Xg = a, $acd06eaa94858840$var$Yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $acd06eaa94858840$var$Qg ? {
                id: $acd06eaa94858840$var$Rg,
                overflow: $acd06eaa94858840$var$Sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $acd06eaa94858840$var$ah(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $acd06eaa94858840$var$Xg = a, $acd06eaa94858840$var$Yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $acd06eaa94858840$var$ch(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $acd06eaa94858840$var$dh(a) {
    if ($acd06eaa94858840$var$N) {
        var b = $acd06eaa94858840$var$Yg;
        if (b) {
            var c = b;
            if (!$acd06eaa94858840$var$bh(a, b)) {
                if ($acd06eaa94858840$var$ch(a)) throw Error($acd06eaa94858840$var$p(418));
                b = $acd06eaa94858840$var$Ff(c.nextSibling);
                var d = $acd06eaa94858840$var$Xg;
                b && $acd06eaa94858840$var$bh(a, b) ? $acd06eaa94858840$var$$g(d, c) : (a.flags = a.flags & -4097 | 2, $acd06eaa94858840$var$N = !1, $acd06eaa94858840$var$Xg = a);
            }
        } else {
            if ($acd06eaa94858840$var$ch(a)) throw Error($acd06eaa94858840$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $acd06eaa94858840$var$N = !1;
            $acd06eaa94858840$var$Xg = a;
        }
    }
}
function $acd06eaa94858840$var$eh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $acd06eaa94858840$var$Xg = a;
}
function $acd06eaa94858840$var$fh(a) {
    if (a !== $acd06eaa94858840$var$Xg) return !1;
    if (!$acd06eaa94858840$var$N) return $acd06eaa94858840$var$eh(a), $acd06eaa94858840$var$N = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$acd06eaa94858840$var$yf(a.type, a.memoizedProps));
    if (b && (b = $acd06eaa94858840$var$Yg)) {
        if ($acd06eaa94858840$var$ch(a)) {
            for(a = $acd06eaa94858840$var$Yg; a;)a = $acd06eaa94858840$var$Ff(a.nextSibling);
            throw Error($acd06eaa94858840$var$p(418));
        }
        for(; b;)$acd06eaa94858840$var$$g(a, b), b = $acd06eaa94858840$var$Ff(b.nextSibling);
    }
    $acd06eaa94858840$var$eh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($acd06eaa94858840$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $acd06eaa94858840$var$Yg = $acd06eaa94858840$var$Ff(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $acd06eaa94858840$var$Yg = null;
        }
    } else $acd06eaa94858840$var$Yg = $acd06eaa94858840$var$Xg ? $acd06eaa94858840$var$Ff(a.stateNode.nextSibling) : null;
    return !0;
}
function $acd06eaa94858840$var$gh() {
    $acd06eaa94858840$var$Yg = $acd06eaa94858840$var$Xg = null;
    $acd06eaa94858840$var$N = !1;
}
function $acd06eaa94858840$var$hh(a) {
    null === $acd06eaa94858840$var$Zg ? $acd06eaa94858840$var$Zg = [
        a
    ] : $acd06eaa94858840$var$Zg.push(a);
}
function $acd06eaa94858840$var$ih(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($acd06eaa94858840$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($acd06eaa94858840$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $acd06eaa94858840$var$Bg && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($acd06eaa94858840$var$p(284));
        if (!c._owner) throw Error($acd06eaa94858840$var$p(290, a));
    }
    return a;
}
function $acd06eaa94858840$var$jh(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($acd06eaa94858840$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $acd06eaa94858840$var$kh(a) {
    var b = a._init;
    return b(a._payload);
}
function $acd06eaa94858840$var$lh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $acd06eaa94858840$var$mh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $acd06eaa94858840$var$nh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $acd06eaa94858840$var$va) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $acd06eaa94858840$var$Fa && $acd06eaa94858840$var$kh(f) === b.type)) return d = e(b, c.props), d.ref = $acd06eaa94858840$var$ih(a, b, c), d.return = a, d;
        d = $acd06eaa94858840$var$oh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $acd06eaa94858840$var$ih(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $acd06eaa94858840$var$ph(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $acd06eaa94858840$var$qh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function w(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $acd06eaa94858840$var$nh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $acd06eaa94858840$var$ta:
                    return c = $acd06eaa94858840$var$oh(b.type, b.key, b.props, null, a.mode, c), c.ref = $acd06eaa94858840$var$ih(a, null, b), c.return = a, c;
                case $acd06eaa94858840$var$ua:
                    return b = $acd06eaa94858840$var$ph(b, a.mode, c), b.return = a, b;
                case $acd06eaa94858840$var$Fa:
                    var d = b._init;
                    return w(a, d(b._payload), c);
            }
            if ($acd06eaa94858840$var$bb(b) || $acd06eaa94858840$var$Ia(b)) return b = $acd06eaa94858840$var$qh(b, a.mode, c, null), b.return = a, b;
            $acd06eaa94858840$var$jh(a, b);
        }
        return null;
    }
    function u(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $acd06eaa94858840$var$ta:
                    return c.key === e ? k(a, b, c, d) : null;
                case $acd06eaa94858840$var$ua:
                    return c.key === e ? l(a, b, c, d) : null;
                case $acd06eaa94858840$var$Fa:
                    return e = c._init, u(a, b, e(c._payload), d);
            }
            if ($acd06eaa94858840$var$bb(c) || $acd06eaa94858840$var$Ia(c)) return null !== e ? null : m(a, b, c, d, null);
            $acd06eaa94858840$var$jh(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $acd06eaa94858840$var$ta:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $acd06eaa94858840$var$ua:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $acd06eaa94858840$var$Fa:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($acd06eaa94858840$var$bb(d) || $acd06eaa94858840$var$Ia(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $acd06eaa94858840$var$jh(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, n = null, m = g, r = g = 0, x = null; null !== m && r < h.length; r++){
            m.index > r ? (x = m, m = null) : x = m.sibling;
            var t = u(e, m, h[r], k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, r);
            null === n ? l = t : n.sibling = t;
            n = t;
            m = x;
        }
        if (r === h.length) return c(e, m), $acd06eaa94858840$var$N && $acd06eaa94858840$var$Tg(e, r), l;
        if (null === m) {
            for(; r < h.length; r++)m = w(e, h[r], k), null !== m && (g = f(m, g, r), null === n ? l = m : n.sibling = m, n = m);
            $acd06eaa94858840$var$N && $acd06eaa94858840$var$Tg(e, r);
            return l;
        }
        for(m = d(e, m); r < h.length; r++)x = y(m, e, r, h[r], k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? r : x.key), g = f(x, g, r), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $acd06eaa94858840$var$N && $acd06eaa94858840$var$Tg(e, r);
        return l;
    }
    function v(e, g, h, k) {
        var l = $acd06eaa94858840$var$Ia(h);
        if ("function" !== typeof l) throw Error($acd06eaa94858840$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($acd06eaa94858840$var$p(151));
        for(var m = l = null, n = g, r = g = 0, x = null, t = h.next(); null !== n && !t.done; r++, t = h.next()){
            n.index > r ? (x = n, n = null) : x = n.sibling;
            var v = u(e, n, t.value, k);
            if (null === v) {
                null === n && (n = x);
                break;
            }
            a && n && null === v.alternate && b(e, n);
            g = f(v, g, r);
            null === m ? l = v : m.sibling = v;
            m = v;
            n = x;
        }
        if (t.done) return c(e, n), $acd06eaa94858840$var$N && $acd06eaa94858840$var$Tg(e, r), l;
        if (null === n) {
            for(; !t.done; r++, t = h.next())t = w(e, t.value, k), null !== t && (g = f(t, g, r), null === m ? l = t : m.sibling = t, m = t);
            $acd06eaa94858840$var$N && $acd06eaa94858840$var$Tg(e, r);
            return l;
        }
        for(n = d(e, n); !t.done; r++, t = h.next())t = y(n, e, r, t.value, k), null !== t && (a && null !== t.alternate && n.delete(null === t.key ? r : t.key), g = f(t, g, r), null === m ? l = t : m.sibling = t, m = t);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $acd06eaa94858840$var$N && $acd06eaa94858840$var$Tg(e, r);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $acd06eaa94858840$var$va && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $acd06eaa94858840$var$ta:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $acd06eaa94858840$var$va) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $acd06eaa94858840$var$Fa && $acd06eaa94858840$var$kh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $acd06eaa94858840$var$ih(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $acd06eaa94858840$var$va ? (d = $acd06eaa94858840$var$qh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $acd06eaa94858840$var$oh(f.type, f.key, f.props, null, a.mode, h), h.ref = $acd06eaa94858840$var$ih(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $acd06eaa94858840$var$ua:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $acd06eaa94858840$var$ph(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $acd06eaa94858840$var$Fa:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($acd06eaa94858840$var$bb(f)) return n(a, d, f, h);
            if ($acd06eaa94858840$var$Ia(f)) return v(a, d, f, h);
            $acd06eaa94858840$var$jh(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $acd06eaa94858840$var$nh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $acd06eaa94858840$var$rh = $acd06eaa94858840$var$lh(!0), $acd06eaa94858840$var$sh = $acd06eaa94858840$var$lh(!1), $acd06eaa94858840$var$th = {}, $acd06eaa94858840$var$uh = $acd06eaa94858840$var$Of($acd06eaa94858840$var$th), $acd06eaa94858840$var$vh = $acd06eaa94858840$var$Of($acd06eaa94858840$var$th), $acd06eaa94858840$var$wh = $acd06eaa94858840$var$Of($acd06eaa94858840$var$th);
function $acd06eaa94858840$var$xh(a) {
    if (a === $acd06eaa94858840$var$th) throw Error($acd06eaa94858840$var$p(174));
    return a;
}
function $acd06eaa94858840$var$yh(a, b) {
    $acd06eaa94858840$var$H($acd06eaa94858840$var$wh, b);
    $acd06eaa94858840$var$H($acd06eaa94858840$var$vh, a);
    $acd06eaa94858840$var$H($acd06eaa94858840$var$uh, $acd06eaa94858840$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $acd06eaa94858840$var$ib(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $acd06eaa94858840$var$ib(b, a);
    }
    $acd06eaa94858840$var$G($acd06eaa94858840$var$uh);
    $acd06eaa94858840$var$H($acd06eaa94858840$var$uh, b);
}
function $acd06eaa94858840$var$zh() {
    $acd06eaa94858840$var$G($acd06eaa94858840$var$uh);
    $acd06eaa94858840$var$G($acd06eaa94858840$var$vh);
    $acd06eaa94858840$var$G($acd06eaa94858840$var$wh);
}
function $acd06eaa94858840$var$Ah(a) {
    $acd06eaa94858840$var$xh($acd06eaa94858840$var$wh.current);
    var b = $acd06eaa94858840$var$xh($acd06eaa94858840$var$uh.current);
    var c = $acd06eaa94858840$var$ib(b, a.type);
    b !== c && ($acd06eaa94858840$var$H($acd06eaa94858840$var$vh, a), $acd06eaa94858840$var$H($acd06eaa94858840$var$uh, c));
}
function $acd06eaa94858840$var$Bh(a) {
    $acd06eaa94858840$var$vh.current === a && ($acd06eaa94858840$var$G($acd06eaa94858840$var$uh), $acd06eaa94858840$var$G($acd06eaa94858840$var$vh));
}
var $acd06eaa94858840$var$P = $acd06eaa94858840$var$Of(0);
function $acd06eaa94858840$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $acd06eaa94858840$var$Dh = [];
function $acd06eaa94858840$var$Eh() {
    for(var a = 0; a < $acd06eaa94858840$var$Dh.length; a++)$acd06eaa94858840$var$Dh[a]._workInProgressVersionPrimary = null;
    $acd06eaa94858840$var$Dh.length = 0;
}
var $acd06eaa94858840$var$Fh = $acd06eaa94858840$var$sa.ReactCurrentDispatcher, $acd06eaa94858840$var$Gh = $acd06eaa94858840$var$sa.ReactCurrentBatchConfig, $acd06eaa94858840$var$Hh = 0, $acd06eaa94858840$var$Q = null, $acd06eaa94858840$var$R = null, $acd06eaa94858840$var$S = null, $acd06eaa94858840$var$Ih = !1, $acd06eaa94858840$var$Jh = !1, $acd06eaa94858840$var$Kh = 0, $acd06eaa94858840$var$Lh = 0;
function $acd06eaa94858840$var$U() {
    throw Error($acd06eaa94858840$var$p(321));
}
function $acd06eaa94858840$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$acd06eaa94858840$var$Ce(a[c], b[c])) return !1;
    return !0;
}
function $acd06eaa94858840$var$Nh(a, b, c, d, e, f) {
    $acd06eaa94858840$var$Hh = f;
    $acd06eaa94858840$var$Q = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $acd06eaa94858840$var$Fh.current = null === a || null === a.memoizedState ? $acd06eaa94858840$var$Oh : $acd06eaa94858840$var$Ph;
    a = c(d, e);
    if ($acd06eaa94858840$var$Jh) {
        f = 0;
        do {
            $acd06eaa94858840$var$Jh = !1;
            $acd06eaa94858840$var$Kh = 0;
            if (25 <= f) throw Error($acd06eaa94858840$var$p(301));
            f += 1;
            $acd06eaa94858840$var$S = $acd06eaa94858840$var$R = null;
            b.updateQueue = null;
            $acd06eaa94858840$var$Fh.current = $acd06eaa94858840$var$Qh;
            a = c(d, e);
        }while ($acd06eaa94858840$var$Jh);
    }
    $acd06eaa94858840$var$Fh.current = $acd06eaa94858840$var$Rh;
    b = null !== $acd06eaa94858840$var$R && null !== $acd06eaa94858840$var$R.next;
    $acd06eaa94858840$var$Hh = 0;
    $acd06eaa94858840$var$S = $acd06eaa94858840$var$R = $acd06eaa94858840$var$Q = null;
    $acd06eaa94858840$var$Ih = !1;
    if (b) throw Error($acd06eaa94858840$var$p(300));
    return a;
}
function $acd06eaa94858840$var$Sh() {
    var a = 0 !== $acd06eaa94858840$var$Kh;
    $acd06eaa94858840$var$Kh = 0;
    return a;
}
function $acd06eaa94858840$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $acd06eaa94858840$var$S ? $acd06eaa94858840$var$Q.memoizedState = $acd06eaa94858840$var$S = a : $acd06eaa94858840$var$S = $acd06eaa94858840$var$S.next = a;
    return $acd06eaa94858840$var$S;
}
function $acd06eaa94858840$var$Uh() {
    if (null === $acd06eaa94858840$var$R) {
        var a = $acd06eaa94858840$var$Q.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $acd06eaa94858840$var$R.next;
    var b = null === $acd06eaa94858840$var$S ? $acd06eaa94858840$var$Q.memoizedState : $acd06eaa94858840$var$S.next;
    if (null !== b) $acd06eaa94858840$var$S = b, $acd06eaa94858840$var$R = a;
    else {
        if (null === a) throw Error($acd06eaa94858840$var$p(310));
        $acd06eaa94858840$var$R = a;
        a = {
            memoizedState: $acd06eaa94858840$var$R.memoizedState,
            baseState: $acd06eaa94858840$var$R.baseState,
            baseQueue: $acd06eaa94858840$var$R.baseQueue,
            queue: $acd06eaa94858840$var$R.queue,
            next: null
        };
        null === $acd06eaa94858840$var$S ? $acd06eaa94858840$var$Q.memoizedState = $acd06eaa94858840$var$S = a : $acd06eaa94858840$var$S = $acd06eaa94858840$var$S.next = a;
    }
    return $acd06eaa94858840$var$S;
}
function $acd06eaa94858840$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $acd06eaa94858840$var$Wh(a) {
    var b = $acd06eaa94858840$var$Uh(), c = b.queue;
    if (null === c) throw Error($acd06eaa94858840$var$p(311));
    c.lastRenderedReducer = a;
    var d = $acd06eaa94858840$var$R, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($acd06eaa94858840$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var w = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = w, g = d) : k = k.next = w;
                $acd06eaa94858840$var$Q.lanes |= m;
                $acd06eaa94858840$var$zg |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $acd06eaa94858840$var$Ce(d, b.memoizedState) || ($acd06eaa94858840$var$og = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $acd06eaa94858840$var$Q.lanes |= f, $acd06eaa94858840$var$zg |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $acd06eaa94858840$var$Xh(a) {
    var b = $acd06eaa94858840$var$Uh(), c = b.queue;
    if (null === c) throw Error($acd06eaa94858840$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $acd06eaa94858840$var$Ce(f, b.memoizedState) || ($acd06eaa94858840$var$og = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $acd06eaa94858840$var$Yh() {}
function $acd06eaa94858840$var$Zh(a, b) {
    var c = $acd06eaa94858840$var$Q, d = $acd06eaa94858840$var$Uh(), e = b(), f = !$acd06eaa94858840$var$Ce(d.memoizedState, e);
    f && (d.memoizedState = e, $acd06eaa94858840$var$og = !0);
    d = d.queue;
    $acd06eaa94858840$var$$h($acd06eaa94858840$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $acd06eaa94858840$var$S && $acd06eaa94858840$var$S.memoizedState.tag & 1) {
        c.flags |= 2048;
        $acd06eaa94858840$var$bi(9, $acd06eaa94858840$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $acd06eaa94858840$var$J) throw Error($acd06eaa94858840$var$p(349));
        0 !== ($acd06eaa94858840$var$Hh & 30) || $acd06eaa94858840$var$di(c, b, e);
    }
    return e;
}
function $acd06eaa94858840$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $acd06eaa94858840$var$Q.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $acd06eaa94858840$var$Q.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $acd06eaa94858840$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $acd06eaa94858840$var$ei(b) && $acd06eaa94858840$var$Eg(a, 1, -1);
}
function $acd06eaa94858840$var$ai(a, b, c) {
    return c(function() {
        $acd06eaa94858840$var$ei(b) && $acd06eaa94858840$var$Eg(a, 1, -1);
    });
}
function $acd06eaa94858840$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$acd06eaa94858840$var$Ce(a, c);
    } catch (d) {
        return !0;
    }
}
function $acd06eaa94858840$var$fi(a) {
    var b = $acd06eaa94858840$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $acd06eaa94858840$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $acd06eaa94858840$var$gi.bind(null, $acd06eaa94858840$var$Q, a);
    return [
        b.memoizedState,
        a
    ];
}
function $acd06eaa94858840$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $acd06eaa94858840$var$Q.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $acd06eaa94858840$var$Q.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $acd06eaa94858840$var$hi() {
    return $acd06eaa94858840$var$Uh().memoizedState;
}
function $acd06eaa94858840$var$ii(a, b, c, d) {
    var e = $acd06eaa94858840$var$Th();
    $acd06eaa94858840$var$Q.flags |= a;
    e.memoizedState = $acd06eaa94858840$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $acd06eaa94858840$var$ji(a, b, c, d) {
    var e = $acd06eaa94858840$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $acd06eaa94858840$var$R) {
        var g = $acd06eaa94858840$var$R.memoizedState;
        f = g.destroy;
        if (null !== d && $acd06eaa94858840$var$Mh(d, g.deps)) {
            e.memoizedState = $acd06eaa94858840$var$bi(b, c, f, d);
            return;
        }
    }
    $acd06eaa94858840$var$Q.flags |= a;
    e.memoizedState = $acd06eaa94858840$var$bi(1 | b, c, f, d);
}
function $acd06eaa94858840$var$ki(a, b) {
    return $acd06eaa94858840$var$ii(8390656, 8, a, b);
}
function $acd06eaa94858840$var$$h(a, b) {
    return $acd06eaa94858840$var$ji(2048, 8, a, b);
}
function $acd06eaa94858840$var$li(a, b) {
    return $acd06eaa94858840$var$ji(4, 2, a, b);
}
function $acd06eaa94858840$var$mi(a, b) {
    return $acd06eaa94858840$var$ji(4, 4, a, b);
}
function $acd06eaa94858840$var$ni(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $acd06eaa94858840$var$oi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $acd06eaa94858840$var$ji(4, 4, $acd06eaa94858840$var$ni.bind(null, b, a), c);
}
function $acd06eaa94858840$var$pi() {}
function $acd06eaa94858840$var$qi(a, b) {
    var c = $acd06eaa94858840$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $acd06eaa94858840$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $acd06eaa94858840$var$ri(a, b) {
    var c = $acd06eaa94858840$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $acd06eaa94858840$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $acd06eaa94858840$var$si(a, b) {
    var c = $acd06eaa94858840$var$E;
    $acd06eaa94858840$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $acd06eaa94858840$var$Gh.transition;
    $acd06eaa94858840$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $acd06eaa94858840$var$E = c, $acd06eaa94858840$var$Gh.transition = d;
    }
}
function $acd06eaa94858840$var$ti() {
    return $acd06eaa94858840$var$Uh().memoizedState;
}
function $acd06eaa94858840$var$ui(a, b, c) {
    var d = $acd06eaa94858840$var$Dg(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $acd06eaa94858840$var$vi(a) ? $acd06eaa94858840$var$wi(b, c) : ($acd06eaa94858840$var$xi(a, b, c), c = $acd06eaa94858840$var$M(), a = $acd06eaa94858840$var$Eg(a, d, c), null !== a && $acd06eaa94858840$var$yi(a, b, d));
}
function $acd06eaa94858840$var$gi(a, b, c) {
    var d = $acd06eaa94858840$var$Dg(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($acd06eaa94858840$var$vi(a)) $acd06eaa94858840$var$wi(b, e);
    else {
        $acd06eaa94858840$var$xi(a, b, e);
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($acd06eaa94858840$var$Ce(h, g)) return;
        } catch (k) {} finally{}
        c = $acd06eaa94858840$var$M();
        a = $acd06eaa94858840$var$Eg(a, d, c);
        null !== a && $acd06eaa94858840$var$yi(a, b, d);
    }
}
function $acd06eaa94858840$var$vi(a) {
    var b = a.alternate;
    return a === $acd06eaa94858840$var$Q || null !== b && b === $acd06eaa94858840$var$Q;
}
function $acd06eaa94858840$var$wi(a, b) {
    $acd06eaa94858840$var$Jh = $acd06eaa94858840$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $acd06eaa94858840$var$xi(a, b, c) {
    null !== $acd06eaa94858840$var$J && 0 !== (a.mode & 1) && 0 === ($acd06eaa94858840$var$K & 2) ? (a = b.interleaved, null === a ? (c.next = c, null === $acd06eaa94858840$var$qg ? $acd06eaa94858840$var$qg = [
        b
    ] : $acd06eaa94858840$var$qg.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
}
function $acd06eaa94858840$var$yi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $acd06eaa94858840$var$yc(a, c);
    }
}
var $acd06eaa94858840$var$Rh = {
    readContext: $acd06eaa94858840$var$pg,
    useCallback: $acd06eaa94858840$var$U,
    useContext: $acd06eaa94858840$var$U,
    useEffect: $acd06eaa94858840$var$U,
    useImperativeHandle: $acd06eaa94858840$var$U,
    useInsertionEffect: $acd06eaa94858840$var$U,
    useLayoutEffect: $acd06eaa94858840$var$U,
    useMemo: $acd06eaa94858840$var$U,
    useReducer: $acd06eaa94858840$var$U,
    useRef: $acd06eaa94858840$var$U,
    useState: $acd06eaa94858840$var$U,
    useDebugValue: $acd06eaa94858840$var$U,
    useDeferredValue: $acd06eaa94858840$var$U,
    useTransition: $acd06eaa94858840$var$U,
    useMutableSource: $acd06eaa94858840$var$U,
    useSyncExternalStore: $acd06eaa94858840$var$U,
    useId: $acd06eaa94858840$var$U,
    unstable_isNewReconciler: !1
}, $acd06eaa94858840$var$Oh = {
    readContext: $acd06eaa94858840$var$pg,
    useCallback: function(a, b) {
        $acd06eaa94858840$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $acd06eaa94858840$var$pg,
    useEffect: $acd06eaa94858840$var$ki,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $acd06eaa94858840$var$ii(4194308, 4, $acd06eaa94858840$var$ni.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $acd06eaa94858840$var$ii(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $acd06eaa94858840$var$ii(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $acd06eaa94858840$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $acd06eaa94858840$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $acd06eaa94858840$var$ui.bind(null, $acd06eaa94858840$var$Q, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $acd06eaa94858840$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $acd06eaa94858840$var$fi,
    useDebugValue: $acd06eaa94858840$var$pi,
    useDeferredValue: function(a) {
        var b = $acd06eaa94858840$var$fi(a), c = b[0], d = b[1];
        $acd06eaa94858840$var$ki(function() {
            var b = $acd06eaa94858840$var$Gh.transition;
            $acd06eaa94858840$var$Gh.transition = {};
            try {
                d(a);
            } finally{
                $acd06eaa94858840$var$Gh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $acd06eaa94858840$var$fi(!1), b = a[0];
        a = $acd06eaa94858840$var$si.bind(null, a[1]);
        $acd06eaa94858840$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $acd06eaa94858840$var$Q, e = $acd06eaa94858840$var$Th();
        if ($acd06eaa94858840$var$N) {
            if (void 0 === c) throw Error($acd06eaa94858840$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $acd06eaa94858840$var$J) throw Error($acd06eaa94858840$var$p(349));
            0 !== ($acd06eaa94858840$var$Hh & 30) || $acd06eaa94858840$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $acd06eaa94858840$var$ki($acd06eaa94858840$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $acd06eaa94858840$var$bi(9, $acd06eaa94858840$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $acd06eaa94858840$var$Th(), b = $acd06eaa94858840$var$J.identifierPrefix;
        if ($acd06eaa94858840$var$N) {
            var c = $acd06eaa94858840$var$Sg;
            var d = $acd06eaa94858840$var$Rg;
            c = (d & ~(1 << 32 - $acd06eaa94858840$var$lc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $acd06eaa94858840$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $acd06eaa94858840$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $acd06eaa94858840$var$Ph = {
    readContext: $acd06eaa94858840$var$pg,
    useCallback: $acd06eaa94858840$var$qi,
    useContext: $acd06eaa94858840$var$pg,
    useEffect: $acd06eaa94858840$var$$h,
    useImperativeHandle: $acd06eaa94858840$var$oi,
    useInsertionEffect: $acd06eaa94858840$var$li,
    useLayoutEffect: $acd06eaa94858840$var$mi,
    useMemo: $acd06eaa94858840$var$ri,
    useReducer: $acd06eaa94858840$var$Wh,
    useRef: $acd06eaa94858840$var$hi,
    useState: function() {
        return $acd06eaa94858840$var$Wh($acd06eaa94858840$var$Vh);
    },
    useDebugValue: $acd06eaa94858840$var$pi,
    useDeferredValue: function(a) {
        var b = $acd06eaa94858840$var$Wh($acd06eaa94858840$var$Vh), c = b[0], d = b[1];
        $acd06eaa94858840$var$$h(function() {
            var b = $acd06eaa94858840$var$Gh.transition;
            $acd06eaa94858840$var$Gh.transition = {};
            try {
                d(a);
            } finally{
                $acd06eaa94858840$var$Gh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $acd06eaa94858840$var$Wh($acd06eaa94858840$var$Vh)[0], b = $acd06eaa94858840$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $acd06eaa94858840$var$Yh,
    useSyncExternalStore: $acd06eaa94858840$var$Zh,
    useId: $acd06eaa94858840$var$ti,
    unstable_isNewReconciler: !1
}, $acd06eaa94858840$var$Qh = {
    readContext: $acd06eaa94858840$var$pg,
    useCallback: $acd06eaa94858840$var$qi,
    useContext: $acd06eaa94858840$var$pg,
    useEffect: $acd06eaa94858840$var$$h,
    useImperativeHandle: $acd06eaa94858840$var$oi,
    useInsertionEffect: $acd06eaa94858840$var$li,
    useLayoutEffect: $acd06eaa94858840$var$mi,
    useMemo: $acd06eaa94858840$var$ri,
    useReducer: $acd06eaa94858840$var$Xh,
    useRef: $acd06eaa94858840$var$hi,
    useState: function() {
        return $acd06eaa94858840$var$Xh($acd06eaa94858840$var$Vh);
    },
    useDebugValue: $acd06eaa94858840$var$pi,
    useDeferredValue: function(a) {
        var b = $acd06eaa94858840$var$Xh($acd06eaa94858840$var$Vh), c = b[0], d = b[1];
        $acd06eaa94858840$var$$h(function() {
            var b = $acd06eaa94858840$var$Gh.transition;
            $acd06eaa94858840$var$Gh.transition = {};
            try {
                d(a);
            } finally{
                $acd06eaa94858840$var$Gh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $acd06eaa94858840$var$Xh($acd06eaa94858840$var$Vh)[0], b = $acd06eaa94858840$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $acd06eaa94858840$var$Yh,
    useSyncExternalStore: $acd06eaa94858840$var$Zh,
    useId: $acd06eaa94858840$var$ti,
    unstable_isNewReconciler: !1
};
function $acd06eaa94858840$var$zi(a, b) {
    try {
        var c = "", d = b;
        do c += $acd06eaa94858840$var$Na(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $acd06eaa94858840$var$Ai(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $acd06eaa94858840$var$Bi = "function" === typeof WeakMap ? WeakMap : Map;
function $acd06eaa94858840$var$Ci(a, b, c) {
    c = $acd06eaa94858840$var$ug(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $acd06eaa94858840$var$Di || ($acd06eaa94858840$var$Di = !0, $acd06eaa94858840$var$Ei = d);
        $acd06eaa94858840$var$Ai(a, b);
    };
    return c;
}
function $acd06eaa94858840$var$Fi(a, b, c) {
    c = $acd06eaa94858840$var$ug(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $acd06eaa94858840$var$Ai(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $acd06eaa94858840$var$Ai(a, b);
        "function" !== typeof d && (null === $acd06eaa94858840$var$Gi ? $acd06eaa94858840$var$Gi = new Set([
            this
        ]) : $acd06eaa94858840$var$Gi.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $acd06eaa94858840$var$Hi(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $acd06eaa94858840$var$Bi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $acd06eaa94858840$var$Ii.bind(null, a, b, c), b.then(a, a));
}
function $acd06eaa94858840$var$Ji(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $acd06eaa94858840$var$Ki(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $acd06eaa94858840$var$ug(-1, 1), b.tag = 2, $acd06eaa94858840$var$vg(c, b))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $acd06eaa94858840$var$Li, $acd06eaa94858840$var$Mi, $acd06eaa94858840$var$Ni, $acd06eaa94858840$var$Oi;
$acd06eaa94858840$var$Li = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$acd06eaa94858840$var$Mi = function() {};
$acd06eaa94858840$var$Ni = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $acd06eaa94858840$var$xh($acd06eaa94858840$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $acd06eaa94858840$var$Wa(a, e);
                d = $acd06eaa94858840$var$Wa(a, d);
                f = [];
                break;
            case "select":
                e = $acd06eaa94858840$var$A({}, e, {
                    value: void 0
                });
                d = $acd06eaa94858840$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $acd06eaa94858840$var$db(a, e);
                d = $acd06eaa94858840$var$db(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $acd06eaa94858840$var$wf);
        }
        $acd06eaa94858840$var$rb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($acd06eaa94858840$var$da.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($acd06eaa94858840$var$da.hasOwnProperty(l) ? (null != k && "onScroll" === l && $acd06eaa94858840$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$acd06eaa94858840$var$Oi = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $acd06eaa94858840$var$Pi(a, b) {
    if (!$acd06eaa94858840$var$N) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $acd06eaa94858840$var$V(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $acd06eaa94858840$var$Qi(a, b, c) {
    var d = b.pendingProps;
    $acd06eaa94858840$var$Wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $acd06eaa94858840$var$V(b), null;
        case 1:
            return $acd06eaa94858840$var$Tf(b.type) && $acd06eaa94858840$var$Uf(), $acd06eaa94858840$var$V(b), null;
        case 3:
            d = b.stateNode;
            $acd06eaa94858840$var$zh();
            $acd06eaa94858840$var$G($acd06eaa94858840$var$Qf);
            $acd06eaa94858840$var$G($acd06eaa94858840$var$I);
            $acd06eaa94858840$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $acd06eaa94858840$var$fh(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $acd06eaa94858840$var$Zg && ($acd06eaa94858840$var$Ri($acd06eaa94858840$var$Zg), $acd06eaa94858840$var$Zg = null));
            $acd06eaa94858840$var$Mi(a, b);
            $acd06eaa94858840$var$V(b);
            return null;
        case 5:
            $acd06eaa94858840$var$Bh(b);
            var e = $acd06eaa94858840$var$xh($acd06eaa94858840$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $acd06eaa94858840$var$Ni(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($acd06eaa94858840$var$p(166));
                    $acd06eaa94858840$var$V(b);
                    return null;
                }
                a = $acd06eaa94858840$var$xh($acd06eaa94858840$var$uh.current);
                if ($acd06eaa94858840$var$fh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$acd06eaa94858840$var$If] = b;
                    d[$acd06eaa94858840$var$Jf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $acd06eaa94858840$var$F("cancel", d);
                            $acd06eaa94858840$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $acd06eaa94858840$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $acd06eaa94858840$var$ff.length; e++)$acd06eaa94858840$var$F($acd06eaa94858840$var$ff[e], d);
                            break;
                        case "source":
                            $acd06eaa94858840$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $acd06eaa94858840$var$F("error", d);
                            $acd06eaa94858840$var$F("load", d);
                            break;
                        case "details":
                            $acd06eaa94858840$var$F("toggle", d);
                            break;
                        case "input":
                            $acd06eaa94858840$var$Xa(d, f);
                            $acd06eaa94858840$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $acd06eaa94858840$var$F("invalid", d);
                            break;
                        case "textarea":
                            $acd06eaa94858840$var$eb(d, f), $acd06eaa94858840$var$F("invalid", d);
                    }
                    $acd06eaa94858840$var$rb(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && ($acd06eaa94858840$var$vf(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && ($acd06eaa94858840$var$vf(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $acd06eaa94858840$var$da.hasOwnProperty(g) && null != h && "onScroll" === g && $acd06eaa94858840$var$F("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $acd06eaa94858840$var$Ta(d);
                            $acd06eaa94858840$var$ab(d, f, !0);
                            break;
                        case "textarea":
                            $acd06eaa94858840$var$Ta(d);
                            $acd06eaa94858840$var$gb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $acd06eaa94858840$var$wf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $acd06eaa94858840$var$hb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$acd06eaa94858840$var$If] = b;
                    a[$acd06eaa94858840$var$Jf] = d;
                    $acd06eaa94858840$var$Li(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $acd06eaa94858840$var$sb(c, d);
                        switch(c){
                            case "dialog":
                                $acd06eaa94858840$var$F("cancel", a);
                                $acd06eaa94858840$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $acd06eaa94858840$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $acd06eaa94858840$var$ff.length; e++)$acd06eaa94858840$var$F($acd06eaa94858840$var$ff[e], a);
                                e = d;
                                break;
                            case "source":
                                $acd06eaa94858840$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $acd06eaa94858840$var$F("error", a);
                                $acd06eaa94858840$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $acd06eaa94858840$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $acd06eaa94858840$var$Xa(a, d);
                                e = $acd06eaa94858840$var$Wa(a, d);
                                $acd06eaa94858840$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $acd06eaa94858840$var$A({}, d, {
                                    value: void 0
                                });
                                $acd06eaa94858840$var$F("invalid", a);
                                break;
                            case "textarea":
                                $acd06eaa94858840$var$eb(a, d);
                                e = $acd06eaa94858840$var$db(a, d);
                                $acd06eaa94858840$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $acd06eaa94858840$var$rb(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $acd06eaa94858840$var$pb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $acd06eaa94858840$var$kb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $acd06eaa94858840$var$lb(a, k) : "number" === typeof k && $acd06eaa94858840$var$lb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($acd06eaa94858840$var$da.hasOwnProperty(f) ? null != k && "onScroll" === f && $acd06eaa94858840$var$F("scroll", a) : null != k && $acd06eaa94858840$var$ra(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $acd06eaa94858840$var$Ta(a);
                                $acd06eaa94858840$var$ab(a, d, !1);
                                break;
                            case "textarea":
                                $acd06eaa94858840$var$Ta(a);
                                $acd06eaa94858840$var$gb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $acd06eaa94858840$var$Qa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $acd06eaa94858840$var$cb(a, !!d.multiple, f, !1) : null != d.defaultValue && $acd06eaa94858840$var$cb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $acd06eaa94858840$var$wf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $acd06eaa94858840$var$V(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $acd06eaa94858840$var$Oi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($acd06eaa94858840$var$p(166));
                c = $acd06eaa94858840$var$xh($acd06eaa94858840$var$wh.current);
                $acd06eaa94858840$var$xh($acd06eaa94858840$var$uh.current);
                if ($acd06eaa94858840$var$fh(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$acd06eaa94858840$var$If] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $acd06eaa94858840$var$Xg, null !== a) switch(g = 0 !== (a.mode & 1), a.tag){
                            case 3:
                                $acd06eaa94858840$var$vf(d.nodeValue, c, g);
                                break;
                            case 5:
                                !0 !== a.memoizedProps[void 0] && $acd06eaa94858840$var$vf(d.nodeValue, c, g);
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$acd06eaa94858840$var$If] = b, b.stateNode = d;
            }
            $acd06eaa94858840$var$V(b);
            return null;
        case 13:
            $acd06eaa94858840$var$G($acd06eaa94858840$var$P);
            d = b.memoizedState;
            if ($acd06eaa94858840$var$N && null !== $acd06eaa94858840$var$Yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                for(d = $acd06eaa94858840$var$Yg; d;)d = $acd06eaa94858840$var$Ff(d.nextSibling);
                $acd06eaa94858840$var$gh();
                b.flags |= 98560;
                return b;
            }
            if (null !== d && null !== d.dehydrated) {
                d = $acd06eaa94858840$var$fh(b);
                if (null === a) {
                    if (!d) throw Error($acd06eaa94858840$var$p(318));
                    d = b.memoizedState;
                    d = null !== d ? d.dehydrated : null;
                    if (!d) throw Error($acd06eaa94858840$var$p(317));
                    d[$acd06eaa94858840$var$If] = b;
                } else $acd06eaa94858840$var$gh(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                $acd06eaa94858840$var$V(b);
                return null;
            }
            null !== $acd06eaa94858840$var$Zg && ($acd06eaa94858840$var$Ri($acd06eaa94858840$var$Zg), $acd06eaa94858840$var$Zg = null);
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? $acd06eaa94858840$var$fh(b) : c = null !== a.memoizedState;
            d && !c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($acd06eaa94858840$var$P.current & 1) ? 0 === $acd06eaa94858840$var$W && ($acd06eaa94858840$var$W = 3) : $acd06eaa94858840$var$Si()));
            null !== b.updateQueue && (b.flags |= 4);
            $acd06eaa94858840$var$V(b);
            return null;
        case 4:
            return $acd06eaa94858840$var$zh(), $acd06eaa94858840$var$Mi(a, b), null === a && $acd06eaa94858840$var$nf(b.stateNode.containerInfo), $acd06eaa94858840$var$V(b), null;
        case 10:
            return $acd06eaa94858840$var$lg(b.type._context), $acd06eaa94858840$var$V(b), null;
        case 17:
            return $acd06eaa94858840$var$Tf(b.type) && $acd06eaa94858840$var$Uf(), $acd06eaa94858840$var$V(b), null;
        case 19:
            $acd06eaa94858840$var$G($acd06eaa94858840$var$P);
            f = b.memoizedState;
            if (null === f) return $acd06eaa94858840$var$V(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $acd06eaa94858840$var$Pi(f, !1);
                else {
                    if (0 !== $acd06eaa94858840$var$W || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $acd06eaa94858840$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $acd06eaa94858840$var$Pi(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $acd06eaa94858840$var$H($acd06eaa94858840$var$P, $acd06eaa94858840$var$P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $acd06eaa94858840$var$D() > $acd06eaa94858840$var$Ti && (b.flags |= 128, d = !0, $acd06eaa94858840$var$Pi(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $acd06eaa94858840$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $acd06eaa94858840$var$Pi(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$acd06eaa94858840$var$N) return $acd06eaa94858840$var$V(b), null;
                    } else 2 * $acd06eaa94858840$var$D() - f.renderingStartTime > $acd06eaa94858840$var$Ti && 1073741824 !== c && (b.flags |= 128, d = !0, $acd06eaa94858840$var$Pi(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $acd06eaa94858840$var$D(), b.sibling = null, c = $acd06eaa94858840$var$P.current, $acd06eaa94858840$var$H($acd06eaa94858840$var$P, d ? c & 1 | 2 : c & 1), b;
            $acd06eaa94858840$var$V(b);
            return null;
        case 22:
        case 23:
            return $acd06eaa94858840$var$Ui(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($acd06eaa94858840$var$Vi & 1073741824) && ($acd06eaa94858840$var$V(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $acd06eaa94858840$var$V(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($acd06eaa94858840$var$p(156, b.tag));
}
var $acd06eaa94858840$var$Wi = $acd06eaa94858840$var$sa.ReactCurrentOwner, $acd06eaa94858840$var$og = !1;
function $acd06eaa94858840$var$Xi(a, b, c, d) {
    b.child = null === a ? $acd06eaa94858840$var$sh(b, null, c, d) : $acd06eaa94858840$var$rh(b, a.child, c, d);
}
function $acd06eaa94858840$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $acd06eaa94858840$var$ng(b, e);
    d = $acd06eaa94858840$var$Nh(a, b, c, d, f, e);
    c = $acd06eaa94858840$var$Sh();
    if (null !== a && !$acd06eaa94858840$var$og) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $acd06eaa94858840$var$Zi(a, b, e);
    $acd06eaa94858840$var$N && c && $acd06eaa94858840$var$Vg(b);
    b.flags |= 1;
    $acd06eaa94858840$var$Xi(a, b, d, e);
    return b.child;
}
function $acd06eaa94858840$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$acd06eaa94858840$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $acd06eaa94858840$var$bj(a, b, f, d, e);
        a = $acd06eaa94858840$var$oh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $acd06eaa94858840$var$De;
        if (c(g, d) && a.ref === b.ref) return $acd06eaa94858840$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $acd06eaa94858840$var$mh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $acd06eaa94858840$var$bj(a, b, c, d, e) {
    if (null !== a && $acd06eaa94858840$var$De(a.memoizedProps, d) && a.ref === b.ref) {
        if ($acd06eaa94858840$var$og = !1, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($acd06eaa94858840$var$og = !0);
        else return b.lanes = a.lanes, $acd06eaa94858840$var$Zi(a, b, e);
    }
    return $acd06eaa94858840$var$cj(a, b, c, d, e);
}
function $acd06eaa94858840$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, $acd06eaa94858840$var$H($acd06eaa94858840$var$ej, $acd06eaa94858840$var$Vi), $acd06eaa94858840$var$Vi |= c;
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, d = null !== f ? f.baseLanes : c, $acd06eaa94858840$var$H($acd06eaa94858840$var$ej, $acd06eaa94858840$var$Vi), $acd06eaa94858840$var$Vi |= d;
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a,
            cachePool: null
        }, b.updateQueue = null, $acd06eaa94858840$var$H($acd06eaa94858840$var$ej, $acd06eaa94858840$var$Vi), $acd06eaa94858840$var$Vi |= a, null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $acd06eaa94858840$var$H($acd06eaa94858840$var$ej, $acd06eaa94858840$var$Vi), $acd06eaa94858840$var$Vi |= d;
    $acd06eaa94858840$var$Xi(a, b, e, c);
    return b.child;
}
function $acd06eaa94858840$var$fj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $acd06eaa94858840$var$cj(a, b, c, d, e) {
    var f = $acd06eaa94858840$var$Tf(c) ? $acd06eaa94858840$var$Rf : $acd06eaa94858840$var$I.current;
    f = $acd06eaa94858840$var$Sf(b, f);
    $acd06eaa94858840$var$ng(b, e);
    c = $acd06eaa94858840$var$Nh(a, b, c, d, f, e);
    d = $acd06eaa94858840$var$Sh();
    if (null !== a && !$acd06eaa94858840$var$og) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $acd06eaa94858840$var$Zi(a, b, e);
    $acd06eaa94858840$var$N && d && $acd06eaa94858840$var$Vg(b);
    b.flags |= 1;
    $acd06eaa94858840$var$Xi(a, b, c, e);
    return b.child;
}
function $acd06eaa94858840$var$gj(a, b, c, d, e) {
    if ($acd06eaa94858840$var$Tf(c)) {
        var f = !0;
        $acd06eaa94858840$var$Xf(b);
    } else f = !1;
    $acd06eaa94858840$var$ng(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $acd06eaa94858840$var$Hg(b, c, d), $acd06eaa94858840$var$Jg(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $acd06eaa94858840$var$pg(l) : (l = $acd06eaa94858840$var$Tf(c) ? $acd06eaa94858840$var$Rf : $acd06eaa94858840$var$I.current, l = $acd06eaa94858840$var$Sf(b, l));
        var m = c.getDerivedStateFromProps, w = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        w || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $acd06eaa94858840$var$Ig(b, g, d, l);
        $acd06eaa94858840$var$rg = !1;
        var u = b.memoizedState;
        g.state = u;
        $acd06eaa94858840$var$yg(b, d, g, e);
        k = b.memoizedState;
        h !== d || u !== k || $acd06eaa94858840$var$Qf.current || $acd06eaa94858840$var$rg ? ("function" === typeof m && ($acd06eaa94858840$var$Cg(b, c, m, d), k = b.memoizedState), (h = $acd06eaa94858840$var$rg || $acd06eaa94858840$var$Gg(b, c, h, d, u, k, l)) ? (w || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $acd06eaa94858840$var$tg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $acd06eaa94858840$var$fg(b.type, h);
        g.props = l;
        w = b.pendingProps;
        u = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $acd06eaa94858840$var$pg(k) : (k = $acd06eaa94858840$var$Tf(c) ? $acd06eaa94858840$var$Rf : $acd06eaa94858840$var$I.current, k = $acd06eaa94858840$var$Sf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== w || u !== k) && $acd06eaa94858840$var$Ig(b, g, d, k);
        $acd06eaa94858840$var$rg = !1;
        u = b.memoizedState;
        g.state = u;
        $acd06eaa94858840$var$yg(b, d, g, e);
        var n = b.memoizedState;
        h !== w || u !== n || $acd06eaa94858840$var$Qf.current || $acd06eaa94858840$var$rg ? ("function" === typeof y && ($acd06eaa94858840$var$Cg(b, c, y, d), n = b.memoizedState), (l = $acd06eaa94858840$var$rg || $acd06eaa94858840$var$Gg(b, c, l, d, u, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && u === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && u === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && u === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && u === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $acd06eaa94858840$var$hj(a, b, c, d, f, e);
}
function $acd06eaa94858840$var$hj(a, b, c, d, e, f) {
    $acd06eaa94858840$var$fj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $acd06eaa94858840$var$Yf(b, c, !1), $acd06eaa94858840$var$Zi(a, b, f);
    d = b.stateNode;
    $acd06eaa94858840$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $acd06eaa94858840$var$rh(b, a.child, null, f), b.child = $acd06eaa94858840$var$rh(b, null, h, f)) : $acd06eaa94858840$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $acd06eaa94858840$var$Yf(b, c, !0);
    return b.child;
}
function $acd06eaa94858840$var$ij(a) {
    var b = a.stateNode;
    b.pendingContext ? $acd06eaa94858840$var$Vf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $acd06eaa94858840$var$Vf(a, b.context, !1);
    $acd06eaa94858840$var$yh(a, b.containerInfo);
}
function $acd06eaa94858840$var$jj(a, b, c, d, e) {
    $acd06eaa94858840$var$gh();
    $acd06eaa94858840$var$hh(e);
    b.flags |= 256;
    $acd06eaa94858840$var$Xi(a, b, c, d);
    return b.child;
}
var $acd06eaa94858840$var$kj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $acd06eaa94858840$var$lj(a) {
    return {
        baseLanes: a,
        cachePool: null
    };
}
function $acd06eaa94858840$var$mj(a, b, c) {
    var d = b.pendingProps, e = $acd06eaa94858840$var$P.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $acd06eaa94858840$var$H($acd06eaa94858840$var$P, e & 1);
    if (null === a) {
        $acd06eaa94858840$var$dh(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        e = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, e = {
            mode: "hidden",
            children: e
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = $acd06eaa94858840$var$nj(e, d, 0, null), a = $acd06eaa94858840$var$qh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $acd06eaa94858840$var$lj(c), b.memoizedState = $acd06eaa94858840$var$kj, a) : $acd06eaa94858840$var$oj(b, e);
    }
    e = a.memoizedState;
    if (null !== e) {
        h = e.dehydrated;
        if (null !== h) {
            if (g) {
                if (b.flags & 256) return b.flags &= -257, $acd06eaa94858840$var$pj(a, b, c, Error($acd06eaa94858840$var$p(422)));
                if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                f = d.fallback;
                e = b.mode;
                d = $acd06eaa94858840$var$nj({
                    mode: "visible",
                    children: d.children
                }, e, 0, null);
                f = $acd06eaa94858840$var$qh(f, e, c, null);
                f.flags |= 2;
                d.return = b;
                f.return = b;
                d.sibling = f;
                b.child = d;
                0 !== (b.mode & 1) && $acd06eaa94858840$var$rh(b, a.child, null, c);
                b.child.memoizedState = $acd06eaa94858840$var$lj(c);
                b.memoizedState = $acd06eaa94858840$var$kj;
                return f;
            }
            if (0 === (b.mode & 1)) b = $acd06eaa94858840$var$pj(a, b, c, null);
            else if ("$!" === h.data) b = $acd06eaa94858840$var$pj(a, b, c, Error($acd06eaa94858840$var$p(419)));
            else if (d = 0 !== (c & a.childLanes), $acd06eaa94858840$var$og || d) {
                d = $acd06eaa94858840$var$J;
                if (null !== d) {
                    switch(c & -c){
                        case 4:
                            f = 2;
                            break;
                        case 16:
                            f = 8;
                            break;
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                        case 67108864:
                            f = 32;
                            break;
                        case 536870912:
                            f = 268435456;
                            break;
                        default:
                            f = 0;
                    }
                    d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                    0 !== d && d !== e.retryLane && (e.retryLane = d, $acd06eaa94858840$var$Eg(a, d, -1));
                }
                $acd06eaa94858840$var$Si();
                b = $acd06eaa94858840$var$pj(a, b, c, Error($acd06eaa94858840$var$p(421)));
            } else "$?" === h.data ? (b.flags |= 128, b.child = a.child, b = $acd06eaa94858840$var$qj.bind(null, a), h._reactRetry = b, b = null) : (c = e.treeContext, $acd06eaa94858840$var$Yg = $acd06eaa94858840$var$Ff(h.nextSibling), $acd06eaa94858840$var$Xg = b, $acd06eaa94858840$var$N = !0, $acd06eaa94858840$var$Zg = null, null !== c && ($acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg++] = $acd06eaa94858840$var$Rg, $acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg++] = $acd06eaa94858840$var$Sg, $acd06eaa94858840$var$Og[$acd06eaa94858840$var$Pg++] = $acd06eaa94858840$var$Qg, $acd06eaa94858840$var$Rg = c.id, $acd06eaa94858840$var$Sg = c.overflow, $acd06eaa94858840$var$Qg = b), b = $acd06eaa94858840$var$oj(b, b.pendingProps.children), b.flags |= 4096);
            return b;
        }
        if (f) return d = $acd06eaa94858840$var$rj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? $acd06eaa94858840$var$lj(c) : {
            baseLanes: e.baseLanes | c,
            cachePool: null
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = $acd06eaa94858840$var$kj, d;
        c = $acd06eaa94858840$var$sj(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $acd06eaa94858840$var$rj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? $acd06eaa94858840$var$lj(c) : {
        baseLanes: e.baseLanes | c,
        cachePool: null
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = $acd06eaa94858840$var$kj, d;
    c = $acd06eaa94858840$var$sj(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $acd06eaa94858840$var$oj(a, b) {
    b = $acd06eaa94858840$var$nj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $acd06eaa94858840$var$sj(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $acd06eaa94858840$var$mh(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 1) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (d = b.deletions, null === d ? (b.deletions = [
        a
    ], b.flags |= 16) : d.push(a));
    return b.child = c;
}
function $acd06eaa94858840$var$rj(a, b, c, d, e) {
    var f = b.mode;
    a = a.child;
    var g = a.sibling, h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = $acd06eaa94858840$var$mh(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
    null !== g ? d = $acd06eaa94858840$var$mh(g, d) : (d = $acd06eaa94858840$var$qh(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $acd06eaa94858840$var$pj(a, b, c, d) {
    null !== d && $acd06eaa94858840$var$hh(d);
    $acd06eaa94858840$var$rh(b, a.child, null, c);
    a = $acd06eaa94858840$var$oj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $acd06eaa94858840$var$tj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $acd06eaa94858840$var$mg(a.return, b, c);
}
function $acd06eaa94858840$var$uj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $acd06eaa94858840$var$vj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $acd06eaa94858840$var$Xi(a, b, d.children, c);
    d = $acd06eaa94858840$var$P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $acd06eaa94858840$var$tj(a, c, b);
            else if (19 === a.tag) $acd06eaa94858840$var$tj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $acd06eaa94858840$var$H($acd06eaa94858840$var$P, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $acd06eaa94858840$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $acd06eaa94858840$var$uj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $acd06eaa94858840$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $acd06eaa94858840$var$uj(b, !0, c, null, f);
            break;
        case "together":
            $acd06eaa94858840$var$uj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $acd06eaa94858840$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $acd06eaa94858840$var$zg |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($acd06eaa94858840$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $acd06eaa94858840$var$mh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $acd06eaa94858840$var$mh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $acd06eaa94858840$var$wj(a, b, c) {
    switch(b.tag){
        case 3:
            $acd06eaa94858840$var$ij(b);
            $acd06eaa94858840$var$gh();
            break;
        case 5:
            $acd06eaa94858840$var$Ah(b);
            break;
        case 1:
            $acd06eaa94858840$var$Tf(b.type) && $acd06eaa94858840$var$Xf(b);
            break;
        case 4:
            $acd06eaa94858840$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $acd06eaa94858840$var$H($acd06eaa94858840$var$gg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $acd06eaa94858840$var$H($acd06eaa94858840$var$P, $acd06eaa94858840$var$P.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $acd06eaa94858840$var$mj(a, b, c);
                $acd06eaa94858840$var$H($acd06eaa94858840$var$P, $acd06eaa94858840$var$P.current & 1);
                a = $acd06eaa94858840$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $acd06eaa94858840$var$H($acd06eaa94858840$var$P, $acd06eaa94858840$var$P.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $acd06eaa94858840$var$vj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $acd06eaa94858840$var$H($acd06eaa94858840$var$P, $acd06eaa94858840$var$P.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $acd06eaa94858840$var$dj(a, b, c);
    }
    return $acd06eaa94858840$var$Zi(a, b, c);
}
function $acd06eaa94858840$var$xj(a, b) {
    $acd06eaa94858840$var$Wg(b);
    switch(b.tag){
        case 1:
            return $acd06eaa94858840$var$Tf(b.type) && $acd06eaa94858840$var$Uf(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $acd06eaa94858840$var$zh(), $acd06eaa94858840$var$G($acd06eaa94858840$var$Qf), $acd06eaa94858840$var$G($acd06eaa94858840$var$I), $acd06eaa94858840$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $acd06eaa94858840$var$Bh(b), null;
        case 13:
            $acd06eaa94858840$var$G($acd06eaa94858840$var$P);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($acd06eaa94858840$var$p(340));
                $acd06eaa94858840$var$gh();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $acd06eaa94858840$var$G($acd06eaa94858840$var$P), null;
        case 4:
            return $acd06eaa94858840$var$zh(), null;
        case 10:
            return $acd06eaa94858840$var$lg(b.type._context), null;
        case 22:
        case 23:
            return $acd06eaa94858840$var$Ui(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $acd06eaa94858840$var$yj = !1, $acd06eaa94858840$var$zj = !1, $acd06eaa94858840$var$Aj = "function" === typeof WeakSet ? WeakSet : Set, $acd06eaa94858840$var$X = null;
function $acd06eaa94858840$var$Bj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $acd06eaa94858840$var$Cj(a, b, d);
        }
        else c.current = null;
    }
}
function $acd06eaa94858840$var$Dj(a, b, c) {
    try {
        c();
    } catch (d) {
        $acd06eaa94858840$var$Cj(a, b, d);
    }
}
var $acd06eaa94858840$var$Ej = !1;
function $acd06eaa94858840$var$Fj(a, b) {
    a = $acd06eaa94858840$var$He();
    if ($acd06eaa94858840$var$Ie(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (O) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, w = a, u = null;
                b: for(;;){
                    for(var y;;){
                        w !== c || 0 !== e && 3 !== w.nodeType || (h = g + e);
                        w !== f || 0 !== d && 3 !== w.nodeType || (k = g + d);
                        3 === w.nodeType && (g += w.nodeValue.length);
                        if (null === (y = w.firstChild)) break;
                        u = w;
                        w = y;
                    }
                    for(;;){
                        if (w === a) break b;
                        u === c && ++l === e && (h = g);
                        u === f && ++m === d && (k = g);
                        if (null !== (y = w.nextSibling)) break;
                        w = u;
                        u = w.parentNode;
                    }
                    w = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $acd06eaa94858840$var$xf = {
        focusedElem: a,
        selectionRange: c
    };
    for($acd06eaa94858840$var$X = b; null !== $acd06eaa94858840$var$X;)if (b = $acd06eaa94858840$var$X, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $acd06eaa94858840$var$X = a;
    else for(; null !== $acd06eaa94858840$var$X;){
        b = $acd06eaa94858840$var$X;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var v = n.memoizedProps, C = n.memoizedState, t = b.stateNode, r = t.getSnapshotBeforeUpdate(b.elementType === b.type ? v : $acd06eaa94858840$var$fg(b.type, v), C);
                        t.__reactInternalSnapshotBeforeUpdate = r;
                    }
                    break;
                case 3:
                    var x = b.stateNode.containerInfo;
                    if (1 === x.nodeType) x.textContent = "";
                    else if (9 === x.nodeType) {
                        var B = x.body;
                        null != B && (B.textContent = "");
                    }
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($acd06eaa94858840$var$p(163));
            }
        } catch (O) {
            $acd06eaa94858840$var$Cj(b, b.return, O);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $acd06eaa94858840$var$X = a;
            break;
        }
        $acd06eaa94858840$var$X = b.return;
    }
    n = $acd06eaa94858840$var$Ej;
    $acd06eaa94858840$var$Ej = !1;
    return n;
}
function $acd06eaa94858840$var$Gj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $acd06eaa94858840$var$Dj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $acd06eaa94858840$var$Hj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $acd06eaa94858840$var$Ij(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $acd06eaa94858840$var$Jj(a, b, c) {
    if ($acd06eaa94858840$var$ic && "function" === typeof $acd06eaa94858840$var$ic.onCommitFiberUnmount) try {
        $acd06eaa94858840$var$ic.onCommitFiberUnmount($acd06eaa94858840$var$hc, b);
    } catch (g) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a = a.next;
                do {
                    var e = d, f = e.destroy;
                    e = e.tag;
                    void 0 !== f && (0 !== (e & 2) ? $acd06eaa94858840$var$Dj(b, c, f) : 0 !== (e & 4) && $acd06eaa94858840$var$Dj(b, c, f));
                    d = d.next;
                }while (d !== a);
            }
            break;
        case 1:
            $acd06eaa94858840$var$Bj(b, c);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (g) {
                $acd06eaa94858840$var$Cj(b, c, g);
            }
            break;
        case 5:
            $acd06eaa94858840$var$Bj(b, c);
            break;
        case 4:
            $acd06eaa94858840$var$Kj(a, b, c);
    }
}
function $acd06eaa94858840$var$Lj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $acd06eaa94858840$var$Lj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$acd06eaa94858840$var$If], delete b[$acd06eaa94858840$var$Jf], delete b[$acd06eaa94858840$var$jf], delete b[$acd06eaa94858840$var$Kf], delete b[$acd06eaa94858840$var$Lf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $acd06eaa94858840$var$Mj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $acd06eaa94858840$var$Nj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $acd06eaa94858840$var$Mj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $acd06eaa94858840$var$Oj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($acd06eaa94858840$var$Mj(b)) break a;
            b = b.return;
        }
        throw Error($acd06eaa94858840$var$p(160));
    }
    var c = b;
    switch(c.tag){
        case 5:
            b = c.stateNode;
            c.flags & 32 && ($acd06eaa94858840$var$lb(b, ""), c.flags &= -33);
            c = $acd06eaa94858840$var$Nj(a);
            $acd06eaa94858840$var$Pj(a, c, b);
            break;
        case 3:
        case 4:
            b = c.stateNode.containerInfo;
            c = $acd06eaa94858840$var$Nj(a);
            $acd06eaa94858840$var$Qj(a, c, b);
            break;
        default:
            throw Error($acd06eaa94858840$var$p(161));
    }
}
function $acd06eaa94858840$var$Qj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $acd06eaa94858840$var$wf));
    else if (4 !== d && (a = a.child, null !== a)) for($acd06eaa94858840$var$Qj(a, b, c), a = a.sibling; null !== a;)$acd06eaa94858840$var$Qj(a, b, c), a = a.sibling;
}
function $acd06eaa94858840$var$Pj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($acd06eaa94858840$var$Pj(a, b, c), a = a.sibling; null !== a;)$acd06eaa94858840$var$Pj(a, b, c), a = a.sibling;
}
function $acd06eaa94858840$var$Kj(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error($acd06eaa94858840$var$p(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if ($acd06eaa94858840$var$Jj(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (18 === d.tag) g ? (h = f, k = d.stateNode, 8 === h.nodeType ? $acd06eaa94858840$var$Ef(h.parentNode, k) : 1 === h.nodeType && $acd06eaa94858840$var$Ef(h, k), $acd06eaa94858840$var$Yc(h)) : $acd06eaa94858840$var$Ef(f, d.stateNode);
        else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if ($acd06eaa94858840$var$Jj(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function $acd06eaa94858840$var$Rj(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $acd06eaa94858840$var$Gj(3, b, b.return);
            $acd06eaa94858840$var$Hj(3, b);
            $acd06eaa94858840$var$Gj(5, b, b.return);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    "input" === a && "radio" === d.type && null != d.name && $acd06eaa94858840$var$Ya(c, d);
                    $acd06eaa94858840$var$sb(a, e);
                    b = $acd06eaa94858840$var$sb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $acd06eaa94858840$var$pb(c, h) : "dangerouslySetInnerHTML" === g ? $acd06eaa94858840$var$kb(c, h) : "children" === g ? $acd06eaa94858840$var$lb(c, h) : $acd06eaa94858840$var$ra(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $acd06eaa94858840$var$Za(c, d);
                            break;
                        case "textarea":
                            $acd06eaa94858840$var$fb(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? $acd06eaa94858840$var$cb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? $acd06eaa94858840$var$cb(c, !!d.multiple, d.defaultValue, !0) : $acd06eaa94858840$var$cb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                    c[$acd06eaa94858840$var$Jf] = d;
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($acd06eaa94858840$var$p(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            null !== a && a.memoizedState.isDehydrated && $acd06eaa94858840$var$Yc(b.stateNode.containerInfo);
            return;
        case 12:
            return;
        case 13:
            $acd06eaa94858840$var$Sj(b);
            return;
        case 19:
            $acd06eaa94858840$var$Sj(b);
            return;
        case 17:
            return;
    }
    throw Error($acd06eaa94858840$var$p(163));
}
function $acd06eaa94858840$var$Sj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $acd06eaa94858840$var$Aj);
        b.forEach(function(b) {
            var d = $acd06eaa94858840$var$Tj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $acd06eaa94858840$var$Uj(a, b) {
    for($acd06eaa94858840$var$X = b; null !== $acd06eaa94858840$var$X;){
        b = $acd06eaa94858840$var$X;
        var c = b.deletions;
        if (null !== c) for(var d = 0; d < c.length; d++){
            var e = c[d];
            try {
                $acd06eaa94858840$var$Kj(a, e, b);
                var f = e.alternate;
                null !== f && (f.return = null);
                e.return = null;
            } catch (L) {
                $acd06eaa94858840$var$Cj(e, b, L);
            }
        }
        c = b.child;
        if (0 !== (b.subtreeFlags & 12854) && null !== c) c.return = b, $acd06eaa94858840$var$X = c;
        else for(; null !== $acd06eaa94858840$var$X;){
            b = $acd06eaa94858840$var$X;
            try {
                var g = b.flags;
                g & 32 && $acd06eaa94858840$var$lb(b.stateNode, "");
                if (g & 512) {
                    var h = b.alternate;
                    if (null !== h) {
                        var k = h.ref;
                        null !== k && ("function" === typeof k ? k(null) : k.current = null);
                    }
                }
                if (g & 8192) switch(b.tag){
                    case 13:
                        if (null !== b.memoizedState) {
                            var l = b.alternate;
                            if (null === l || null === l.memoizedState) $acd06eaa94858840$var$Vj = $acd06eaa94858840$var$D();
                        }
                        break;
                    case 22:
                        var m = null !== b.memoizedState, w = b.alternate, u = null !== w && null !== w.memoizedState;
                        c = b;
                        a: {
                            d = c;
                            e = m;
                            for(var y = null, n = d;;){
                                if (5 === n.tag) {
                                    if (null === y) {
                                        y = n;
                                        var v = n.stateNode;
                                        if (e) {
                                            var C = v.style;
                                            "function" === typeof C.setProperty ? C.setProperty("display", "none", "important") : C.display = "none";
                                        } else {
                                            var t = n.stateNode, r = n.memoizedProps.style, x = void 0 !== r && null !== r && r.hasOwnProperty("display") ? r.display : null;
                                            t.style.display = $acd06eaa94858840$var$ob("display", x);
                                        }
                                    }
                                } else if (6 === n.tag) null === y && (n.stateNode.nodeValue = e ? "" : n.memoizedProps);
                                else if ((22 !== n.tag && 23 !== n.tag || null === n.memoizedState || n === d) && null !== n.child) {
                                    n.child.return = n;
                                    n = n.child;
                                    continue;
                                }
                                if (n === d) break;
                                for(; null === n.sibling;){
                                    if (null === n.return || n.return === d) break a;
                                    y === n && (y = null);
                                    n = n.return;
                                }
                                y === n && (y = null);
                                n.sibling.return = n.return;
                                n = n.sibling;
                            }
                        }
                        if (m && !u && 0 !== (c.mode & 1)) {
                            $acd06eaa94858840$var$X = c;
                            for(var B = c.child; null !== B;){
                                for(c = $acd06eaa94858840$var$X = B; null !== $acd06eaa94858840$var$X;){
                                    d = $acd06eaa94858840$var$X;
                                    var O = d.child;
                                    switch(d.tag){
                                        case 0:
                                        case 11:
                                        case 14:
                                        case 15:
                                            $acd06eaa94858840$var$Gj(4, d, d.return);
                                            break;
                                        case 1:
                                            $acd06eaa94858840$var$Bj(d, d.return);
                                            var T = d.stateNode;
                                            if ("function" === typeof T.componentWillUnmount) {
                                                var za = d.return;
                                                try {
                                                    T.props = d.memoizedProps, T.state = d.memoizedState, T.componentWillUnmount();
                                                } catch (L) {
                                                    $acd06eaa94858840$var$Cj(d, za, L);
                                                }
                                            }
                                            break;
                                        case 5:
                                            $acd06eaa94858840$var$Bj(d, d.return);
                                            break;
                                        case 22:
                                            if (null !== d.memoizedState) {
                                                $acd06eaa94858840$var$Wj(c);
                                                continue;
                                            }
                                    }
                                    null !== O ? (O.return = d, $acd06eaa94858840$var$X = O) : $acd06eaa94858840$var$Wj(c);
                                }
                                B = B.sibling;
                            }
                        }
                }
                switch(g & 4102){
                    case 2:
                        $acd06eaa94858840$var$Oj(b);
                        b.flags &= -3;
                        break;
                    case 6:
                        $acd06eaa94858840$var$Oj(b);
                        b.flags &= -3;
                        $acd06eaa94858840$var$Rj(b.alternate, b);
                        break;
                    case 4096:
                        b.flags &= -4097;
                        break;
                    case 4100:
                        b.flags &= -4097;
                        $acd06eaa94858840$var$Rj(b.alternate, b);
                        break;
                    case 4:
                        $acd06eaa94858840$var$Rj(b.alternate, b);
                }
            } catch (L) {
                $acd06eaa94858840$var$Cj(b, b.return, L);
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                $acd06eaa94858840$var$X = c;
                break;
            }
            $acd06eaa94858840$var$X = b.return;
        }
    }
}
function $acd06eaa94858840$var$Xj(a, b, c) {
    $acd06eaa94858840$var$X = a;
    $acd06eaa94858840$var$Yj(a, b, c);
}
function $acd06eaa94858840$var$Yj(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $acd06eaa94858840$var$X;){
        var e = $acd06eaa94858840$var$X, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $acd06eaa94858840$var$yj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $acd06eaa94858840$var$zj;
                h = $acd06eaa94858840$var$yj;
                var l = $acd06eaa94858840$var$zj;
                $acd06eaa94858840$var$yj = g;
                if (($acd06eaa94858840$var$zj = k) && !l) for($acd06eaa94858840$var$X = e; null !== $acd06eaa94858840$var$X;)g = $acd06eaa94858840$var$X, k = g.child, 22 === g.tag && null !== g.memoizedState ? $acd06eaa94858840$var$Zj(e) : null !== k ? (k.return = g, $acd06eaa94858840$var$X = k) : $acd06eaa94858840$var$Zj(e);
                for(; null !== f;)$acd06eaa94858840$var$X = f, $acd06eaa94858840$var$Yj(f, b, c), f = f.sibling;
                $acd06eaa94858840$var$X = e;
                $acd06eaa94858840$var$yj = h;
                $acd06eaa94858840$var$zj = l;
            }
            $acd06eaa94858840$var$ak(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $acd06eaa94858840$var$X = f) : $acd06eaa94858840$var$ak(a, b, c);
    }
}
function $acd06eaa94858840$var$ak(a) {
    for(; null !== $acd06eaa94858840$var$X;){
        var b = $acd06eaa94858840$var$X;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $acd06eaa94858840$var$zj || $acd06eaa94858840$var$Hj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$acd06eaa94858840$var$zj) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $acd06eaa94858840$var$fg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $acd06eaa94858840$var$Ag(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $acd06eaa94858840$var$Ag(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var w = m.dehydrated;
                                    null !== w && $acd06eaa94858840$var$Yc(w);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                        break;
                    default:
                        throw Error($acd06eaa94858840$var$p(163));
                }
                $acd06eaa94858840$var$zj || b.flags & 512 && $acd06eaa94858840$var$Ij(b);
            } catch (u) {
                $acd06eaa94858840$var$Cj(b, b.return, u);
            }
        }
        if (b === a) {
            $acd06eaa94858840$var$X = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $acd06eaa94858840$var$X = c;
            break;
        }
        $acd06eaa94858840$var$X = b.return;
    }
}
function $acd06eaa94858840$var$Wj(a) {
    for(; null !== $acd06eaa94858840$var$X;){
        var b = $acd06eaa94858840$var$X;
        if (b === a) {
            $acd06eaa94858840$var$X = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $acd06eaa94858840$var$X = c;
            break;
        }
        $acd06eaa94858840$var$X = b.return;
    }
}
function $acd06eaa94858840$var$Zj(a) {
    for(; null !== $acd06eaa94858840$var$X;){
        var b = $acd06eaa94858840$var$X;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $acd06eaa94858840$var$Hj(4, b);
                    } catch (k) {
                        $acd06eaa94858840$var$Cj(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $acd06eaa94858840$var$Cj(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $acd06eaa94858840$var$Ij(b);
                    } catch (k) {
                        $acd06eaa94858840$var$Cj(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $acd06eaa94858840$var$Ij(b);
                    } catch (k) {
                        $acd06eaa94858840$var$Cj(b, g, k);
                    }
            }
        } catch (k) {
            $acd06eaa94858840$var$Cj(b, b.return, k);
        }
        if (b === a) {
            $acd06eaa94858840$var$X = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $acd06eaa94858840$var$X = h;
            break;
        }
        $acd06eaa94858840$var$X = b.return;
    }
}
var $acd06eaa94858840$var$bk = Math.ceil, $acd06eaa94858840$var$ck = $acd06eaa94858840$var$sa.ReactCurrentDispatcher, $acd06eaa94858840$var$dk = $acd06eaa94858840$var$sa.ReactCurrentOwner, $acd06eaa94858840$var$ek = $acd06eaa94858840$var$sa.ReactCurrentBatchConfig, $acd06eaa94858840$var$K = 0, $acd06eaa94858840$var$J = null, $acd06eaa94858840$var$Y = null, $acd06eaa94858840$var$Z = 0, $acd06eaa94858840$var$Vi = 0, $acd06eaa94858840$var$ej = $acd06eaa94858840$var$Of(0), $acd06eaa94858840$var$W = 0, $acd06eaa94858840$var$fk = null, $acd06eaa94858840$var$zg = 0, $acd06eaa94858840$var$gk = 0, $acd06eaa94858840$var$hk = 0, $acd06eaa94858840$var$ik = null, $acd06eaa94858840$var$jk = null, $acd06eaa94858840$var$Vj = 0, $acd06eaa94858840$var$Ti = Infinity, $acd06eaa94858840$var$Di = !1, $acd06eaa94858840$var$Ei = null, $acd06eaa94858840$var$Gi = null, $acd06eaa94858840$var$kk = !1, $acd06eaa94858840$var$lk = null, $acd06eaa94858840$var$mk = 0, $acd06eaa94858840$var$nk = 0, $acd06eaa94858840$var$ok = null, $acd06eaa94858840$var$pk = -1, $acd06eaa94858840$var$qk = 0;
function $acd06eaa94858840$var$M() {
    return 0 !== ($acd06eaa94858840$var$K & 6) ? $acd06eaa94858840$var$D() : -1 !== $acd06eaa94858840$var$pk ? $acd06eaa94858840$var$pk : $acd06eaa94858840$var$pk = $acd06eaa94858840$var$D();
}
function $acd06eaa94858840$var$Dg(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($acd06eaa94858840$var$K & 2) && 0 !== $acd06eaa94858840$var$Z) return $acd06eaa94858840$var$Z & -$acd06eaa94858840$var$Z;
    if (null !== $acd06eaa94858840$var$eg.transition) return 0 === $acd06eaa94858840$var$qk && (a = $acd06eaa94858840$var$oc, $acd06eaa94858840$var$oc <<= 1, 0 === ($acd06eaa94858840$var$oc & 4194240) && ($acd06eaa94858840$var$oc = 64), $acd06eaa94858840$var$qk = a), $acd06eaa94858840$var$qk;
    a = $acd06eaa94858840$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $acd06eaa94858840$var$ed(a.type);
    return a;
}
function $acd06eaa94858840$var$Eg(a, b, c) {
    if (50 < $acd06eaa94858840$var$nk) throw $acd06eaa94858840$var$nk = 0, $acd06eaa94858840$var$ok = null, Error($acd06eaa94858840$var$p(185));
    var d = $acd06eaa94858840$var$rk(a, b);
    if (null === d) return null;
    $acd06eaa94858840$var$wc(d, b, c);
    if (0 === ($acd06eaa94858840$var$K & 2) || d !== $acd06eaa94858840$var$J) d === $acd06eaa94858840$var$J && (0 === ($acd06eaa94858840$var$K & 2) && ($acd06eaa94858840$var$gk |= b), 4 === $acd06eaa94858840$var$W && $acd06eaa94858840$var$sk(d, $acd06eaa94858840$var$Z)), $acd06eaa94858840$var$tk(d, c), 1 === b && 0 === $acd06eaa94858840$var$K && 0 === (a.mode & 1) && ($acd06eaa94858840$var$Ti = $acd06eaa94858840$var$D() + 500, $acd06eaa94858840$var$$f && $acd06eaa94858840$var$dg());
    return d;
}
function $acd06eaa94858840$var$rk(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $acd06eaa94858840$var$tk(a, b) {
    var c = a.callbackNode;
    $acd06eaa94858840$var$tc(a, b);
    var d = $acd06eaa94858840$var$rc(a, a === $acd06eaa94858840$var$J ? $acd06eaa94858840$var$Z : 0);
    if (0 === d) null !== c && $acd06eaa94858840$var$Zb(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $acd06eaa94858840$var$Zb(c);
        if (1 === b) 0 === a.tag ? $acd06eaa94858840$var$cg($acd06eaa94858840$var$uk.bind(null, a)) : $acd06eaa94858840$var$bg($acd06eaa94858840$var$uk.bind(null, a)), $acd06eaa94858840$var$Df(function() {
            0 === $acd06eaa94858840$var$K && $acd06eaa94858840$var$dg();
        }), c = null;
        else {
            switch($acd06eaa94858840$var$zc(d)){
                case 1:
                    c = $acd06eaa94858840$var$cc;
                    break;
                case 4:
                    c = $acd06eaa94858840$var$dc;
                    break;
                case 16:
                    c = $acd06eaa94858840$var$ec;
                    break;
                case 536870912:
                    c = $acd06eaa94858840$var$gc;
                    break;
                default:
                    c = $acd06eaa94858840$var$ec;
            }
            c = $acd06eaa94858840$var$vk(c, $acd06eaa94858840$var$wk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $acd06eaa94858840$var$wk(a, b) {
    $acd06eaa94858840$var$pk = -1;
    $acd06eaa94858840$var$qk = 0;
    if (0 !== ($acd06eaa94858840$var$K & 6)) throw Error($acd06eaa94858840$var$p(327));
    var c = a.callbackNode;
    if ($acd06eaa94858840$var$xk() && a.callbackNode !== c) return null;
    var d = $acd06eaa94858840$var$rc(a, a === $acd06eaa94858840$var$J ? $acd06eaa94858840$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $acd06eaa94858840$var$yk(a, d);
    else {
        b = d;
        var e = $acd06eaa94858840$var$K;
        $acd06eaa94858840$var$K |= 2;
        var f = $acd06eaa94858840$var$zk();
        if ($acd06eaa94858840$var$J !== a || $acd06eaa94858840$var$Z !== b) $acd06eaa94858840$var$Ti = $acd06eaa94858840$var$D() + 500, $acd06eaa94858840$var$Ak(a, b);
        for(;;)try {
            $acd06eaa94858840$var$Bk();
            break;
        } catch (h) {
            $acd06eaa94858840$var$Ck(a, h);
        }
        $acd06eaa94858840$var$kg();
        $acd06eaa94858840$var$ck.current = f;
        $acd06eaa94858840$var$K = e;
        null !== $acd06eaa94858840$var$Y ? b = 0 : ($acd06eaa94858840$var$J = null, $acd06eaa94858840$var$Z = 0, b = $acd06eaa94858840$var$W);
    }
    if (0 !== b) {
        2 === b && (e = $acd06eaa94858840$var$uc(a), 0 !== e && (d = e, b = $acd06eaa94858840$var$Dk(a, e)));
        if (1 === b) throw c = $acd06eaa94858840$var$fk, $acd06eaa94858840$var$Ak(a, 0), $acd06eaa94858840$var$sk(a, d), $acd06eaa94858840$var$tk(a, $acd06eaa94858840$var$D()), c;
        if (6 === b) $acd06eaa94858840$var$sk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$acd06eaa94858840$var$Ek(e) && (b = $acd06eaa94858840$var$yk(a, d), 2 === b && (f = $acd06eaa94858840$var$uc(a), 0 !== f && (d = f, b = $acd06eaa94858840$var$Dk(a, f))), 1 === b)) throw c = $acd06eaa94858840$var$fk, $acd06eaa94858840$var$Ak(a, 0), $acd06eaa94858840$var$sk(a, d), $acd06eaa94858840$var$tk(a, $acd06eaa94858840$var$D()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($acd06eaa94858840$var$p(345));
                case 2:
                    $acd06eaa94858840$var$Fk(a, $acd06eaa94858840$var$jk);
                    break;
                case 3:
                    $acd06eaa94858840$var$sk(a, d);
                    if ((d & 130023424) === d && (b = $acd06eaa94858840$var$Vj + 500 - $acd06eaa94858840$var$D(), 10 < b)) {
                        if (0 !== $acd06eaa94858840$var$rc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $acd06eaa94858840$var$M();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $acd06eaa94858840$var$zf($acd06eaa94858840$var$Fk.bind(null, a, $acd06eaa94858840$var$jk), b);
                        break;
                    }
                    $acd06eaa94858840$var$Fk(a, $acd06eaa94858840$var$jk);
                    break;
                case 4:
                    $acd06eaa94858840$var$sk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $acd06eaa94858840$var$lc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $acd06eaa94858840$var$D() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $acd06eaa94858840$var$bk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $acd06eaa94858840$var$zf($acd06eaa94858840$var$Fk.bind(null, a, $acd06eaa94858840$var$jk), d);
                        break;
                    }
                    $acd06eaa94858840$var$Fk(a, $acd06eaa94858840$var$jk);
                    break;
                case 5:
                    $acd06eaa94858840$var$Fk(a, $acd06eaa94858840$var$jk);
                    break;
                default:
                    throw Error($acd06eaa94858840$var$p(329));
            }
        }
    }
    $acd06eaa94858840$var$tk(a, $acd06eaa94858840$var$D());
    return a.callbackNode === c ? $acd06eaa94858840$var$wk.bind(null, a) : null;
}
function $acd06eaa94858840$var$Dk(a, b) {
    var c = $acd06eaa94858840$var$ik;
    a.current.memoizedState.isDehydrated && ($acd06eaa94858840$var$Ak(a, b).flags |= 256);
    a = $acd06eaa94858840$var$yk(a, b);
    2 !== a && (b = $acd06eaa94858840$var$jk, $acd06eaa94858840$var$jk = c, null !== b && $acd06eaa94858840$var$Ri(b));
    return a;
}
function $acd06eaa94858840$var$Ri(a) {
    null === $acd06eaa94858840$var$jk ? $acd06eaa94858840$var$jk = a : $acd06eaa94858840$var$jk.push.apply($acd06eaa94858840$var$jk, a);
}
function $acd06eaa94858840$var$Ek(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$acd06eaa94858840$var$Ce(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $acd06eaa94858840$var$sk(a, b) {
    b &= ~$acd06eaa94858840$var$hk;
    b &= ~$acd06eaa94858840$var$gk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $acd06eaa94858840$var$lc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $acd06eaa94858840$var$uk(a) {
    if (0 !== ($acd06eaa94858840$var$K & 6)) throw Error($acd06eaa94858840$var$p(327));
    $acd06eaa94858840$var$xk();
    var b = $acd06eaa94858840$var$rc(a, 0);
    if (0 === (b & 1)) return $acd06eaa94858840$var$tk(a, $acd06eaa94858840$var$D()), null;
    var c = $acd06eaa94858840$var$yk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $acd06eaa94858840$var$uc(a);
        0 !== d && (b = d, c = $acd06eaa94858840$var$Dk(a, d));
    }
    if (1 === c) throw c = $acd06eaa94858840$var$fk, $acd06eaa94858840$var$Ak(a, 0), $acd06eaa94858840$var$sk(a, b), $acd06eaa94858840$var$tk(a, $acd06eaa94858840$var$D()), c;
    if (6 === c) throw Error($acd06eaa94858840$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $acd06eaa94858840$var$Fk(a, $acd06eaa94858840$var$jk);
    $acd06eaa94858840$var$tk(a, $acd06eaa94858840$var$D());
    return null;
}
function $acd06eaa94858840$var$Gk(a, b) {
    var c = $acd06eaa94858840$var$K;
    $acd06eaa94858840$var$K |= 1;
    try {
        return a(b);
    } finally{
        $acd06eaa94858840$var$K = c, 0 === $acd06eaa94858840$var$K && ($acd06eaa94858840$var$Ti = $acd06eaa94858840$var$D() + 500, $acd06eaa94858840$var$$f && $acd06eaa94858840$var$dg());
    }
}
function $acd06eaa94858840$var$Hk(a) {
    null !== $acd06eaa94858840$var$lk && 0 === $acd06eaa94858840$var$lk.tag && 0 === ($acd06eaa94858840$var$K & 6) && $acd06eaa94858840$var$xk();
    var b = $acd06eaa94858840$var$K;
    $acd06eaa94858840$var$K |= 1;
    var c = $acd06eaa94858840$var$ek.transition, d = $acd06eaa94858840$var$E;
    try {
        if ($acd06eaa94858840$var$ek.transition = null, $acd06eaa94858840$var$E = 1, a) return a();
    } finally{
        $acd06eaa94858840$var$E = d, $acd06eaa94858840$var$ek.transition = c, $acd06eaa94858840$var$K = b, 0 === ($acd06eaa94858840$var$K & 6) && $acd06eaa94858840$var$dg();
    }
}
function $acd06eaa94858840$var$Ui() {
    $acd06eaa94858840$var$Vi = $acd06eaa94858840$var$ej.current;
    $acd06eaa94858840$var$G($acd06eaa94858840$var$ej);
}
function $acd06eaa94858840$var$Ak(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $acd06eaa94858840$var$Af(c));
    if (null !== $acd06eaa94858840$var$Y) for(c = $acd06eaa94858840$var$Y.return; null !== c;){
        var d = c;
        $acd06eaa94858840$var$Wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $acd06eaa94858840$var$Uf();
                break;
            case 3:
                $acd06eaa94858840$var$zh();
                $acd06eaa94858840$var$G($acd06eaa94858840$var$Qf);
                $acd06eaa94858840$var$G($acd06eaa94858840$var$I);
                $acd06eaa94858840$var$Eh();
                break;
            case 5:
                $acd06eaa94858840$var$Bh(d);
                break;
            case 4:
                $acd06eaa94858840$var$zh();
                break;
            case 13:
                $acd06eaa94858840$var$G($acd06eaa94858840$var$P);
                break;
            case 19:
                $acd06eaa94858840$var$G($acd06eaa94858840$var$P);
                break;
            case 10:
                $acd06eaa94858840$var$lg(d.type._context);
                break;
            case 22:
            case 23:
                $acd06eaa94858840$var$Ui();
        }
        c = c.return;
    }
    $acd06eaa94858840$var$J = a;
    $acd06eaa94858840$var$Y = a = $acd06eaa94858840$var$mh(a.current, null);
    $acd06eaa94858840$var$Z = $acd06eaa94858840$var$Vi = b;
    $acd06eaa94858840$var$W = 0;
    $acd06eaa94858840$var$fk = null;
    $acd06eaa94858840$var$hk = $acd06eaa94858840$var$gk = $acd06eaa94858840$var$zg = 0;
    $acd06eaa94858840$var$jk = $acd06eaa94858840$var$ik = null;
    if (null !== $acd06eaa94858840$var$qg) {
        for(b = 0; b < $acd06eaa94858840$var$qg.length; b++)if (c = $acd06eaa94858840$var$qg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $acd06eaa94858840$var$qg = null;
    }
    return a;
}
function $acd06eaa94858840$var$Ck(a, b) {
    do {
        var c = $acd06eaa94858840$var$Y;
        try {
            $acd06eaa94858840$var$kg();
            $acd06eaa94858840$var$Fh.current = $acd06eaa94858840$var$Rh;
            if ($acd06eaa94858840$var$Ih) {
                for(var d = $acd06eaa94858840$var$Q.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $acd06eaa94858840$var$Ih = !1;
            }
            $acd06eaa94858840$var$Hh = 0;
            $acd06eaa94858840$var$S = $acd06eaa94858840$var$R = $acd06eaa94858840$var$Q = null;
            $acd06eaa94858840$var$Jh = !1;
            $acd06eaa94858840$var$Kh = 0;
            $acd06eaa94858840$var$dk.current = null;
            if (null === c || null === c.return) {
                $acd06eaa94858840$var$W = 1;
                $acd06eaa94858840$var$fk = b;
                $acd06eaa94858840$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $acd06eaa94858840$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, w = m.tag;
                    if (0 === (m.mode & 1) && (0 === w || 11 === w || 15 === w)) {
                        var u = m.alternate;
                        u ? (m.updateQueue = u.updateQueue, m.memoizedState = u.memoizedState, m.lanes = u.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $acd06eaa94858840$var$Ji(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $acd06eaa94858840$var$Ki(y, g, h, f, b);
                        y.mode & 1 && $acd06eaa94858840$var$Hi(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var v = new Set;
                            v.add(k);
                            b.updateQueue = v;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $acd06eaa94858840$var$Hi(f, l, b);
                            $acd06eaa94858840$var$Si();
                            break a;
                        }
                        k = Error($acd06eaa94858840$var$p(426));
                    }
                } else if ($acd06eaa94858840$var$N && h.mode & 1) {
                    var C = $acd06eaa94858840$var$Ji(g);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $acd06eaa94858840$var$Ki(C, g, h, f, b);
                        $acd06eaa94858840$var$hh(k);
                        break a;
                    }
                }
                f = k;
                4 !== $acd06eaa94858840$var$W && ($acd06eaa94858840$var$W = 2);
                null === $acd06eaa94858840$var$ik ? $acd06eaa94858840$var$ik = [
                    f
                ] : $acd06eaa94858840$var$ik.push(f);
                k = $acd06eaa94858840$var$zi(k, h);
                h = g;
                do {
                    switch(h.tag){
                        case 3:
                            h.flags |= 65536;
                            b &= -b;
                            h.lanes |= b;
                            var t = $acd06eaa94858840$var$Ci(h, k, b);
                            $acd06eaa94858840$var$xg(h, t);
                            break a;
                        case 1:
                            f = k;
                            var r = h.type, x = h.stateNode;
                            if (0 === (h.flags & 128) && ("function" === typeof r.getDerivedStateFromError || null !== x && "function" === typeof x.componentDidCatch && (null === $acd06eaa94858840$var$Gi || !$acd06eaa94858840$var$Gi.has(x)))) {
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var B = $acd06eaa94858840$var$Fi(h, f, b);
                                $acd06eaa94858840$var$xg(h, B);
                                break a;
                            }
                    }
                    h = h.return;
                }while (null !== h);
            }
            $acd06eaa94858840$var$Ik(c);
        } catch (O) {
            b = O;
            $acd06eaa94858840$var$Y === c && null !== c && ($acd06eaa94858840$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $acd06eaa94858840$var$zk() {
    var a = $acd06eaa94858840$var$ck.current;
    $acd06eaa94858840$var$ck.current = $acd06eaa94858840$var$Rh;
    return null === a ? $acd06eaa94858840$var$Rh : a;
}
function $acd06eaa94858840$var$Si() {
    if (0 === $acd06eaa94858840$var$W || 3 === $acd06eaa94858840$var$W || 2 === $acd06eaa94858840$var$W) $acd06eaa94858840$var$W = 4;
    null === $acd06eaa94858840$var$J || 0 === ($acd06eaa94858840$var$zg & 268435455) && 0 === ($acd06eaa94858840$var$gk & 268435455) || $acd06eaa94858840$var$sk($acd06eaa94858840$var$J, $acd06eaa94858840$var$Z);
}
function $acd06eaa94858840$var$yk(a, b) {
    var c = $acd06eaa94858840$var$K;
    $acd06eaa94858840$var$K |= 2;
    var d = $acd06eaa94858840$var$zk();
    $acd06eaa94858840$var$J === a && $acd06eaa94858840$var$Z === b || $acd06eaa94858840$var$Ak(a, b);
    for(;;)try {
        $acd06eaa94858840$var$Jk();
        break;
    } catch (e) {
        $acd06eaa94858840$var$Ck(a, e);
    }
    $acd06eaa94858840$var$kg();
    $acd06eaa94858840$var$K = c;
    $acd06eaa94858840$var$ck.current = d;
    if (null !== $acd06eaa94858840$var$Y) throw Error($acd06eaa94858840$var$p(261));
    $acd06eaa94858840$var$J = null;
    $acd06eaa94858840$var$Z = 0;
    return $acd06eaa94858840$var$W;
}
function $acd06eaa94858840$var$Jk() {
    for(; null !== $acd06eaa94858840$var$Y;)$acd06eaa94858840$var$Kk($acd06eaa94858840$var$Y);
}
function $acd06eaa94858840$var$Bk() {
    for(; null !== $acd06eaa94858840$var$Y && !$acd06eaa94858840$var$$b();)$acd06eaa94858840$var$Kk($acd06eaa94858840$var$Y);
}
function $acd06eaa94858840$var$Kk(a) {
    var b = $acd06eaa94858840$var$Lk(a.alternate, a, $acd06eaa94858840$var$Vi);
    a.memoizedProps = a.pendingProps;
    null === b ? $acd06eaa94858840$var$Ik(a) : $acd06eaa94858840$var$Y = b;
    $acd06eaa94858840$var$dk.current = null;
}
function $acd06eaa94858840$var$Ik(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $acd06eaa94858840$var$Qi(c, b, $acd06eaa94858840$var$Vi), null !== c) {
                $acd06eaa94858840$var$Y = c;
                return;
            }
        } else {
            c = $acd06eaa94858840$var$xj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $acd06eaa94858840$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $acd06eaa94858840$var$W = 6;
                $acd06eaa94858840$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $acd06eaa94858840$var$Y = b;
            return;
        }
        $acd06eaa94858840$var$Y = b = a;
    }while (null !== b);
    0 === $acd06eaa94858840$var$W && ($acd06eaa94858840$var$W = 5);
}
function $acd06eaa94858840$var$Fk(a, b) {
    var c = $acd06eaa94858840$var$E, d = $acd06eaa94858840$var$ek.transition;
    try {
        $acd06eaa94858840$var$ek.transition = null, $acd06eaa94858840$var$E = 1, $acd06eaa94858840$var$Mk(a, b, c);
    } finally{
        $acd06eaa94858840$var$ek.transition = d, $acd06eaa94858840$var$E = c;
    }
    return null;
}
function $acd06eaa94858840$var$Mk(a, b, c) {
    do $acd06eaa94858840$var$xk();
    while (null !== $acd06eaa94858840$var$lk);
    if (0 !== ($acd06eaa94858840$var$K & 6)) throw Error($acd06eaa94858840$var$p(327));
    var d = a.finishedWork, e = a.finishedLanes;
    if (null === d) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (d === a.current) throw Error($acd06eaa94858840$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = d.lanes | d.childLanes;
    $acd06eaa94858840$var$xc(a, f);
    a === $acd06eaa94858840$var$J && ($acd06eaa94858840$var$Y = $acd06eaa94858840$var$J = null, $acd06eaa94858840$var$Z = 0);
    0 === (d.subtreeFlags & 2064) && 0 === (d.flags & 2064) || $acd06eaa94858840$var$kk || ($acd06eaa94858840$var$kk = !0, $acd06eaa94858840$var$vk($acd06eaa94858840$var$ec, function() {
        $acd06eaa94858840$var$xk();
        return null;
    }));
    f = 0 !== (d.flags & 15990);
    if (0 !== (d.subtreeFlags & 15990) || f) {
        f = $acd06eaa94858840$var$ek.transition;
        $acd06eaa94858840$var$ek.transition = null;
        var g = $acd06eaa94858840$var$E;
        $acd06eaa94858840$var$E = 1;
        var h = $acd06eaa94858840$var$K;
        $acd06eaa94858840$var$K |= 4;
        $acd06eaa94858840$var$dk.current = null;
        $acd06eaa94858840$var$Fj(a, d);
        $acd06eaa94858840$var$Uj(a, d, e);
        $acd06eaa94858840$var$Je($acd06eaa94858840$var$xf);
        $acd06eaa94858840$var$xf = null;
        a.current = d;
        $acd06eaa94858840$var$Xj(d, a, e);
        $acd06eaa94858840$var$ac();
        $acd06eaa94858840$var$K = h;
        $acd06eaa94858840$var$E = g;
        $acd06eaa94858840$var$ek.transition = f;
    } else a.current = d;
    $acd06eaa94858840$var$kk && ($acd06eaa94858840$var$kk = !1, $acd06eaa94858840$var$lk = a, $acd06eaa94858840$var$mk = e);
    f = a.pendingLanes;
    0 === f && ($acd06eaa94858840$var$Gi = null);
    $acd06eaa94858840$var$jc(d.stateNode, c);
    $acd06eaa94858840$var$tk(a, $acd06eaa94858840$var$D());
    if (null !== b) for(c = a.onRecoverableError, d = 0; d < b.length; d++)c(b[d]);
    if ($acd06eaa94858840$var$Di) throw $acd06eaa94858840$var$Di = !1, a = $acd06eaa94858840$var$Ei, $acd06eaa94858840$var$Ei = null, a;
    0 !== ($acd06eaa94858840$var$mk & 1) && 0 !== a.tag && $acd06eaa94858840$var$xk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $acd06eaa94858840$var$ok ? $acd06eaa94858840$var$nk++ : ($acd06eaa94858840$var$nk = 0, $acd06eaa94858840$var$ok = a) : $acd06eaa94858840$var$nk = 0;
    $acd06eaa94858840$var$dg();
    return null;
}
function $acd06eaa94858840$var$xk() {
    if (null !== $acd06eaa94858840$var$lk) {
        var a = $acd06eaa94858840$var$zc($acd06eaa94858840$var$mk), b = $acd06eaa94858840$var$ek.transition, c = $acd06eaa94858840$var$E;
        try {
            $acd06eaa94858840$var$ek.transition = null;
            $acd06eaa94858840$var$E = 16 > a ? 16 : a;
            if (null === $acd06eaa94858840$var$lk) var d = !1;
            else {
                a = $acd06eaa94858840$var$lk;
                $acd06eaa94858840$var$lk = null;
                $acd06eaa94858840$var$mk = 0;
                if (0 !== ($acd06eaa94858840$var$K & 6)) throw Error($acd06eaa94858840$var$p(331));
                var e = $acd06eaa94858840$var$K;
                $acd06eaa94858840$var$K |= 4;
                for($acd06eaa94858840$var$X = a.current; null !== $acd06eaa94858840$var$X;){
                    var f = $acd06eaa94858840$var$X, g = f.child;
                    if (0 !== ($acd06eaa94858840$var$X.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($acd06eaa94858840$var$X = l; null !== $acd06eaa94858840$var$X;){
                                    var m = $acd06eaa94858840$var$X;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $acd06eaa94858840$var$Gj(8, m, f);
                                    }
                                    var w = m.child;
                                    if (null !== w) w.return = m, $acd06eaa94858840$var$X = w;
                                    else for(; null !== $acd06eaa94858840$var$X;){
                                        m = $acd06eaa94858840$var$X;
                                        var u = m.sibling, y = m.return;
                                        $acd06eaa94858840$var$Lj(m);
                                        if (m === l) {
                                            $acd06eaa94858840$var$X = null;
                                            break;
                                        }
                                        if (null !== u) {
                                            u.return = y;
                                            $acd06eaa94858840$var$X = u;
                                            break;
                                        }
                                        $acd06eaa94858840$var$X = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var v = n.child;
                                if (null !== v) {
                                    n.child = null;
                                    do {
                                        var C = v.sibling;
                                        v.sibling = null;
                                        v = C;
                                    }while (null !== v);
                                }
                            }
                            $acd06eaa94858840$var$X = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $acd06eaa94858840$var$X = g;
                    else b: for(; null !== $acd06eaa94858840$var$X;){
                        f = $acd06eaa94858840$var$X;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $acd06eaa94858840$var$Gj(9, f, f.return);
                        }
                        var t = f.sibling;
                        if (null !== t) {
                            t.return = f.return;
                            $acd06eaa94858840$var$X = t;
                            break b;
                        }
                        $acd06eaa94858840$var$X = f.return;
                    }
                }
                var r = a.current;
                for($acd06eaa94858840$var$X = r; null !== $acd06eaa94858840$var$X;){
                    g = $acd06eaa94858840$var$X;
                    var x = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== x) x.return = g, $acd06eaa94858840$var$X = x;
                    else b: for(g = r; null !== $acd06eaa94858840$var$X;){
                        h = $acd06eaa94858840$var$X;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $acd06eaa94858840$var$Hj(9, h);
                            }
                        } catch (O) {
                            $acd06eaa94858840$var$Cj(h, h.return, O);
                        }
                        if (h === g) {
                            $acd06eaa94858840$var$X = null;
                            break b;
                        }
                        var B = h.sibling;
                        if (null !== B) {
                            B.return = h.return;
                            $acd06eaa94858840$var$X = B;
                            break b;
                        }
                        $acd06eaa94858840$var$X = h.return;
                    }
                }
                $acd06eaa94858840$var$K = e;
                $acd06eaa94858840$var$dg();
                if ($acd06eaa94858840$var$ic && "function" === typeof $acd06eaa94858840$var$ic.onPostCommitFiberRoot) try {
                    $acd06eaa94858840$var$ic.onPostCommitFiberRoot($acd06eaa94858840$var$hc, a);
                } catch (O) {}
                d = !0;
            }
            return d;
        } finally{
            $acd06eaa94858840$var$E = c, $acd06eaa94858840$var$ek.transition = b;
        }
    }
    return !1;
}
function $acd06eaa94858840$var$Nk(a, b, c) {
    b = $acd06eaa94858840$var$zi(c, b);
    b = $acd06eaa94858840$var$Ci(a, b, 1);
    $acd06eaa94858840$var$vg(a, b);
    b = $acd06eaa94858840$var$M();
    a = $acd06eaa94858840$var$rk(a, 1);
    null !== a && ($acd06eaa94858840$var$wc(a, 1, b), $acd06eaa94858840$var$tk(a, b));
}
function $acd06eaa94858840$var$Cj(a, b, c) {
    if (3 === a.tag) $acd06eaa94858840$var$Nk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $acd06eaa94858840$var$Nk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $acd06eaa94858840$var$Gi || !$acd06eaa94858840$var$Gi.has(d))) {
                a = $acd06eaa94858840$var$zi(c, a);
                a = $acd06eaa94858840$var$Fi(b, a, 1);
                $acd06eaa94858840$var$vg(b, a);
                a = $acd06eaa94858840$var$M();
                b = $acd06eaa94858840$var$rk(b, 1);
                null !== b && ($acd06eaa94858840$var$wc(b, 1, a), $acd06eaa94858840$var$tk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $acd06eaa94858840$var$Ii(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $acd06eaa94858840$var$M();
    a.pingedLanes |= a.suspendedLanes & c;
    $acd06eaa94858840$var$J === a && ($acd06eaa94858840$var$Z & c) === c && (4 === $acd06eaa94858840$var$W || 3 === $acd06eaa94858840$var$W && ($acd06eaa94858840$var$Z & 130023424) === $acd06eaa94858840$var$Z && 500 > $acd06eaa94858840$var$D() - $acd06eaa94858840$var$Vj ? $acd06eaa94858840$var$Ak(a, 0) : $acd06eaa94858840$var$hk |= c);
    $acd06eaa94858840$var$tk(a, b);
}
function $acd06eaa94858840$var$Ok(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $acd06eaa94858840$var$pc, $acd06eaa94858840$var$pc <<= 1, 0 === ($acd06eaa94858840$var$pc & 130023424) && ($acd06eaa94858840$var$pc = 4194304)));
    var c = $acd06eaa94858840$var$M();
    a = $acd06eaa94858840$var$rk(a, b);
    null !== a && ($acd06eaa94858840$var$wc(a, b, c), $acd06eaa94858840$var$tk(a, c));
}
function $acd06eaa94858840$var$qj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $acd06eaa94858840$var$Ok(a, c);
}
function $acd06eaa94858840$var$Tj(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($acd06eaa94858840$var$p(314));
    }
    null !== d && d.delete(b);
    $acd06eaa94858840$var$Ok(a, c);
}
var $acd06eaa94858840$var$Lk;
$acd06eaa94858840$var$Lk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $acd06eaa94858840$var$Qf.current) $acd06eaa94858840$var$og = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $acd06eaa94858840$var$og = !1, $acd06eaa94858840$var$wj(a, b, c);
            $acd06eaa94858840$var$og = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $acd06eaa94858840$var$og = !1, $acd06eaa94858840$var$N && 0 !== (b.flags & 1048576) && $acd06eaa94858840$var$Ug(b, $acd06eaa94858840$var$Ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            var e = $acd06eaa94858840$var$Sf(b, $acd06eaa94858840$var$I.current);
            $acd06eaa94858840$var$ng(b, c);
            e = $acd06eaa94858840$var$Nh(null, b, d, a, e, c);
            var f = $acd06eaa94858840$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $acd06eaa94858840$var$Tf(d) ? (f = !0, $acd06eaa94858840$var$Xf(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $acd06eaa94858840$var$sg(b), e.updater = $acd06eaa94858840$var$Fg, b.stateNode = e, e._reactInternals = b, $acd06eaa94858840$var$Jg(b, d, a, c), b = $acd06eaa94858840$var$hj(null, b, d, !0, f, c)) : (b.tag = 0, $acd06eaa94858840$var$N && f && $acd06eaa94858840$var$Vg(b), $acd06eaa94858840$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $acd06eaa94858840$var$Pk(d);
                a = $acd06eaa94858840$var$fg(d, a);
                switch(e){
                    case 0:
                        b = $acd06eaa94858840$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $acd06eaa94858840$var$gj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $acd06eaa94858840$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $acd06eaa94858840$var$$i(null, b, d, $acd06eaa94858840$var$fg(d.type, a), c);
                        break a;
                }
                throw Error($acd06eaa94858840$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $acd06eaa94858840$var$fg(d, e), $acd06eaa94858840$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $acd06eaa94858840$var$fg(d, e), $acd06eaa94858840$var$gj(a, b, d, e, c);
        case 3:
            a: {
                $acd06eaa94858840$var$ij(b);
                if (null === a) throw Error($acd06eaa94858840$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $acd06eaa94858840$var$tg(a, b);
                $acd06eaa94858840$var$yg(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Error($acd06eaa94858840$var$p(423));
                        b = $acd06eaa94858840$var$jj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Error($acd06eaa94858840$var$p(424));
                        b = $acd06eaa94858840$var$jj(a, b, d, c, e);
                        break a;
                    } else for($acd06eaa94858840$var$Yg = $acd06eaa94858840$var$Ff(b.stateNode.containerInfo.firstChild), $acd06eaa94858840$var$Xg = b, $acd06eaa94858840$var$N = !0, $acd06eaa94858840$var$Zg = null, c = $acd06eaa94858840$var$sh(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $acd06eaa94858840$var$gh();
                    if (d === e) {
                        b = $acd06eaa94858840$var$Zi(a, b, c);
                        break a;
                    }
                    $acd06eaa94858840$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $acd06eaa94858840$var$Ah(b), null === a && $acd06eaa94858840$var$dh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $acd06eaa94858840$var$yf(d, e) ? g = null : null !== f && $acd06eaa94858840$var$yf(d, f) && (b.flags |= 32), $acd06eaa94858840$var$fj(a, b), $acd06eaa94858840$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $acd06eaa94858840$var$dh(b), null;
        case 13:
            return $acd06eaa94858840$var$mj(a, b, c);
        case 4:
            return $acd06eaa94858840$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $acd06eaa94858840$var$rh(b, null, d, c) : $acd06eaa94858840$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $acd06eaa94858840$var$fg(d, e), $acd06eaa94858840$var$Yi(a, b, d, e, c);
        case 7:
            return $acd06eaa94858840$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $acd06eaa94858840$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $acd06eaa94858840$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $acd06eaa94858840$var$H($acd06eaa94858840$var$gg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($acd06eaa94858840$var$Ce(f.value, g)) {
                        if (f.children === e.children && !$acd06eaa94858840$var$Qf.current) {
                            b = $acd06eaa94858840$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $acd06eaa94858840$var$ug(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $acd06eaa94858840$var$mg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($acd06eaa94858840$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $acd06eaa94858840$var$mg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $acd06eaa94858840$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $acd06eaa94858840$var$ng(b, c), e = $acd06eaa94858840$var$pg(e), d = d(e), b.flags |= 1, $acd06eaa94858840$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $acd06eaa94858840$var$fg(d, b.pendingProps), e = $acd06eaa94858840$var$fg(d.type, e), $acd06eaa94858840$var$$i(a, b, d, e, c);
        case 15:
            return $acd06eaa94858840$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $acd06eaa94858840$var$fg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $acd06eaa94858840$var$Tf(d) ? (a = !0, $acd06eaa94858840$var$Xf(b)) : a = !1, $acd06eaa94858840$var$ng(b, c), $acd06eaa94858840$var$Hg(b, d, e), $acd06eaa94858840$var$Jg(b, d, e, c), $acd06eaa94858840$var$hj(null, b, d, !0, a, c);
        case 19:
            return $acd06eaa94858840$var$vj(a, b, c);
        case 22:
            return $acd06eaa94858840$var$dj(a, b, c);
    }
    throw Error($acd06eaa94858840$var$p(156, b.tag));
};
function $acd06eaa94858840$var$vk(a, b) {
    return $acd06eaa94858840$var$Yb(a, b);
}
function $acd06eaa94858840$var$Qk(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $acd06eaa94858840$var$ah(a, b, c, d) {
    return new $acd06eaa94858840$var$Qk(a, b, c, d);
}
function $acd06eaa94858840$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $acd06eaa94858840$var$Pk(a) {
    if ("function" === typeof a) return $acd06eaa94858840$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $acd06eaa94858840$var$Ba) return 11;
        if (a === $acd06eaa94858840$var$Ea) return 14;
    }
    return 2;
}
function $acd06eaa94858840$var$mh(a, b) {
    var c = a.alternate;
    null === c ? (c = $acd06eaa94858840$var$ah(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $acd06eaa94858840$var$oh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $acd06eaa94858840$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $acd06eaa94858840$var$va:
            return $acd06eaa94858840$var$qh(c.children, e, f, b);
        case $acd06eaa94858840$var$wa:
            g = 8;
            e |= 8;
            break;
        case $acd06eaa94858840$var$xa:
            return a = $acd06eaa94858840$var$ah(12, c, b, e | 2), a.elementType = $acd06eaa94858840$var$xa, a.lanes = f, a;
        case $acd06eaa94858840$var$Ca:
            return a = $acd06eaa94858840$var$ah(13, c, b, e), a.elementType = $acd06eaa94858840$var$Ca, a.lanes = f, a;
        case $acd06eaa94858840$var$Da:
            return a = $acd06eaa94858840$var$ah(19, c, b, e), a.elementType = $acd06eaa94858840$var$Da, a.lanes = f, a;
        case $acd06eaa94858840$var$Ga:
            return $acd06eaa94858840$var$nj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $acd06eaa94858840$var$ya:
                    g = 10;
                    break a;
                case $acd06eaa94858840$var$Aa:
                    g = 9;
                    break a;
                case $acd06eaa94858840$var$Ba:
                    g = 11;
                    break a;
                case $acd06eaa94858840$var$Ea:
                    g = 14;
                    break a;
                case $acd06eaa94858840$var$Fa:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($acd06eaa94858840$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $acd06eaa94858840$var$ah(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $acd06eaa94858840$var$qh(a, b, c, d) {
    a = $acd06eaa94858840$var$ah(7, a, d, b);
    a.lanes = c;
    return a;
}
function $acd06eaa94858840$var$nj(a, b, c, d) {
    a = $acd06eaa94858840$var$ah(22, a, d, b);
    a.elementType = $acd06eaa94858840$var$Ga;
    a.lanes = c;
    a.stateNode = {};
    return a;
}
function $acd06eaa94858840$var$nh(a, b, c) {
    a = $acd06eaa94858840$var$ah(6, a, null, b);
    a.lanes = c;
    return a;
}
function $acd06eaa94858840$var$ph(a, b, c) {
    b = $acd06eaa94858840$var$ah(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $acd06eaa94858840$var$Rk(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $acd06eaa94858840$var$vc(0);
    this.expirationTimes = $acd06eaa94858840$var$vc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $acd06eaa94858840$var$vc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $acd06eaa94858840$var$Sk(a, b, c, d, e, f, g, h, k) {
    a = new $acd06eaa94858840$var$Rk(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $acd06eaa94858840$var$ah(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null
    };
    $acd06eaa94858840$var$sg(f);
    return a;
}
function $acd06eaa94858840$var$Tk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $acd06eaa94858840$var$ua,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $acd06eaa94858840$var$Uk(a) {
    if (!a) return $acd06eaa94858840$var$Pf;
    a = a._reactInternals;
    a: {
        if ($acd06eaa94858840$var$Sb(a) !== a || 1 !== a.tag) throw Error($acd06eaa94858840$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($acd06eaa94858840$var$Tf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($acd06eaa94858840$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($acd06eaa94858840$var$Tf(c)) return $acd06eaa94858840$var$Wf(a, c, b);
    }
    return b;
}
function $acd06eaa94858840$var$Vk(a, b, c, d, e, f, g, h, k) {
    a = $acd06eaa94858840$var$Sk(c, d, !0, a, e, f, g, h, k);
    a.context = $acd06eaa94858840$var$Uk(null);
    c = a.current;
    d = $acd06eaa94858840$var$M();
    e = $acd06eaa94858840$var$Dg(c);
    f = $acd06eaa94858840$var$ug(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $acd06eaa94858840$var$vg(c, f);
    a.current.lanes = e;
    $acd06eaa94858840$var$wc(a, e, d);
    $acd06eaa94858840$var$tk(a, d);
    return a;
}
function $acd06eaa94858840$var$Wk(a, b, c, d) {
    var e = b.current, f = $acd06eaa94858840$var$M(), g = $acd06eaa94858840$var$Dg(e);
    c = $acd06eaa94858840$var$Uk(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $acd06eaa94858840$var$ug(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $acd06eaa94858840$var$vg(e, b);
    a = $acd06eaa94858840$var$Eg(e, g, f);
    null !== a && $acd06eaa94858840$var$wg(a, e, g);
    return g;
}
function $acd06eaa94858840$var$Xk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $acd06eaa94858840$var$Yk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $acd06eaa94858840$var$Zk(a, b) {
    $acd06eaa94858840$var$Yk(a, b);
    (a = a.alternate) && $acd06eaa94858840$var$Yk(a, b);
}
function $acd06eaa94858840$var$$k() {
    return null;
}
var $acd06eaa94858840$var$al = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $acd06eaa94858840$var$bl(a) {
    this._internalRoot = a;
}
$acd06eaa94858840$var$cl.prototype.render = $acd06eaa94858840$var$bl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($acd06eaa94858840$var$p(409));
    $acd06eaa94858840$var$Wk(a, b, null, null);
};
$acd06eaa94858840$var$cl.prototype.unmount = $acd06eaa94858840$var$bl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $acd06eaa94858840$var$Hk(function() {
            $acd06eaa94858840$var$Wk(null, a, null, null);
        });
        b[$acd06eaa94858840$var$pf] = null;
    }
};
function $acd06eaa94858840$var$cl(a) {
    this._internalRoot = a;
}
$acd06eaa94858840$var$cl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $acd06eaa94858840$var$Dc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $acd06eaa94858840$var$Mc.length && 0 !== b && b < $acd06eaa94858840$var$Mc[c].priority; c++);
        $acd06eaa94858840$var$Mc.splice(c, 0, a);
        0 === c && $acd06eaa94858840$var$Rc(a);
    }
};
function $acd06eaa94858840$var$dl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $acd06eaa94858840$var$el(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $acd06eaa94858840$var$fl() {}
function $acd06eaa94858840$var$gl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $acd06eaa94858840$var$Xk(g);
                f.call(a);
            };
        }
        var g = $acd06eaa94858840$var$Vk(b, d, a, 0, null, !1, !1, "", $acd06eaa94858840$var$fl);
        a._reactRootContainer = g;
        a[$acd06eaa94858840$var$pf] = g.current;
        $acd06eaa94858840$var$nf(8 === a.nodeType ? a.parentNode : a);
        $acd06eaa94858840$var$Hk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $acd06eaa94858840$var$Xk(k);
            h.call(a);
        };
    }
    var k = $acd06eaa94858840$var$Sk(a, 0, !1, null, null, !1, !1, "", $acd06eaa94858840$var$fl);
    a._reactRootContainer = k;
    a[$acd06eaa94858840$var$pf] = k.current;
    $acd06eaa94858840$var$nf(8 === a.nodeType ? a.parentNode : a);
    $acd06eaa94858840$var$Hk(function() {
        $acd06eaa94858840$var$Wk(b, k, c, d);
    });
    return k;
}
function $acd06eaa94858840$var$hl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $acd06eaa94858840$var$Xk(g);
                h.call(a);
            };
        }
        $acd06eaa94858840$var$Wk(b, g, a, e);
    } else g = $acd06eaa94858840$var$gl(c, b, a, e, d);
    return $acd06eaa94858840$var$Xk(g);
}
$acd06eaa94858840$var$Ac = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $acd06eaa94858840$var$qc(b.pendingLanes);
                0 !== c && ($acd06eaa94858840$var$yc(b, c | 1), $acd06eaa94858840$var$tk(b, $acd06eaa94858840$var$D()), 0 === ($acd06eaa94858840$var$K & 6) && ($acd06eaa94858840$var$Ti = $acd06eaa94858840$var$D() + 500, $acd06eaa94858840$var$dg()));
            }
            break;
        case 13:
            var d = $acd06eaa94858840$var$M();
            $acd06eaa94858840$var$Hk(function() {
                return $acd06eaa94858840$var$Eg(a, 1, d);
            });
            $acd06eaa94858840$var$Zk(a, 1);
    }
};
$acd06eaa94858840$var$Bc = function(a) {
    if (13 === a.tag) {
        var b = $acd06eaa94858840$var$M();
        $acd06eaa94858840$var$Eg(a, 134217728, b);
        $acd06eaa94858840$var$Zk(a, 134217728);
    }
};
$acd06eaa94858840$var$Cc = function(a) {
    if (13 === a.tag) {
        var b = $acd06eaa94858840$var$M(), c = $acd06eaa94858840$var$Dg(a);
        $acd06eaa94858840$var$Eg(a, c, b);
        $acd06eaa94858840$var$Zk(a, c);
    }
};
$acd06eaa94858840$var$Dc = function() {
    return $acd06eaa94858840$var$E;
};
$acd06eaa94858840$var$Ec = function(a, b) {
    var c = $acd06eaa94858840$var$E;
    try {
        return $acd06eaa94858840$var$E = a, b();
    } finally{
        $acd06eaa94858840$var$E = c;
    }
};
$acd06eaa94858840$var$vb = function(a, b, c) {
    switch(b){
        case "input":
            $acd06eaa94858840$var$Za(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $acd06eaa94858840$var$Ab(d);
                        if (!e) throw Error($acd06eaa94858840$var$p(90));
                        $acd06eaa94858840$var$Ua(d);
                        $acd06eaa94858840$var$Za(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $acd06eaa94858840$var$fb(a, c);
            break;
        case "select":
            b = c.value, null != b && $acd06eaa94858840$var$cb(a, !!c.multiple, b, !1);
    }
};
$acd06eaa94858840$var$Db = $acd06eaa94858840$var$Gk;
$acd06eaa94858840$var$Eb = $acd06eaa94858840$var$Hk;
var $acd06eaa94858840$var$il = {
    usingClientEntryPoint: !1,
    Events: [
        $acd06eaa94858840$var$zb,
        $acd06eaa94858840$var$pe,
        $acd06eaa94858840$var$Ab,
        $acd06eaa94858840$var$Bb,
        $acd06eaa94858840$var$Cb,
        $acd06eaa94858840$var$Gk
    ]
}, $acd06eaa94858840$var$jl = {
    findFiberByHostInstance: $acd06eaa94858840$var$Sc,
    bundleType: 0,
    version: "18.0.0-fc46dba67-20220329",
    rendererPackageName: "react-dom"
};
var $acd06eaa94858840$var$kl = {
    bundleType: $acd06eaa94858840$var$jl.bundleType,
    version: $acd06eaa94858840$var$jl.version,
    rendererPackageName: $acd06eaa94858840$var$jl.rendererPackageName,
    rendererConfig: $acd06eaa94858840$var$jl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $acd06eaa94858840$var$sa.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $acd06eaa94858840$var$Wb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $acd06eaa94858840$var$jl.findFiberByHostInstance || $acd06eaa94858840$var$$k,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.0.0-fc46dba67-20220329"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $acd06eaa94858840$var$ll = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$acd06eaa94858840$var$ll.isDisabled && $acd06eaa94858840$var$ll.supportsFiber) try {
        $acd06eaa94858840$var$hc = $acd06eaa94858840$var$ll.inject($acd06eaa94858840$var$kl), $acd06eaa94858840$var$ic = $acd06eaa94858840$var$ll;
    } catch (a) {}
}
$acd06eaa94858840$export$ae55be85d98224ed = $acd06eaa94858840$var$il;
$acd06eaa94858840$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$acd06eaa94858840$var$dl(b)) throw Error($acd06eaa94858840$var$p(200));
    return $acd06eaa94858840$var$Tk(a, b, null, c);
};
$acd06eaa94858840$export$882461b6382ed46c = function(a, b) {
    if (!$acd06eaa94858840$var$dl(a)) throw Error($acd06eaa94858840$var$p(299));
    var c = !1, d = "", e = $acd06eaa94858840$var$al;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $acd06eaa94858840$var$Sk(a, 1, !1, null, null, c, !1, d, e);
    a[$acd06eaa94858840$var$pf] = b.current;
    $acd06eaa94858840$var$nf(8 === a.nodeType ? a.parentNode : a);
    return new $acd06eaa94858840$var$bl(b);
};
$acd06eaa94858840$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($acd06eaa94858840$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($acd06eaa94858840$var$p(268, a));
    }
    a = $acd06eaa94858840$var$Wb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$acd06eaa94858840$export$cd75ccfd720a3cd4 = function(a) {
    return $acd06eaa94858840$var$Hk(a);
};
$acd06eaa94858840$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$acd06eaa94858840$var$el(b)) throw Error($acd06eaa94858840$var$p(200));
    return $acd06eaa94858840$var$hl(null, a, b, !0, c);
};
$acd06eaa94858840$export$757ceba2d55c277e = function(a, b, c) {
    if (!$acd06eaa94858840$var$dl(a)) throw Error($acd06eaa94858840$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $acd06eaa94858840$var$al;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $acd06eaa94858840$var$Vk(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$acd06eaa94858840$var$pf] = b.current;
    $acd06eaa94858840$var$nf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $acd06eaa94858840$var$cl(b);
};
$acd06eaa94858840$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$acd06eaa94858840$var$el(b)) throw Error($acd06eaa94858840$var$p(200));
    return $acd06eaa94858840$var$hl(null, a, b, !1, c);
};
$acd06eaa94858840$export$502457920280e6be = function(a) {
    if (!$acd06eaa94858840$var$el(a)) throw Error($acd06eaa94858840$var$p(40));
    return a._reactRootContainer ? ($acd06eaa94858840$var$Hk(function() {
        $acd06eaa94858840$var$hl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$acd06eaa94858840$var$pf] = null;
        });
    }), !0) : !1;
};
$acd06eaa94858840$export$c78a37762a8d58e1 = $acd06eaa94858840$var$Gk;
$acd06eaa94858840$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$acd06eaa94858840$var$el(c)) throw Error($acd06eaa94858840$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($acd06eaa94858840$var$p(38));
    return $acd06eaa94858840$var$hl(a, b, c, !1, d);
};
$acd06eaa94858840$export$83d89fbfd8236492 = "18.0.0-fc46dba67-20220329";

});
parcelRegister("f435U", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ND4Bb"));

});
parcelRegister("ND4Bb", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $0952e2d605be64aa$export$c4744153514ff05d; }, function (v) { return $0952e2d605be64aa$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $0952e2d605be64aa$export$3e506c1ccc9cc1a7; }, function (v) { return $0952e2d605be64aa$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $0952e2d605be64aa$export$e26fe2ed2fa76875; }, function (v) { return $0952e2d605be64aa$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $0952e2d605be64aa$export$502329bbf4b505b1; }, function (v) { return $0952e2d605be64aa$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $0952e2d605be64aa$export$6e3807111c4874c4; }, function (v) { return $0952e2d605be64aa$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $0952e2d605be64aa$export$c27134553091fb3a; }, function (v) { return $0952e2d605be64aa$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $0952e2d605be64aa$export$33ee1acdc04fd2a2; }, function (v) { return $0952e2d605be64aa$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $0952e2d605be64aa$export$b00a404bbd5edef2; }, function (v) { return $0952e2d605be64aa$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $0952e2d605be64aa$export$8352ce38b91d0c62; }, function (v) { return $0952e2d605be64aa$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $0952e2d605be64aa$export$d66a1c1c77bd778b; }, function (v) { return $0952e2d605be64aa$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $0952e2d605be64aa$export$d3dfb8e4810cb555; }, function (v) { return $0952e2d605be64aa$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $0952e2d605be64aa$export$839f9183b0465a69; }, function (v) { return $0952e2d605be64aa$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $0952e2d605be64aa$export$72fdf0e06517287b; }, function (v) { return $0952e2d605be64aa$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $0952e2d605be64aa$export$4b844e58a3e414b4; }, function (v) { return $0952e2d605be64aa$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $0952e2d605be64aa$export$816d2913ae6b83b1; }, function (v) { return $0952e2d605be64aa$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $0952e2d605be64aa$export$61bcfe829111a1d0; }, function (v) { return $0952e2d605be64aa$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $0952e2d605be64aa$export$7ee8c9beb337bc3f; }, function (v) { return $0952e2d605be64aa$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $0952e2d605be64aa$export$b5836b71941fa3ed; }, function (v) { return $0952e2d605be64aa$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $0952e2d605be64aa$export$cf845f2c119da08a; }, function (v) { return $0952e2d605be64aa$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0952e2d605be64aa$export$c4744153514ff05d;
var $0952e2d605be64aa$export$3e506c1ccc9cc1a7;
var $0952e2d605be64aa$export$e26fe2ed2fa76875;
var $0952e2d605be64aa$export$502329bbf4b505b1;
var $0952e2d605be64aa$export$6e3807111c4874c4;
var $0952e2d605be64aa$export$c27134553091fb3a;
var $0952e2d605be64aa$export$33ee1acdc04fd2a2;
var $0952e2d605be64aa$export$b00a404bbd5edef2;
var $0952e2d605be64aa$export$8352ce38b91d0c62;
var $0952e2d605be64aa$export$d66a1c1c77bd778b;
var $0952e2d605be64aa$export$d3dfb8e4810cb555;
var $0952e2d605be64aa$export$839f9183b0465a69;
var $0952e2d605be64aa$export$72fdf0e06517287b;
var $0952e2d605be64aa$export$4b844e58a3e414b4;
var $0952e2d605be64aa$export$816d2913ae6b83b1;
var $0952e2d605be64aa$export$61bcfe829111a1d0;
var $0952e2d605be64aa$export$7ee8c9beb337bc3f;
var $0952e2d605be64aa$export$b5836b71941fa3ed;
var $0952e2d605be64aa$export$cf845f2c119da08a;
'use strict';
function $0952e2d605be64aa$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $0952e2d605be64aa$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $0952e2d605be64aa$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $0952e2d605be64aa$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $0952e2d605be64aa$var$g(C, c)) n < e && 0 > $0952e2d605be64aa$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $0952e2d605be64aa$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $0952e2d605be64aa$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $0952e2d605be64aa$var$l = performance;
    $0952e2d605be64aa$export$c4744153514ff05d = function() {
        return $0952e2d605be64aa$var$l.now();
    };
} else {
    var $0952e2d605be64aa$var$p = Date, $0952e2d605be64aa$var$q = $0952e2d605be64aa$var$p.now();
    $0952e2d605be64aa$export$c4744153514ff05d = function() {
        return $0952e2d605be64aa$var$p.now() - $0952e2d605be64aa$var$q;
    };
}
var $0952e2d605be64aa$var$r = [], $0952e2d605be64aa$var$t = [], $0952e2d605be64aa$var$u = 1, $0952e2d605be64aa$var$v = null, $0952e2d605be64aa$var$y = 3, $0952e2d605be64aa$var$z = !1, $0952e2d605be64aa$var$A = !1, $0952e2d605be64aa$var$B = !1, $0952e2d605be64aa$var$D = "function" === typeof setTimeout ? setTimeout : null, $0952e2d605be64aa$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $0952e2d605be64aa$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $0952e2d605be64aa$var$G(a) {
    for(var b = $0952e2d605be64aa$var$h($0952e2d605be64aa$var$t); null !== b;){
        if (null === b.callback) $0952e2d605be64aa$var$k($0952e2d605be64aa$var$t);
        else if (b.startTime <= a) $0952e2d605be64aa$var$k($0952e2d605be64aa$var$t), b.sortIndex = b.expirationTime, $0952e2d605be64aa$var$f($0952e2d605be64aa$var$r, b);
        else break;
        b = $0952e2d605be64aa$var$h($0952e2d605be64aa$var$t);
    }
}
function $0952e2d605be64aa$var$H(a) {
    $0952e2d605be64aa$var$B = !1;
    $0952e2d605be64aa$var$G(a);
    if (!$0952e2d605be64aa$var$A) {
        if (null !== $0952e2d605be64aa$var$h($0952e2d605be64aa$var$r)) $0952e2d605be64aa$var$A = !0, $0952e2d605be64aa$var$I($0952e2d605be64aa$var$J);
        else {
            var b = $0952e2d605be64aa$var$h($0952e2d605be64aa$var$t);
            null !== b && $0952e2d605be64aa$var$K($0952e2d605be64aa$var$H, b.startTime - a);
        }
    }
}
function $0952e2d605be64aa$var$J(a, b) {
    $0952e2d605be64aa$var$A = !1;
    $0952e2d605be64aa$var$B && ($0952e2d605be64aa$var$B = !1, $0952e2d605be64aa$var$E($0952e2d605be64aa$var$L), $0952e2d605be64aa$var$L = -1);
    $0952e2d605be64aa$var$z = !0;
    var c = $0952e2d605be64aa$var$y;
    try {
        $0952e2d605be64aa$var$G(b);
        for($0952e2d605be64aa$var$v = $0952e2d605be64aa$var$h($0952e2d605be64aa$var$r); null !== $0952e2d605be64aa$var$v && (!($0952e2d605be64aa$var$v.expirationTime > b) || a && !$0952e2d605be64aa$var$M());){
            var d = $0952e2d605be64aa$var$v.callback;
            if ("function" === typeof d) {
                $0952e2d605be64aa$var$v.callback = null;
                $0952e2d605be64aa$var$y = $0952e2d605be64aa$var$v.priorityLevel;
                var e = d($0952e2d605be64aa$var$v.expirationTime <= b);
                b = $0952e2d605be64aa$export$c4744153514ff05d();
                "function" === typeof e ? $0952e2d605be64aa$var$v.callback = e : $0952e2d605be64aa$var$v === $0952e2d605be64aa$var$h($0952e2d605be64aa$var$r) && $0952e2d605be64aa$var$k($0952e2d605be64aa$var$r);
                $0952e2d605be64aa$var$G(b);
            } else $0952e2d605be64aa$var$k($0952e2d605be64aa$var$r);
            $0952e2d605be64aa$var$v = $0952e2d605be64aa$var$h($0952e2d605be64aa$var$r);
        }
        if (null !== $0952e2d605be64aa$var$v) var w = !0;
        else {
            var m = $0952e2d605be64aa$var$h($0952e2d605be64aa$var$t);
            null !== m && $0952e2d605be64aa$var$K($0952e2d605be64aa$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $0952e2d605be64aa$var$v = null, $0952e2d605be64aa$var$y = c, $0952e2d605be64aa$var$z = !1;
    }
}
var $0952e2d605be64aa$var$N = !1, $0952e2d605be64aa$var$O = null, $0952e2d605be64aa$var$L = -1, $0952e2d605be64aa$var$P = 5, $0952e2d605be64aa$var$Q = -1;
function $0952e2d605be64aa$var$M() {
    return $0952e2d605be64aa$export$c4744153514ff05d() - $0952e2d605be64aa$var$Q < $0952e2d605be64aa$var$P ? !1 : !0;
}
function $0952e2d605be64aa$var$R() {
    if (null !== $0952e2d605be64aa$var$O) {
        var a = $0952e2d605be64aa$export$c4744153514ff05d();
        $0952e2d605be64aa$var$Q = a;
        var b = !0;
        try {
            b = $0952e2d605be64aa$var$O(!0, a);
        } finally{
            b ? $0952e2d605be64aa$var$S() : ($0952e2d605be64aa$var$N = !1, $0952e2d605be64aa$var$O = null);
        }
    } else $0952e2d605be64aa$var$N = !1;
}
var $0952e2d605be64aa$var$S;
if ("function" === typeof $0952e2d605be64aa$var$F) $0952e2d605be64aa$var$S = function() {
    $0952e2d605be64aa$var$F($0952e2d605be64aa$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $0952e2d605be64aa$var$T = new MessageChannel, $0952e2d605be64aa$var$U = $0952e2d605be64aa$var$T.port2;
    $0952e2d605be64aa$var$T.port1.onmessage = $0952e2d605be64aa$var$R;
    $0952e2d605be64aa$var$S = function() {
        $0952e2d605be64aa$var$U.postMessage(null);
    };
} else $0952e2d605be64aa$var$S = function() {
    $0952e2d605be64aa$var$D($0952e2d605be64aa$var$R, 0);
};
function $0952e2d605be64aa$var$I(a) {
    $0952e2d605be64aa$var$O = a;
    $0952e2d605be64aa$var$N || ($0952e2d605be64aa$var$N = !0, $0952e2d605be64aa$var$S());
}
function $0952e2d605be64aa$var$K(a, b) {
    $0952e2d605be64aa$var$L = $0952e2d605be64aa$var$D(function() {
        a($0952e2d605be64aa$export$c4744153514ff05d());
    }, b);
}
$0952e2d605be64aa$export$3e506c1ccc9cc1a7 = 5;
$0952e2d605be64aa$export$e26fe2ed2fa76875 = 1;
$0952e2d605be64aa$export$502329bbf4b505b1 = 4;
$0952e2d605be64aa$export$6e3807111c4874c4 = 3;
$0952e2d605be64aa$export$c27134553091fb3a = null;
$0952e2d605be64aa$export$33ee1acdc04fd2a2 = 2;
$0952e2d605be64aa$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$0952e2d605be64aa$export$8352ce38b91d0c62 = function() {
    $0952e2d605be64aa$var$A || $0952e2d605be64aa$var$z || ($0952e2d605be64aa$var$A = !0, $0952e2d605be64aa$var$I($0952e2d605be64aa$var$J));
};
$0952e2d605be64aa$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $0952e2d605be64aa$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$0952e2d605be64aa$export$d3dfb8e4810cb555 = function() {
    return $0952e2d605be64aa$var$y;
};
$0952e2d605be64aa$export$839f9183b0465a69 = function() {
    return $0952e2d605be64aa$var$h($0952e2d605be64aa$var$r);
};
$0952e2d605be64aa$export$72fdf0e06517287b = function(a) {
    switch($0952e2d605be64aa$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $0952e2d605be64aa$var$y;
    }
    var c = $0952e2d605be64aa$var$y;
    $0952e2d605be64aa$var$y = b;
    try {
        return a();
    } finally{
        $0952e2d605be64aa$var$y = c;
    }
};
$0952e2d605be64aa$export$4b844e58a3e414b4 = function() {};
$0952e2d605be64aa$export$816d2913ae6b83b1 = function() {};
$0952e2d605be64aa$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $0952e2d605be64aa$var$y;
    $0952e2d605be64aa$var$y = a;
    try {
        return b();
    } finally{
        $0952e2d605be64aa$var$y = c;
    }
};
$0952e2d605be64aa$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $0952e2d605be64aa$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $0952e2d605be64aa$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $0952e2d605be64aa$var$f($0952e2d605be64aa$var$t, a), null === $0952e2d605be64aa$var$h($0952e2d605be64aa$var$r) && a === $0952e2d605be64aa$var$h($0952e2d605be64aa$var$t) && ($0952e2d605be64aa$var$B ? ($0952e2d605be64aa$var$E($0952e2d605be64aa$var$L), $0952e2d605be64aa$var$L = -1) : $0952e2d605be64aa$var$B = !0, $0952e2d605be64aa$var$K($0952e2d605be64aa$var$H, c - d))) : (a.sortIndex = e, $0952e2d605be64aa$var$f($0952e2d605be64aa$var$r, a), $0952e2d605be64aa$var$A || $0952e2d605be64aa$var$z || ($0952e2d605be64aa$var$A = !0, $0952e2d605be64aa$var$I($0952e2d605be64aa$var$J)));
    return a;
};
$0952e2d605be64aa$export$b5836b71941fa3ed = $0952e2d605be64aa$var$M;
$0952e2d605be64aa$export$cf845f2c119da08a = function(a) {
    var b = $0952e2d605be64aa$var$y;
    return function() {
        var c = $0952e2d605be64aa$var$y;
        $0952e2d605be64aa$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $0952e2d605be64aa$var$y = c;
        }
    };
};

});



parcelRegister("fE8jk", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $aE1o0 = parcelRequire("aE1o0");
function $b64109cc9b467698$var$emptyFunction() {}
function $b64109cc9b467698$var$emptyFunctionWithReset() {}
$b64109cc9b467698$var$emptyFunctionWithReset.resetWarningCache = $b64109cc9b467698$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aE1o0) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $b64109cc9b467698$var$emptyFunctionWithReset,
        resetWarningCache: $b64109cc9b467698$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aE1o0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $7bfeb713f1748ae0$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $7bfeb713f1748ae0$var$ReactPropTypesSecret;

});


var $558ca21e1ebcb642$exports = {};
'use strict';

$558ca21e1ebcb642$exports = (parcelRequire("59Y1B"));



var $9kKA1 = parcelRequire("9kKA1");
var $ed66448760126aed$export$882461b6382ed46c;
var $ed66448760126aed$export$757ceba2d55c277e;
'use strict';
var $aba877308eacd357$exports = {};
'use strict';
function $aba877308eacd357$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($aba877308eacd357$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$aba877308eacd357$var$checkDCE();

$aba877308eacd357$exports = (parcelRequire("ePSVh"));


var $ed66448760126aed$var$i;
$ed66448760126aed$export$882461b6382ed46c = $aba877308eacd357$exports.createRoot;
$ed66448760126aed$export$757ceba2d55c277e = $aba877308eacd357$exports.hydrateRoot;


/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $9kKA1 = parcelRequire("9kKA1");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f622e64b75e035a8$var$_extends() {
    $f622e64b75e035a8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f622e64b75e035a8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f622e64b75e035a8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f622e64b75e035a8$export$e19cd5f9376f8cee || ($f622e64b75e035a8$export$e19cd5f9376f8cee = {}));
const $f622e64b75e035a8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f622e64b75e035a8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f622e64b75e035a8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f622e64b75e035a8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f622e64b75e035a8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f622e64b75e035a8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f622e64b75e035a8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f622e64b75e035a8$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f622e64b75e035a8$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f622e64b75e035a8$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f622e64b75e035a8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f622e64b75e035a8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f622e64b75e035a8$export$fe53371bee54353d(to);
    }
    return $f622e64b75e035a8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f622e64b75e035a8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f622e64b75e035a8$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f622e64b75e035a8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f622e64b75e035a8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f622e64b75e035a8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f622e64b75e035a8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f622e64b75e035a8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f622e64b75e035a8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f622e64b75e035a8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f622e64b75e035a8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f622e64b75e035a8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f622e64b75e035a8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f622e64b75e035a8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f622e64b75e035a8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f622e64b75e035a8$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f622e64b75e035a8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f622e64b75e035a8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f622e64b75e035a8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f622e64b75e035a8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f622e64b75e035a8$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f622e64b75e035a8$export$e19cd5f9376f8cee.Push;
        let location = $f622e64b75e035a8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f622e64b75e035a8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f622e64b75e035a8$export$e19cd5f9376f8cee.Replace;
        let location = $f622e64b75e035a8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f622e64b75e035a8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f622e64b75e035a8$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $f622e64b75e035a8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f622e64b75e035a8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f622e64b75e035a8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $f622e64b75e035a8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f622e64b75e035a8$var$ResultType || ($f622e64b75e035a8$var$ResultType = {}));
const $f622e64b75e035a8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f622e64b75e035a8$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f622e64b75e035a8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f622e64b75e035a8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f622e64b75e035a8$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($f622e64b75e035a8$var$isIndexRoute(route)) {
            let indexRoute = $f622e64b75e035a8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f622e64b75e035a8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f622e64b75e035a8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $f622e64b75e035a8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $f622e64b75e035a8$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $f622e64b75e035a8$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $f622e64b75e035a8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f622e64b75e035a8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f622e64b75e035a8$var$flattenRoutes(routes);
    $f622e64b75e035a8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $f622e64b75e035a8$export$30d21fd6d7295f52(pathname);
        matches = $f622e64b75e035a8$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $f622e64b75e035a8$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f622e64b75e035a8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f622e64b75e035a8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f622e64b75e035a8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f622e64b75e035a8$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $f622e64b75e035a8$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f622e64b75e035a8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f622e64b75e035a8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f622e64b75e035a8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f622e64b75e035a8$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f622e64b75e035a8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f622e64b75e035a8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f622e64b75e035a8$var$paramRe = /^:[\w-]+$/;
const $f622e64b75e035a8$var$dynamicSegmentValue = 3;
const $f622e64b75e035a8$var$indexRouteValue = 2;
const $f622e64b75e035a8$var$emptySegmentValue = 1;
const $f622e64b75e035a8$var$staticSegmentValue = 10;
const $f622e64b75e035a8$var$splatPenalty = -2;
const $f622e64b75e035a8$var$isSplat = (s)=>s === "*";
function $f622e64b75e035a8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f622e64b75e035a8$var$isSplat)) initialScore += $f622e64b75e035a8$var$splatPenalty;
    if (index) initialScore += $f622e64b75e035a8$var$indexRouteValue;
    return segments.filter((s)=>!$f622e64b75e035a8$var$isSplat(s)).reduce((score, segment)=>score + ($f622e64b75e035a8$var$paramRe.test(segment) ? $f622e64b75e035a8$var$dynamicSegmentValue : segment === "" ? $f622e64b75e035a8$var$emptySegmentValue : $f622e64b75e035a8$var$staticSegmentValue), initialScore);
}
function $f622e64b75e035a8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f622e64b75e035a8$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f622e64b75e035a8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $f622e64b75e035a8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f622e64b75e035a8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f622e64b75e035a8$export$a5c6d149b50c1d86($f622e64b75e035a8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f622e64b75e035a8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $f622e64b75e035a8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f622e64b75e035a8$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $f622e64b75e035a8$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $f622e64b75e035a8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f622e64b75e035a8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f622e64b75e035a8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f622e64b75e035a8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $f622e64b75e035a8$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f622e64b75e035a8$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f622e64b75e035a8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $f622e64b75e035a8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f622e64b75e035a8$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f622e64b75e035a8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f622e64b75e035a8$var$normalizeSearch(search),
        hash: $f622e64b75e035a8$var$normalizeHash(hash)
    };
}
function $f622e64b75e035a8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f622e64b75e035a8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f622e64b75e035a8$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $f622e64b75e035a8$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $f622e64b75e035a8$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $f622e64b75e035a8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f622e64b75e035a8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f622e64b75e035a8$var$_extends({}, toArg);
        $f622e64b75e035a8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f622e64b75e035a8$var$getInvalidPathError("?", "pathname", "search", to));
        $f622e64b75e035a8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f622e64b75e035a8$var$getInvalidPathError("#", "pathname", "hash", to));
        $f622e64b75e035a8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f622e64b75e035a8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f622e64b75e035a8$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f622e64b75e035a8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f622e64b75e035a8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f622e64b75e035a8$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f622e64b75e035a8$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f622e64b75e035a8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f622e64b75e035a8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $f622e64b75e035a8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f622e64b75e035a8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f622e64b75e035a8$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $f622e64b75e035a8$export$4051a07651545597(data, init) {
    return new $f622e64b75e035a8$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $f622e64b75e035a8$export$42a99a7a4bc0e76a extends Error {
}
class $f622e64b75e035a8$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f622e64b75e035a8$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f622e64b75e035a8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $f622e64b75e035a8$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f622e64b75e035a8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f622e64b75e035a8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $f622e64b75e035a8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f622e64b75e035a8$var$unwrapTrackedPromise(value) {
    if (!$f622e64b75e035a8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $f622e64b75e035a8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f622e64b75e035a8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f622e64b75e035a8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f622e64b75e035a8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f622e64b75e035a8$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f622e64b75e035a8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f622e64b75e035a8$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $f622e64b75e035a8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $f622e64b75e035a8$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f622e64b75e035a8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f622e64b75e035a8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f622e64b75e035a8$var$validMutationMethods = new Set($f622e64b75e035a8$var$validMutationMethodsArr);
const $f622e64b75e035a8$var$validRequestMethodsArr = [
    "get",
    ...$f622e64b75e035a8$var$validMutationMethodsArr
];
const $f622e64b75e035a8$var$validRequestMethods = new Set($f622e64b75e035a8$var$validRequestMethodsArr);
const $f622e64b75e035a8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f622e64b75e035a8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f622e64b75e035a8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f622e64b75e035a8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f622e64b75e035a8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f622e64b75e035a8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f622e64b75e035a8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $f622e64b75e035a8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f622e64b75e035a8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $f622e64b75e035a8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f622e64b75e035a8$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $f622e64b75e035a8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $f622e64b75e035a8$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $f622e64b75e035a8$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f622e64b75e035a8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f622e64b75e035a8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f622e64b75e035a8$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$f622e64b75e035a8$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$f622e64b75e035a8$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f622e64b75e035a8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f622e64b75e035a8$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $f622e64b75e035a8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f622e64b75e035a8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $f622e64b75e035a8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f622e64b75e035a8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f622e64b75e035a8$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $f622e64b75e035a8$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f622e64b75e035a8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f622e64b75e035a8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f622e64b75e035a8$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f622e64b75e035a8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f622e64b75e035a8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f622e64b75e035a8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f622e64b75e035a8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $f622e64b75e035a8$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($f622e64b75e035a8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f622e64b75e035a8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $f622e64b75e035a8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f622e64b75e035a8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f622e64b75e035a8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f622e64b75e035a8$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f622e64b75e035a8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f622e64b75e035a8$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f622e64b75e035a8$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f622e64b75e035a8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f622e64b75e035a8$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f622e64b75e035a8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $f622e64b75e035a8$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $f622e64b75e035a8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f622e64b75e035a8$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f622e64b75e035a8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $f622e64b75e035a8$var$findNearestBoundary(matches).route.id,
            {
                type: $f622e64b75e035a8$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f622e64b75e035a8$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($f622e64b75e035a8$var$isErrorResult(result) && $f622e64b75e035a8$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f622e64b75e035a8$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $f622e64b75e035a8$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f622e64b75e035a8$var$_extends({
            matches: updatedMatches || matches
        }, $f622e64b75e035a8$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $f622e64b75e035a8$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $f622e64b75e035a8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $f622e64b75e035a8$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $f622e64b75e035a8$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $f622e64b75e035a8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f622e64b75e035a8$var$ResultType.error,
            error: $f622e64b75e035a8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f622e64b75e035a8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $f622e64b75e035a8$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f622e64b75e035a8$var$isDeferredResult(result)) throw $f622e64b75e035a8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($f622e64b75e035a8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f622e64b75e035a8$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $f622e64b75e035a8$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $f622e64b75e035a8$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $f622e64b75e035a8$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($f622e64b75e035a8$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $f622e64b75e035a8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f622e64b75e035a8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f622e64b75e035a8$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $f622e64b75e035a8$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $f622e64b75e035a8$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f622e64b75e035a8$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $f622e64b75e035a8$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f622e64b75e035a8$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $f622e64b75e035a8$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f622e64b75e035a8$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$f622e64b75e035a8$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $f622e64b75e035a8$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f622e64b75e035a8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f622e64b75e035a8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $f622e64b75e035a8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f622e64b75e035a8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $f622e64b75e035a8$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f622e64b75e035a8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $f622e64b75e035a8$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f622e64b75e035a8$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f622e64b75e035a8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f622e64b75e035a8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $f622e64b75e035a8$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($f622e64b75e035a8$var$isRedirectResult(actionResult) || $f622e64b75e035a8$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f622e64b75e035a8$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($f622e64b75e035a8$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $f622e64b75e035a8$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f622e64b75e035a8$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($f622e64b75e035a8$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($f622e64b75e035a8$var$isDeferredResult(actionResult)) throw $f622e64b75e035a8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f622e64b75e035a8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f622e64b75e035a8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f622e64b75e035a8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f622e64b75e035a8$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f622e64b75e035a8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $f622e64b75e035a8$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f622e64b75e035a8$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $f622e64b75e035a8$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f622e64b75e035a8$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $f622e64b75e035a8$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f622e64b75e035a8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $f622e64b75e035a8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f622e64b75e035a8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f622e64b75e035a8$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f622e64b75e035a8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $f622e64b75e035a8$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f622e64b75e035a8$var$isDeferredResult(result)) result = await $f622e64b75e035a8$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $f622e64b75e035a8$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f622e64b75e035a8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $f622e64b75e035a8$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($f622e64b75e035a8$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $f622e64b75e035a8$export$3e9cee6b33872309(!$f622e64b75e035a8$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $f622e64b75e035a8$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $f622e64b75e035a8$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $f622e64b75e035a8$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $f622e64b75e035a8$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($f622e64b75e035a8$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f622e64b75e035a8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $f622e64b75e035a8$export$e19cd5f9376f8cee.Replace : $f622e64b75e035a8$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f622e64b75e035a8$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($f622e64b75e035a8$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $f622e64b75e035a8$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f622e64b75e035a8$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $f622e64b75e035a8$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $f622e64b75e035a8$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $f622e64b75e035a8$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($f622e64b75e035a8$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $f622e64b75e035a8$var$ResultType.redirect,
                response: $f622e64b75e035a8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $f622e64b75e035a8$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $f622e64b75e035a8$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $f622e64b75e035a8$var$ResultType.error,
                    error: $f622e64b75e035a8$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $f622e64b75e035a8$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $f622e64b75e035a8$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $f622e64b75e035a8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $f622e64b75e035a8$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $f622e64b75e035a8$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f622e64b75e035a8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f622e64b75e035a8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f622e64b75e035a8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f622e64b75e035a8$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f622e64b75e035a8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f622e64b75e035a8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $f622e64b75e035a8$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $f622e64b75e035a8$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f622e64b75e035a8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$f622e64b75e035a8$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $f622e64b75e035a8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $f622e64b75e035a8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $f622e64b75e035a8$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $f622e64b75e035a8$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $f622e64b75e035a8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f622e64b75e035a8$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $f622e64b75e035a8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f622e64b75e035a8$export$4d0306f8f6a4585b = Symbol("deferred");
function $f622e64b75e035a8$export$3336b097a6fbc59a(routes, opts) {
    $f622e64b75e035a8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f622e64b75e035a8$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $f622e64b75e035a8$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $f622e64b75e035a8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f622e64b75e035a8$var$createLocation("", $f622e64b75e035a8$export$fe53371bee54353d(url), null, "default");
        let matches = $f622e64b75e035a8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f622e64b75e035a8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f622e64b75e035a8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f622e64b75e035a8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f622e64b75e035a8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f622e64b75e035a8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($f622e64b75e035a8$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f622e64b75e035a8$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f622e64b75e035a8$var$createLocation("", $f622e64b75e035a8$export$fe53371bee54353d(url), null, "default");
        let matches = $f622e64b75e035a8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f622e64b75e035a8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f622e64b75e035a8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f622e64b75e035a8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f622e64b75e035a8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f622e64b75e035a8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f622e64b75e035a8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($f622e64b75e035a8$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f622e64b75e035a8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $f622e64b75e035a8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f622e64b75e035a8$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f622e64b75e035a8$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $f622e64b75e035a8$var$isResponse(result) ? result : $f622e64b75e035a8$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($f622e64b75e035a8$var$isDataStrategyResult(e) && $f622e64b75e035a8$var$isResponse(e.result)) {
                if (e.type === $f622e64b75e035a8$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f622e64b75e035a8$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f622e64b75e035a8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f622e64b75e035a8$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $f622e64b75e035a8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($f622e64b75e035a8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($f622e64b75e035a8$var$isDeferredResult(result)) {
            let error = $f622e64b75e035a8$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f622e64b75e035a8$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f622e64b75e035a8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f622e64b75e035a8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f622e64b75e035a8$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $f622e64b75e035a8$var$_extends({}, context, {
                statusCode: $f622e64b75e035a8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $f622e64b75e035a8$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $f622e64b75e035a8$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f622e64b75e035a8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $f622e64b75e035a8$var$isErrorResult(pendingActionResult[1]) ? $f622e64b75e035a8$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $f622e64b75e035a8$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $f622e64b75e035a8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f622e64b75e035a8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f622e64b75e035a8$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $f622e64b75e035a8$var$callDataStrategyImpl(dataStrategy || $f622e64b75e035a8$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($f622e64b75e035a8$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $f622e64b75e035a8$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($f622e64b75e035a8$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $f622e64b75e035a8$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f622e64b75e035a8$export$fec11da027c70692(routes, context, error) {
    let newContext = $f622e64b75e035a8$var$_extends({}, context, {
        statusCode: $f622e64b75e035a8$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f622e64b75e035a8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $f622e64b75e035a8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $f622e64b75e035a8$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $f622e64b75e035a8$export$cae722b0cc860f13(to ? to : ".", $f622e64b75e035a8$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $f622e64b75e035a8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $f622e64b75e035a8$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f622e64b75e035a8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f622e64b75e035a8$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f622e64b75e035a8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f622e64b75e035a8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f622e64b75e035a8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f622e64b75e035a8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f622e64b75e035a8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $f622e64b75e035a8$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$f622e64b75e035a8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$f622e64b75e035a8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f622e64b75e035a8$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f622e64b75e035a8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f622e64b75e035a8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f622e64b75e035a8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f622e64b75e035a8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($f622e64b75e035a8$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f622e64b75e035a8$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f622e64b75e035a8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f622e64b75e035a8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $f622e64b75e035a8$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $f622e64b75e035a8$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $f622e64b75e035a8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $f622e64b75e035a8$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $f622e64b75e035a8$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $f622e64b75e035a8$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $f622e64b75e035a8$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($f622e64b75e035a8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f622e64b75e035a8$var$shouldRevalidateLoader(match, $f622e64b75e035a8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f622e64b75e035a8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $f622e64b75e035a8$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $f622e64b75e035a8$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $f622e64b75e035a8$var$shouldRevalidateLoader(fetcherMatch, $f622e64b75e035a8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f622e64b75e035a8$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $f622e64b75e035a8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f622e64b75e035a8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f622e64b75e035a8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $f622e64b75e035a8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $f622e64b75e035a8$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$f622e64b75e035a8$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $f622e64b75e035a8$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $f622e64b75e035a8$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$f622e64b75e035a8$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f622e64b75e035a8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f622e64b75e035a8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f622e64b75e035a8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$f622e64b75e035a8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f622e64b75e035a8$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $f622e64b75e035a8$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $f622e64b75e035a8$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $f622e64b75e035a8$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $f622e64b75e035a8$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $f622e64b75e035a8$var$ResultType.data,
                result: undefined
            });
        };
        return $f622e64b75e035a8$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $f622e64b75e035a8$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f622e64b75e035a8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f622e64b75e035a8$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f622e64b75e035a8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f622e64b75e035a8$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $f622e64b75e035a8$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f622e64b75e035a8$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($f622e64b75e035a8$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $f622e64b75e035a8$var$ResultType.error,
                error: e
            };
        }
        if (type === $f622e64b75e035a8$var$ResultType.error) return {
            type: $f622e64b75e035a8$var$ResultType.error,
            error: new $f622e64b75e035a8$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $f622e64b75e035a8$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $f622e64b75e035a8$var$ResultType.error) {
        if ($f622e64b75e035a8$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $f622e64b75e035a8$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $f622e64b75e035a8$var$ResultType.error,
                error: new $f622e64b75e035a8$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $f622e64b75e035a8$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $f622e64b75e035a8$var$ResultType.error,
            error: result,
            statusCode: $f622e64b75e035a8$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($f622e64b75e035a8$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $f622e64b75e035a8$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($f622e64b75e035a8$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $f622e64b75e035a8$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $f622e64b75e035a8$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $f622e64b75e035a8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $f622e64b75e035a8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$f622e64b75e035a8$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f622e64b75e035a8$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $f622e64b75e035a8$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($f622e64b75e035a8$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $f622e64b75e035a8$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f622e64b75e035a8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f622e64b75e035a8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f622e64b75e035a8$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $f622e64b75e035a8$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f622e64b75e035a8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f622e64b75e035a8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f622e64b75e035a8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f622e64b75e035a8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $f622e64b75e035a8$export$3e9cee6b33872309(!$f622e64b75e035a8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f622e64b75e035a8$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $f622e64b75e035a8$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f622e64b75e035a8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($f622e64b75e035a8$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f622e64b75e035a8$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f622e64b75e035a8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $f622e64b75e035a8$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($f622e64b75e035a8$var$isErrorResult(result)) {
            let boundaryMatch = $f622e64b75e035a8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f622e64b75e035a8$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f622e64b75e035a8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f622e64b75e035a8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f622e64b75e035a8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f622e64b75e035a8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $f622e64b75e035a8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f622e64b75e035a8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f622e64b75e035a8$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f622e64b75e035a8$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f622e64b75e035a8$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f622e64b75e035a8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f622e64b75e035a8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f622e64b75e035a8$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $f622e64b75e035a8$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $f622e64b75e035a8$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($f622e64b75e035a8$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $f622e64b75e035a8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f622e64b75e035a8$export$8ccf933b0513f8d0(path) : path;
    return $f622e64b75e035a8$export$fe53371bee54353d($f622e64b75e035a8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f622e64b75e035a8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f622e64b75e035a8$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $f622e64b75e035a8$var$ResultType.data || result.type === $f622e64b75e035a8$var$ResultType.error);
}
function $f622e64b75e035a8$var$isRedirectDataStrategyResultResult(result) {
    return $f622e64b75e035a8$var$isResponse(result.result) && $f622e64b75e035a8$var$redirectStatusCodes.has(result.result.status);
}
function $f622e64b75e035a8$var$isDeferredResult(result) {
    return result.type === $f622e64b75e035a8$var$ResultType.deferred;
}
function $f622e64b75e035a8$var$isErrorResult(result) {
    return result.type === $f622e64b75e035a8$var$ResultType.error;
}
function $f622e64b75e035a8$var$isRedirectResult(result) {
    return (result && result.type) === $f622e64b75e035a8$var$ResultType.redirect;
}
function $f622e64b75e035a8$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $f622e64b75e035a8$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f622e64b75e035a8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f622e64b75e035a8$var$isRedirectResponse(result) {
    if (!$f622e64b75e035a8$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f622e64b75e035a8$var$isValidMethod(method) {
    return $f622e64b75e035a8$var$validRequestMethods.has(method.toLowerCase());
}
function $f622e64b75e035a8$var$isMutationMethod(method) {
    return $f622e64b75e035a8$var$validMutationMethods.has(method.toLowerCase());
}
async function $f622e64b75e035a8$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f622e64b75e035a8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f622e64b75e035a8$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $f622e64b75e035a8$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $f622e64b75e035a8$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($f622e64b75e035a8$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $f622e64b75e035a8$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $f622e64b75e035a8$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $f622e64b75e035a8$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f622e64b75e035a8$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f622e64b75e035a8$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f622e64b75e035a8$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f622e64b75e035a8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f622e64b75e035a8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f622e64b75e035a8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f622e64b75e035a8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f622e64b75e035a8$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f622e64b75e035a8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $f622e64b75e035a8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $f622e64b75e035a8$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f622e64b75e035a8$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $f622e64b75e035a8$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $f622e64b75e035a8$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $f622e64b75e035a8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f622e64b75e035a8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $f622e64b75e035a8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f622e64b75e035a8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f622e64b75e035a8$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $9kKA1 = parcelRequire("9kKA1");

function $7a35efd9976b1f32$var$_extends() {
    $7a35efd9976b1f32$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a35efd9976b1f32$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7a35efd9976b1f32$export$3add0d5dce533e2e = /*#__PURE__*/ $9kKA1.createContext(null);
const $7a35efd9976b1f32$export$145dfa71566a64dc = /*#__PURE__*/ $9kKA1.createContext(null);
const $7a35efd9976b1f32$var$AwaitContext = /*#__PURE__*/ $9kKA1.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7a35efd9976b1f32$export$26749e8557646306 = /*#__PURE__*/ $9kKA1.createContext(null);
const $7a35efd9976b1f32$export$c7914228fb69b0f5 = /*#__PURE__*/ $9kKA1.createContext(null);
const $7a35efd9976b1f32$export$9072aa6dd1f93057 = /*#__PURE__*/ $9kKA1.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7a35efd9976b1f32$var$RouteErrorContext = /*#__PURE__*/ $9kKA1.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7a35efd9976b1f32$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7a35efd9976b1f32$export$9c954a9d03d32f4a() && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $9kKA1.useContext($7a35efd9976b1f32$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7a35efd9976b1f32$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f622e64b75e035a8$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7a35efd9976b1f32$export$9c954a9d03d32f4a() {
    return $9kKA1.useContext($7a35efd9976b1f32$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7a35efd9976b1f32$export$45d76561a5302f2b() {
    !$7a35efd9976b1f32$export$9c954a9d03d32f4a() && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    return $9kKA1.useContext($7a35efd9976b1f32$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7a35efd9976b1f32$export$1b3f31771c5d07c() {
    return $9kKA1.useContext($7a35efd9976b1f32$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7a35efd9976b1f32$export$6c330e8992e8a295(pattern) {
    !$7a35efd9976b1f32$export$9c954a9d03d32f4a() && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7a35efd9976b1f32$export$45d76561a5302f2b();
    return $9kKA1.useMemo(()=>(0, $f622e64b75e035a8$export$81336c211d5ff295)(pattern, (0, $f622e64b75e035a8$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7a35efd9976b1f32$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7a35efd9976b1f32$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $9kKA1.useContext($7a35efd9976b1f32$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $9kKA1.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7a35efd9976b1f32$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $9kKA1.useContext($7a35efd9976b1f32$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7a35efd9976b1f32$var$useNavigateStable() : $7a35efd9976b1f32$var$useNavigateUnstable();
}
function $7a35efd9976b1f32$var$useNavigateUnstable() {
    !$7a35efd9976b1f32$export$9c954a9d03d32f4a() && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    let dataRouterContext = $9kKA1.useContext($7a35efd9976b1f32$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $9kKA1.useContext($7a35efd9976b1f32$export$26749e8557646306);
    let { matches: matches } = $9kKA1.useContext($7a35efd9976b1f32$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a35efd9976b1f32$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f622e64b75e035a8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $9kKA1.useRef(false);
    $7a35efd9976b1f32$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $9kKA1.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f622e64b75e035a8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f622e64b75e035a8$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7a35efd9976b1f32$var$OutletContext = /*#__PURE__*/ $9kKA1.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7a35efd9976b1f32$export$4138103a3ae699cc() {
    return $9kKA1.useContext($7a35efd9976b1f32$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7a35efd9976b1f32$export$a3be3530d8e40d0b(context) {
    let outlet = $9kKA1.useContext($7a35efd9976b1f32$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7a35efd9976b1f32$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $9kKA1.useContext($7a35efd9976b1f32$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7a35efd9976b1f32$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $9kKA1.useContext($7a35efd9976b1f32$export$26749e8557646306);
    let { matches: matches } = $9kKA1.useContext($7a35efd9976b1f32$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a35efd9976b1f32$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f622e64b75e035a8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $9kKA1.useMemo(()=>(0, $f622e64b75e035a8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7a35efd9976b1f32$export$5d3fca4a98652595(routes, locationArg) {
    return $7a35efd9976b1f32$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7a35efd9976b1f32$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7a35efd9976b1f32$export$9c954a9d03d32f4a() && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $9kKA1.useContext($7a35efd9976b1f32$export$26749e8557646306);
    let { matches: parentMatches } = $9kKA1.useContext($7a35efd9976b1f32$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7a35efd9976b1f32$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f622e64b75e035a8$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $f622e64b75e035a8$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7a35efd9976b1f32$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f622e64b75e035a8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f622e64b75e035a8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7a35efd9976b1f32$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f622e64b75e035a8$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7a35efd9976b1f32$var$DefaultErrorComponent() {
    let error = $7a35efd9976b1f32$export$ed527bf60f6e05f2();
    let message = (0, $f622e64b75e035a8$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $9kKA1.createElement($9kKA1.Fragment, null, /*#__PURE__*/ $9kKA1.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $9kKA1.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $9kKA1.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7a35efd9976b1f32$var$defaultErrorElement = /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$DefaultErrorComponent, null);
class $7a35efd9976b1f32$var$RenderErrorBoundary extends $9kKA1.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $7a35efd9976b1f32$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $9kKA1.useContext($7a35efd9976b1f32$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7a35efd9976b1f32$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7a35efd9976b1f32$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7a35efd9976b1f32$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $9kKA1.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7a35efd9976b1f32$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7a35efd9976b1f32$var$DataRouterHook || {});
var $7a35efd9976b1f32$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7a35efd9976b1f32$var$DataRouterStateHook || {});
function $7a35efd9976b1f32$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7a35efd9976b1f32$var$useDataRouterContext(hookName) {
    let ctx = $9kKA1.useContext($7a35efd9976b1f32$export$3add0d5dce533e2e);
    !ctx && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7a35efd9976b1f32$var$useDataRouterState(hookName) {
    let state = $9kKA1.useContext($7a35efd9976b1f32$export$145dfa71566a64dc);
    !state && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    return state;
}
function $7a35efd9976b1f32$var$useRouteContext(hookName) {
    let route = $9kKA1.useContext($7a35efd9976b1f32$export$9072aa6dd1f93057);
    !route && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7a35efd9976b1f32$var$useCurrentRouteId(hookName) {
    let route = $7a35efd9976b1f32$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7a35efd9976b1f32$export$5fc8298006ad9e58() {
    return $7a35efd9976b1f32$var$useCurrentRouteId($7a35efd9976b1f32$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7a35efd9976b1f32$export$d0fd4b7106de2769() {
    let state = $7a35efd9976b1f32$var$useDataRouterState($7a35efd9976b1f32$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7a35efd9976b1f32$export$600dc272ed516c15() {
    let dataRouterContext = $7a35efd9976b1f32$var$useDataRouterContext($7a35efd9976b1f32$var$DataRouterHook.UseRevalidator);
    let state = $7a35efd9976b1f32$var$useDataRouterState($7a35efd9976b1f32$var$DataRouterStateHook.UseRevalidator);
    return $9kKA1.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7a35efd9976b1f32$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7a35efd9976b1f32$var$useDataRouterState($7a35efd9976b1f32$var$DataRouterStateHook.UseMatches);
    return $9kKA1.useMemo(()=>matches.map((m)=>(0, $f622e64b75e035a8$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7a35efd9976b1f32$export$1448a5050d252c4d() {
    let state = $7a35efd9976b1f32$var$useDataRouterState($7a35efd9976b1f32$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7a35efd9976b1f32$var$useCurrentRouteId($7a35efd9976b1f32$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7a35efd9976b1f32$export$fd5d37484eab868d(routeId) {
    let state = $7a35efd9976b1f32$var$useDataRouterState($7a35efd9976b1f32$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7a35efd9976b1f32$export$fdc00f3f26066d5e() {
    let state = $7a35efd9976b1f32$var$useDataRouterState($7a35efd9976b1f32$var$DataRouterStateHook.UseActionData);
    let routeId = $7a35efd9976b1f32$var$useCurrentRouteId($7a35efd9976b1f32$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7a35efd9976b1f32$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $9kKA1.useContext($7a35efd9976b1f32$var$RouteErrorContext);
    let state = $7a35efd9976b1f32$var$useDataRouterState($7a35efd9976b1f32$var$DataRouterStateHook.UseRouteError);
    let routeId = $7a35efd9976b1f32$var$useCurrentRouteId($7a35efd9976b1f32$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7a35efd9976b1f32$export$78a72ddb39bdd145() {
    let value = $9kKA1.useContext($7a35efd9976b1f32$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7a35efd9976b1f32$export$17f53340677d5831() {
    let value = $9kKA1.useContext($7a35efd9976b1f32$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7a35efd9976b1f32$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7a35efd9976b1f32$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7a35efd9976b1f32$var$useDataRouterContext($7a35efd9976b1f32$var$DataRouterHook.UseBlocker);
    let state = $7a35efd9976b1f32$var$useDataRouterState($7a35efd9976b1f32$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $9kKA1.useState("");
    let blockerFunction = $9kKA1.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7a35efd9976b1f32$var$_extends({}, currentLocation, {
                pathname: (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7a35efd9976b1f32$var$_extends({}, nextLocation, {
                pathname: (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $9kKA1.useEffect(()=>{
        let key = String(++$7a35efd9976b1f32$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $9kKA1.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f622e64b75e035a8$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7a35efd9976b1f32$var$useNavigateStable() {
    let { router: router } = $7a35efd9976b1f32$var$useDataRouterContext($7a35efd9976b1f32$var$DataRouterHook.UseNavigateStable);
    let id = $7a35efd9976b1f32$var$useCurrentRouteId($7a35efd9976b1f32$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $9kKA1.useRef(false);
    $7a35efd9976b1f32$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $9kKA1.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7a35efd9976b1f32$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7a35efd9976b1f32$var$alreadyWarned$1 = {};
function $7a35efd9976b1f32$var$warningOnce(key, cond, message) {
    if (!cond && !$7a35efd9976b1f32$var$alreadyWarned$1[key]) $7a35efd9976b1f32$var$alreadyWarned$1[key] = true;
}
const $7a35efd9976b1f32$var$alreadyWarned = {};
function $7a35efd9976b1f32$var$warnOnce(key, message) {}
const $7a35efd9976b1f32$var$logDeprecation = (flag, msg, link)=>$7a35efd9976b1f32$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7a35efd9976b1f32$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7a35efd9976b1f32$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7a35efd9976b1f32$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7a35efd9976b1f32$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7a35efd9976b1f32$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7a35efd9976b1f32$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7a35efd9976b1f32$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7a35efd9976b1f32$var$START_TRANSITION = "startTransition";
const $7a35efd9976b1f32$var$startTransitionImpl = $9kKA1[$7a35efd9976b1f32$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7a35efd9976b1f32$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $9kKA1.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9kKA1.useCallback((newState)=>{
        if (v7_startTransition && $7a35efd9976b1f32$var$startTransitionImpl) $7a35efd9976b1f32$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $9kKA1.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $9kKA1.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $9kKA1.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $9kKA1.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $9kKA1.useEffect(()=>$7a35efd9976b1f32$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $9kKA1.createElement($9kKA1.Fragment, null, /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7a35efd9976b1f32$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7a35efd9976b1f32$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7a35efd9976b1f32$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $9kKA1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f622e64b75e035a8$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9kKA1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9kKA1.useCallback((newState)=>{
        v7_startTransition && $7a35efd9976b1f32$var$startTransitionImpl ? $7a35efd9976b1f32$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9kKA1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $9kKA1.useEffect(()=>$7a35efd9976b1f32$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7a35efd9976b1f32$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7a35efd9976b1f32$export$9c954a9d03d32f4a() && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $9kKA1.useContext($7a35efd9976b1f32$export$26749e8557646306);
    let { matches: matches } = $9kKA1.useContext($7a35efd9976b1f32$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7a35efd9976b1f32$export$45d76561a5302f2b();
    let navigate = $7a35efd9976b1f32$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f622e64b75e035a8$export$cae722b0cc860f13)(to, (0, $f622e64b75e035a8$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $9kKA1.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7a35efd9976b1f32$export$910ae8079b2c2852(props) {
    return $7a35efd9976b1f32$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7a35efd9976b1f32$export$e7b0ac011bb776c6(_props) {
    (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7a35efd9976b1f32$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f622e64b75e035a8$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7a35efd9976b1f32$export$9c954a9d03d32f4a() && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $9kKA1.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7a35efd9976b1f32$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f622e64b75e035a8$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $9kKA1.useMemo(()=>{
        let trailingPathname = (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7a35efd9976b1f32$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7a35efd9976b1f32$export$5d3fca4a98652595($7a35efd9976b1f32$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7a35efd9976b1f32$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$ResolveAwait, null, children));
}
var $7a35efd9976b1f32$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7a35efd9976b1f32$var$AwaitRenderStatus || {});
const $7a35efd9976b1f32$var$neverSettledPromise = new Promise(()=>{});
class $7a35efd9976b1f32$var$AwaitErrorBoundary extends $9kKA1.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7a35efd9976b1f32$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7a35efd9976b1f32$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7a35efd9976b1f32$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7a35efd9976b1f32$var$AwaitRenderStatus.error : "_data" in promise ? $7a35efd9976b1f32$var$AwaitRenderStatus.success : $7a35efd9976b1f32$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7a35efd9976b1f32$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7a35efd9976b1f32$var$AwaitRenderStatus.error && promise._error instanceof (0, $f622e64b75e035a8$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7a35efd9976b1f32$var$neverSettledPromise;
        if (status === $7a35efd9976b1f32$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7a35efd9976b1f32$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7a35efd9976b1f32$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $9kKA1.createElement($7a35efd9976b1f32$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7a35efd9976b1f32$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7a35efd9976b1f32$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $9kKA1.createElement($9kKA1.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7a35efd9976b1f32$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $9kKA1.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $9kKA1.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $9kKA1.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7a35efd9976b1f32$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7a35efd9976b1f32$export$e7b0ac011bb776c6) && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7a35efd9976b1f32$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7a35efd9976b1f32$export$daf73786167a7f72(matches) {
    return $7a35efd9976b1f32$var$_renderMatches(matches);
}
function $7a35efd9976b1f32$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $9kKA1.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $9kKA1.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $9kKA1.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7a35efd9976b1f32$export$f30f7e456d254e83(routes, opts) {
    return (0, $f622e64b75e035a8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7a35efd9976b1f32$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f622e64b75e035a8$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7a35efd9976b1f32$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $6c90d8a012cccc16$var$_extends() {
    $6c90d8a012cccc16$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6c90d8a012cccc16$var$_extends.apply(this, arguments);
}
function $6c90d8a012cccc16$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $6c90d8a012cccc16$var$defaultMethod = "get";
const $6c90d8a012cccc16$var$defaultEncType = "application/x-www-form-urlencoded";
function $6c90d8a012cccc16$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $6c90d8a012cccc16$var$isButtonElement(object) {
    return $6c90d8a012cccc16$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $6c90d8a012cccc16$var$isFormElement(object) {
    return $6c90d8a012cccc16$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $6c90d8a012cccc16$var$isInputElement(object) {
    return $6c90d8a012cccc16$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $6c90d8a012cccc16$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $6c90d8a012cccc16$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$6c90d8a012cccc16$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $6c90d8a012cccc16$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $6c90d8a012cccc16$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $6c90d8a012cccc16$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $6c90d8a012cccc16$var$_formDataSupportsSubmitter = null;
function $6c90d8a012cccc16$var$isFormDataSubmitterSupported() {
    if ($6c90d8a012cccc16$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $6c90d8a012cccc16$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $6c90d8a012cccc16$var$_formDataSupportsSubmitter = true;
    }
    return $6c90d8a012cccc16$var$_formDataSupportsSubmitter;
}
const $6c90d8a012cccc16$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $6c90d8a012cccc16$var$getFormEncType(encType) {
    if (encType != null && !$6c90d8a012cccc16$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $6c90d8a012cccc16$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($6c90d8a012cccc16$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $6c90d8a012cccc16$var$defaultMethod;
        encType = $6c90d8a012cccc16$var$getFormEncType(target.getAttribute("enctype")) || $6c90d8a012cccc16$var$defaultEncType;
        formData = new FormData(target);
    } else if ($6c90d8a012cccc16$var$isButtonElement(target) || $6c90d8a012cccc16$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $6c90d8a012cccc16$var$defaultMethod;
        encType = $6c90d8a012cccc16$var$getFormEncType(target.getAttribute("formenctype")) || $6c90d8a012cccc16$var$getFormEncType(form.getAttribute("enctype")) || $6c90d8a012cccc16$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$6c90d8a012cccc16$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($6c90d8a012cccc16$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $6c90d8a012cccc16$var$defaultMethod;
        action = null;
        encType = $6c90d8a012cccc16$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $6c90d8a012cccc16$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $6c90d8a012cccc16$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $6c90d8a012cccc16$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $6c90d8a012cccc16$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $6c90d8a012cccc16$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $6c90d8a012cccc16$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f622e64b75e035a8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6c90d8a012cccc16$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f622e64b75e035a8$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $6c90d8a012cccc16$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7a35efd9976b1f32$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $6c90d8a012cccc16$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f622e64b75e035a8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6c90d8a012cccc16$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f622e64b75e035a8$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $6c90d8a012cccc16$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7a35efd9976b1f32$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $6c90d8a012cccc16$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $6c90d8a012cccc16$var$_extends({}, state, {
        errors: $6c90d8a012cccc16$var$deserializeErrors(state.errors)
    });
    return state;
}
function $6c90d8a012cccc16$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f622e64b75e035a8$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $6c90d8a012cccc16$export$7ad602f0e94e62d1 = /*#__PURE__*/ $9kKA1.createContext({
    isTransitioning: false
});
const $6c90d8a012cccc16$export$148fd98d095596d4 = /*#__PURE__*/ $9kKA1.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6c90d8a012cccc16$var$START_TRANSITION = "startTransition";
const $6c90d8a012cccc16$var$startTransitionImpl = $9kKA1[$6c90d8a012cccc16$var$START_TRANSITION];
const $6c90d8a012cccc16$var$FLUSH_SYNC = "flushSync";
const $6c90d8a012cccc16$var$flushSyncImpl = $aba877308eacd357$exports[$6c90d8a012cccc16$var$FLUSH_SYNC];
const $6c90d8a012cccc16$var$USE_ID = "useId";
const $6c90d8a012cccc16$var$useIdImpl = $9kKA1[$6c90d8a012cccc16$var$USE_ID];
function $6c90d8a012cccc16$var$startTransitionSafe(cb) {
    if ($6c90d8a012cccc16$var$startTransitionImpl) $6c90d8a012cccc16$var$startTransitionImpl(cb);
    else cb();
}
function $6c90d8a012cccc16$var$flushSyncSafe(cb) {
    if ($6c90d8a012cccc16$var$flushSyncImpl) $6c90d8a012cccc16$var$flushSyncImpl(cb);
    else cb();
}
class $6c90d8a012cccc16$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6c90d8a012cccc16$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $9kKA1.useState(router.state);
    let [pendingState, setPendingState] = $9kKA1.useState();
    let [vtContext, setVtContext] = $9kKA1.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $9kKA1.useState();
    let [transition, setTransition] = $9kKA1.useState();
    let [interruption, setInterruption] = $9kKA1.useState();
    let fetcherData = $9kKA1.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $9kKA1.useCallback((cb)=>{
        if (v7_startTransition) $6c90d8a012cccc16$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $9kKA1.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $6c90d8a012cccc16$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $6c90d8a012cccc16$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $6c90d8a012cccc16$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $6c90d8a012cccc16$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $6c90d8a012cccc16$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $9kKA1.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $9kKA1.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $6c90d8a012cccc16$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $9kKA1.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $9kKA1.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $9kKA1.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $9kKA1.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $9kKA1.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $9kKA1.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $9kKA1.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $9kKA1.useEffect(()=>(0, $7a35efd9976b1f32$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $9kKA1.createElement($9kKA1.Fragment, null, /*#__PURE__*/ $9kKA1.createElement((0, $7a35efd9976b1f32$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $9kKA1.createElement((0, $7a35efd9976b1f32$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $9kKA1.createElement($6c90d8a012cccc16$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $9kKA1.createElement($6c90d8a012cccc16$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $9kKA1.createElement((0, $7a35efd9976b1f32$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $9kKA1.createElement($6c90d8a012cccc16$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $6c90d8a012cccc16$var$MemoizedDataRoutes = /*#__PURE__*/ $9kKA1.memo($6c90d8a012cccc16$var$DataRoutes);
function $6c90d8a012cccc16$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7a35efd9976b1f32$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $6c90d8a012cccc16$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $9kKA1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f622e64b75e035a8$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9kKA1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9kKA1.useCallback((newState)=>{
        v7_startTransition && $6c90d8a012cccc16$var$startTransitionImpl ? $6c90d8a012cccc16$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9kKA1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $9kKA1.useEffect(()=>(0, $7a35efd9976b1f32$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $9kKA1.createElement((0, $7a35efd9976b1f32$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $6c90d8a012cccc16$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $9kKA1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f622e64b75e035a8$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9kKA1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9kKA1.useCallback((newState)=>{
        v7_startTransition && $6c90d8a012cccc16$var$startTransitionImpl ? $6c90d8a012cccc16$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9kKA1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $9kKA1.useEffect(()=>(0, $7a35efd9976b1f32$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $9kKA1.createElement((0, $7a35efd9976b1f32$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $6c90d8a012cccc16$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $9kKA1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9kKA1.useCallback((newState)=>{
        v7_startTransition && $6c90d8a012cccc16$var$startTransitionImpl ? $6c90d8a012cccc16$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9kKA1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $9kKA1.useEffect(()=>(0, $7a35efd9976b1f32$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $9kKA1.createElement((0, $7a35efd9976b1f32$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $6c90d8a012cccc16$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $6c90d8a012cccc16$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $6c90d8a012cccc16$export$a6c7ac8248d6e38a = /*#__PURE__*/ $9kKA1.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $6c90d8a012cccc16$var$_objectWithoutPropertiesLoose(_ref7, $6c90d8a012cccc16$var$_excluded);
    let { basename: basename } = $9kKA1.useContext((0, $7a35efd9976b1f32$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $6c90d8a012cccc16$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($6c90d8a012cccc16$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7a35efd9976b1f32$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $6c90d8a012cccc16$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $9kKA1.createElement("a", $6c90d8a012cccc16$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $6c90d8a012cccc16$export$b0d92dbee9b5b60d = /*#__PURE__*/ $9kKA1.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $6c90d8a012cccc16$var$_objectWithoutPropertiesLoose(_ref8, $6c90d8a012cccc16$var$_excluded2);
    let path = (0, $7a35efd9976b1f32$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7a35efd9976b1f32$export$45d76561a5302f2b)();
    let routerState = $9kKA1.useContext((0, $7a35efd9976b1f32$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $9kKA1.useContext((0, $7a35efd9976b1f32$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6c90d8a012cccc16$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $9kKA1.createElement($6c90d8a012cccc16$export$a6c7ac8248d6e38a, $6c90d8a012cccc16$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $6c90d8a012cccc16$export$a7fed597f4b8afd8 = /*#__PURE__*/ $9kKA1.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $6c90d8a012cccc16$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $6c90d8a012cccc16$var$_objectWithoutPropertiesLoose(_ref9, $6c90d8a012cccc16$var$_excluded3);
    let submit = $6c90d8a012cccc16$export$47c85c6e3a081d3();
    let formAction = $6c90d8a012cccc16$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $9kKA1.createElement("form", $6c90d8a012cccc16$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $6c90d8a012cccc16$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $6c90d8a012cccc16$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $6c90d8a012cccc16$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($6c90d8a012cccc16$var$DataRouterHook || ($6c90d8a012cccc16$var$DataRouterHook = {}));
var $6c90d8a012cccc16$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($6c90d8a012cccc16$var$DataRouterStateHook || ($6c90d8a012cccc16$var$DataRouterStateHook = {}));
// Internal hooks
function $6c90d8a012cccc16$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $6c90d8a012cccc16$var$useDataRouterContext(hookName) {
    let ctx = $9kKA1.useContext((0, $7a35efd9976b1f32$export$3add0d5dce533e2e));
    !ctx && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $6c90d8a012cccc16$var$useDataRouterState(hookName) {
    let state = $9kKA1.useContext((0, $7a35efd9976b1f32$export$145dfa71566a64dc));
    !state && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $6c90d8a012cccc16$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7a35efd9976b1f32$export$9770f232ac06a008)();
    let location = (0, $7a35efd9976b1f32$export$45d76561a5302f2b)();
    let path = (0, $7a35efd9976b1f32$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $9kKA1.useCallback((event)=>{
        if ($6c90d8a012cccc16$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $f622e64b75e035a8$export$fe53371bee54353d)(location) === (0, $f622e64b75e035a8$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $6c90d8a012cccc16$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $9kKA1.useRef($6c90d8a012cccc16$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $9kKA1.useRef(false);
    let location = (0, $7a35efd9976b1f32$export$45d76561a5302f2b)();
    let searchParams = $9kKA1.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $6c90d8a012cccc16$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7a35efd9976b1f32$export$9770f232ac06a008)();
    let setSearchParams = $9kKA1.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $6c90d8a012cccc16$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $6c90d8a012cccc16$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $6c90d8a012cccc16$var$fetcherId = 0;
let $6c90d8a012cccc16$var$getUniqueFetcherId = ()=>"__" + String(++$6c90d8a012cccc16$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $6c90d8a012cccc16$export$47c85c6e3a081d3() {
    let { router: router } = $6c90d8a012cccc16$var$useDataRouterContext($6c90d8a012cccc16$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $9kKA1.useContext((0, $7a35efd9976b1f32$export$26749e8557646306));
    let currentRouteId = (0, $7a35efd9976b1f32$export$5fc8298006ad9e58)();
    return $9kKA1.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $6c90d8a012cccc16$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $6c90d8a012cccc16$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $6c90d8a012cccc16$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $6c90d8a012cccc16$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $9kKA1.useContext((0, $7a35efd9976b1f32$export$26749e8557646306));
    let routeContext = $9kKA1.useContext((0, $7a35efd9976b1f32$export$9072aa6dd1f93057));
    !routeContext && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $6c90d8a012cccc16$var$_extends({}, (0, $7a35efd9976b1f32$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7a35efd9976b1f32$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f622e64b75e035a8$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $f622e64b75e035a8$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $6c90d8a012cccc16$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $6c90d8a012cccc16$var$useDataRouterContext($6c90d8a012cccc16$var$DataRouterHook.UseFetcher);
    let state = $6c90d8a012cccc16$var$useDataRouterState($6c90d8a012cccc16$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $9kKA1.useContext($6c90d8a012cccc16$export$148fd98d095596d4);
    let route = $9kKA1.useContext((0, $7a35efd9976b1f32$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    !route && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $6c90d8a012cccc16$var$useIdImpl ? $6c90d8a012cccc16$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $9kKA1.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($6c90d8a012cccc16$var$getUniqueFetcherId());
    // Registration/cleanup
    $9kKA1.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $9kKA1.useCallback((href, opts)=>{
        !routeId && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $6c90d8a012cccc16$export$47c85c6e3a081d3();
    let submit = $9kKA1.useCallback((target, opts)=>{
        submitImpl(target, $6c90d8a012cccc16$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $9kKA1.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $9kKA1.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $9kKA1.createElement($6c90d8a012cccc16$export$a7fed597f4b8afd8, $6c90d8a012cccc16$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $f622e64b75e035a8$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $9kKA1.useMemo(()=>$6c90d8a012cccc16$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $6c90d8a012cccc16$export$fa996778a3a31087() {
    let state = $6c90d8a012cccc16$var$useDataRouterState($6c90d8a012cccc16$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $6c90d8a012cccc16$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $6c90d8a012cccc16$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $6c90d8a012cccc16$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $6c90d8a012cccc16$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $6c90d8a012cccc16$var$useDataRouterContext($6c90d8a012cccc16$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $6c90d8a012cccc16$var$useDataRouterState($6c90d8a012cccc16$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $9kKA1.useContext((0, $7a35efd9976b1f32$export$26749e8557646306));
    let location = (0, $7a35efd9976b1f32$export$45d76561a5302f2b)();
    let matches = (0, $7a35efd9976b1f32$export$2378eb7f5ff86053)();
    let navigation = (0, $7a35efd9976b1f32$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $9kKA1.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $6c90d8a012cccc16$var$usePageHide($9kKA1.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $6c90d8a012cccc16$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $6c90d8a012cccc16$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($6c90d8a012cccc16$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9kKA1.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $6c90d8a012cccc16$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $6c90d8a012cccc16$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9kKA1.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($6c90d8a012cccc16$var$_extends({}, location, {
                    pathname: (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($6c90d8a012cccc16$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9kKA1.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $6c90d8a012cccc16$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $9kKA1.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $6c90d8a012cccc16$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $9kKA1.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $6c90d8a012cccc16$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7a35efd9976b1f32$export$b273b3273281a049)(when);
    $9kKA1.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $9kKA1.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $6c90d8a012cccc16$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $9kKA1.useContext($6c90d8a012cccc16$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $f622e64b75e035a8$export$3e9cee6b33872309)(false);
    let { basename: basename } = $6c90d8a012cccc16$var$useDataRouterContext($6c90d8a012cccc16$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7a35efd9976b1f32$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $f622e64b75e035a8$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $f622e64b75e035a8$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $f622e64b75e035a8$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}






var $9kKA1 = parcelRequire("9kKA1");
function $70738842294dd06b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $639d0fc934b99f1e$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $70738842294dd06b$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $fbaa68106cb8822c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fbaa68106cb8822c$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $fbaa68106cb8822c$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $b229356d77b60def$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $347ca26438ba19a6$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $b229356d77b60def$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


var $a22cae3fcc50759c$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($a22cae3fcc50759c$exports) {
        classNames.default = classNames;
        $a22cae3fcc50759c$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $9kKA1 = parcelRequire("9kKA1");
function $83ed4fffd84b1c49$export$2e2bcd8739ae039() {
    return $83ed4fffd84b1c49$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $83ed4fffd84b1c49$export$2e2bcd8739ae039.apply(null, arguments);
}


function $6367fa4806eec091$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $9kKA1 = parcelRequire("9kKA1");
var $0e11f5c033351b22$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e11f5c033351b22$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$0e11f5c033351b22$exports = $0e11f5c033351b22$var$invariant;


var $9609d92aac610f57$var$noop = function noop() {};
function $9609d92aac610f57$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $9609d92aac610f57$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $9609d92aac610f57$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$9609d92aac610f57$export$26cbf8c37e721e67(prop)] = $9609d92aac610f57$var$noop;
        var handler;
    });
    return propTypes;
}
function $9609d92aac610f57$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $9609d92aac610f57$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $9609d92aac610f57$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $a88d4624e47843eb$var$_toPropertyKey(arg) {
    var key = $a88d4624e47843eb$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a88d4624e47843eb$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a88d4624e47843eb$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $9kKA1.useRef)(propValue !== undefined);
    var _useState = (0, $9kKA1.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $9kKA1.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $a88d4624e47843eb$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$9609d92aac610f57$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $6367fa4806eec091$export$2e2bcd8739ae039)(_ref, [
            $9609d92aac610f57$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($a88d4624e47843eb$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $a88d4624e47843eb$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $83ed4fffd84b1c49$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $8808ceb2373202d1$export$2e2bcd8739ae039(t, e) {
    return $8808ceb2373202d1$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $8808ceb2373202d1$export$2e2bcd8739ae039(t, e);
}


function $b9068a85acbb8572$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $8808ceb2373202d1$export$2e2bcd8739ae039)(t, o);
}



var $9kKA1 = parcelRequire("9kKA1");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $395cd9dcdac5c8ba$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $395cd9dcdac5c8ba$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $395cd9dcdac5c8ba$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$395cd9dcdac5c8ba$var$componentWillMount.__suppressDeprecationWarning = true;
$395cd9dcdac5c8ba$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$395cd9dcdac5c8ba$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $395cd9dcdac5c8ba$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $395cd9dcdac5c8ba$var$componentWillMount;
        prototype.componentWillReceiveProps = $395cd9dcdac5c8ba$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $395cd9dcdac5c8ba$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $d55293dd91303321$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $d55293dd91303321$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $9609d92aac610f57$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($9609d92aac610f57$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($0e11f5c033351b22$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $b9068a85acbb8572$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $83ed4fffd84b1c49$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$9609d92aac610f57$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $83ed4fffd84b1c49$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$9609d92aac610f57$export$12ae2baa35bd9b8b(props, key) && $9609d92aac610f57$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$9609d92aac610f57$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $6367fa4806eec091$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).createElement(Component, (0, $83ed4fffd84b1c49$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).Component);
    (0, $395cd9dcdac5c8ba$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $83ed4fffd84b1c49$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $9609d92aac610f57$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).createElement(UncontrolledComponent, (0, $83ed4fffd84b1c49$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $d55293dd91303321$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $d55293dd91303321$export$2e2bcd8739ae039(newComponent, (0, $83ed4fffd84b1c49$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $9kKA1 = parcelRequire("9kKA1");

var $9kKA1 = parcelRequire("9kKA1");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $4d5c0efbbee3a230$var$useCommittedRef(value) {
    const ref = (0, $9kKA1.useRef)(value);
    (0, $9kKA1.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $4d5c0efbbee3a230$export$2e2bcd8739ae039 = $4d5c0efbbee3a230$var$useCommittedRef;


function $e881a5f2f7c6fa3f$export$2e2bcd8739ae039(fn) {
    const ref = (0, $4d5c0efbbee3a230$export$2e2bcd8739ae039)(fn);
    return (0, $9kKA1.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


function $7e8fc8233cbbb35e$export$71511d61b312f219() {
    $7e8fc8233cbbb35e$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7e8fc8233cbbb35e$export$71511d61b312f219.apply(this, arguments);
}


function $92a605abbaa3c3e0$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}





var $9kKA1 = parcelRequire("9kKA1");

"use client";
const $1ae26d1586ced64e$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $1ae26d1586ced64e$export$ff817e17bad2e091 = 'xs';
const $1ae26d1586ced64e$var$ThemeContext = /*#__PURE__*/ $9kKA1.createContext({
    prefixes: {},
    breakpoints: $1ae26d1586ced64e$export$666ad80b5007f835,
    minBreakpoint: $1ae26d1586ced64e$export$ff817e17bad2e091
});
const { Consumer: $1ae26d1586ced64e$export$b631efc24e9d5e2f, Provider: $1ae26d1586ced64e$var$Provider } = $1ae26d1586ced64e$var$ThemeContext;
function $1ae26d1586ced64e$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $1ae26d1586ced64e$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $1ae26d1586ced64e$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $9kKA1.useMemo)(()=>({
            prefixes: (0, $639d0fc934b99f1e$export$71511d61b312f219)({}, prefixes),
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)($1ae26d1586ced64e$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $1ae26d1586ced64e$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $9kKA1.useContext)($1ae26d1586ced64e$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $1ae26d1586ced64e$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $9kKA1.useContext)($1ae26d1586ced64e$var$ThemeContext);
    return breakpoints;
}
function $1ae26d1586ced64e$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $9kKA1.useContext)($1ae26d1586ced64e$var$ThemeContext);
    return minBreakpoint;
}
function $1ae26d1586ced64e$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $9kKA1.useContext)($1ae26d1586ced64e$var$ThemeContext);
    return dir === 'rtl';
}
function $1ae26d1586ced64e$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
        var props = (0, $7e8fc8233cbbb35e$export$71511d61b312f219)({}, (0, $92a605abbaa3c3e0$export$71511d61b312f219)(_param));
        props[forwardRefAs] = ref;
        const bsPrefix = $1ae26d1586ced64e$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $1ae26d1586ced64e$export$2e2bcd8739ae039 = $1ae26d1586ced64e$var$ThemeProvider;





var $9kKA1 = parcelRequire("9kKA1");





var $9kKA1 = parcelRequire("9kKA1");


var $99aaf3b630596b82$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $9kKA1.forwardRef((p, ref)=>/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, p), {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(p.className, className)
        })));



"use client";
const $d36544d7672d4597$var$DivStyledAsH4 = (0, $99aaf3b630596b82$export$2e2bcd8739ae039)('h4');
$d36544d7672d4597$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $d36544d7672d4597$var$AlertHeading = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $d36544d7672d4597$var$DivStyledAsH4 } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$d36544d7672d4597$var$AlertHeading.displayName = 'AlertHeading';
var $d36544d7672d4597$export$2e2bcd8739ae039 = $d36544d7672d4597$var$AlertHeading;





var $9kKA1 = parcelRequire("9kKA1");


var $9kKA1 = parcelRequire("9kKA1");

var $9kKA1 = parcelRequire("9kKA1");
function $4d6f4243a2e23210$export$2e2bcd8739ae039() {
    return (0, $9kKA1.useState)(null);
}



var $9kKA1 = parcelRequire("9kKA1");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $3a170752d845aa3c$var$useCommittedRef(value) {
    const ref = (0, $9kKA1.useRef)(value);
    (0, $9kKA1.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $3a170752d845aa3c$export$2e2bcd8739ae039 = $3a170752d845aa3c$var$useCommittedRef;



var $9kKA1 = parcelRequire("9kKA1");

function $9aaec398347e0c17$export$2e2bcd8739ae039(fn) {
    const ref = (0, $3a170752d845aa3c$export$2e2bcd8739ae039)(fn);
    return (0, $9kKA1.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $9kKA1 = parcelRequire("9kKA1");

function $727be6a01cbaa24a$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)(listener);
    (0, $9kKA1.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $9kKA1 = parcelRequire("9kKA1");
function $efef1dc3c34fbadb$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $9kKA1.useCallback)(()=>document, []);
    return (0, $727be6a01cbaa24a$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $9kKA1 = parcelRequire("9kKA1");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $6f8304a4f30e55e2$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $3a170752d845aa3c$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $3a170752d845aa3c$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $9kKA1.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $6f8304a4f30e55e2$export$2e2bcd8739ae039 = $6f8304a4f30e55e2$var$useInterval;



var $9kKA1 = parcelRequire("9kKA1");

function $81623edd2b08d1b3$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $3a170752d845aa3c$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $3a170752d845aa3c$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $9kKA1.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $81623edd2b08d1b3$export$2e2bcd8739ae039 = $81623edd2b08d1b3$var$useRafInterval;



var $9kKA1 = parcelRequire("9kKA1");
function $f979695132eed9ad$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $9kKA1.useState)(initialState);
    const updater = (0, $9kKA1.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $82f2adfa00518830$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $f979695132eed9ad$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $9kKA1 = parcelRequire("9kKA1");
function $59e2e539dfd21728$export$2e2bcd8739ae039() {
    const mounted = (0, $9kKA1.useRef)(true);
    const isMounted = (0, $9kKA1.useRef)(()=>mounted.current);
    (0, $9kKA1.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $9kKA1 = parcelRequire("9kKA1");
function $91d3da1183e3460e$export$2e2bcd8739ae039(value) {
    const ref = (0, $9kKA1.useRef)(null);
    (0, $9kKA1.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $9kKA1 = parcelRequire("9kKA1");
function $f7d63c27cb647e9b$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $9kKA1.useState)({
        image: null,
        error: null
    });
    (0, $9kKA1.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $9kKA1 = parcelRequire("9kKA1");

var $9kKA1 = parcelRequire("9kKA1");
const $ab176e261f0aa93b$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $ab176e261f0aa93b$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $ab176e261f0aa93b$export$2e2bcd8739ae039 = $ab176e261f0aa93b$var$isDOM || $ab176e261f0aa93b$var$isReactNative ? (0, $9kKA1.useLayoutEffect) : (0, $9kKA1.useEffect);


const $dcd01f7e4bbe960f$var$targetMap = new WeakMap();
let $dcd01f7e4bbe960f$var$resizeObserver;
function $dcd01f7e4bbe960f$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $dcd01f7e4bbe960f$var$resizeObserver = $dcd01f7e4bbe960f$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $dcd01f7e4bbe960f$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $dcd01f7e4bbe960f$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $9kKA1.useState)(null);
    (0, $ab176e261f0aa93b$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $dcd01f7e4bbe960f$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $dcd01f7e4bbe960f$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $dcd01f7e4bbe960f$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}





var $9kKA1 = parcelRequire("9kKA1");

const $1846bbec3b51e2a0$var$_excluded = [
    "as",
    "disabled"
];
function $1846bbec3b51e2a0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $1846bbec3b51e2a0$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $1846bbec3b51e2a0$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $1846bbec3b51e2a0$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $1846bbec3b51e2a0$var$Button = /*#__PURE__*/ $9kKA1.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $1846bbec3b51e2a0$var$_objectWithoutPropertiesLoose(_ref, $1846bbec3b51e2a0$var$_excluded);
    const [buttonProps, { tagName: Component }] = $1846bbec3b51e2a0$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$1846bbec3b51e2a0$var$Button.displayName = 'Button';
var $1846bbec3b51e2a0$export$2e2bcd8739ae039 = $1846bbec3b51e2a0$var$Button;



const $31b3e00d6bbcb13c$var$_excluded = [
    "onKeyDown"
];
function $31b3e00d6bbcb13c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $31b3e00d6bbcb13c$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $31b3e00d6bbcb13c$var$Anchor = /*#__PURE__*/ $9kKA1.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $31b3e00d6bbcb13c$var$_objectWithoutPropertiesLoose(_ref, $31b3e00d6bbcb13c$var$_excluded);
    const [buttonProps] = (0, $1846bbec3b51e2a0$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($31b3e00d6bbcb13c$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$31b3e00d6bbcb13c$var$Anchor.displayName = 'Anchor';
var $31b3e00d6bbcb13c$export$2e2bcd8739ae039 = $31b3e00d6bbcb13c$var$Anchor;




"use client";
const $ae043ab23c0536cc$var$AlertLink = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = (0, $31b3e00d6bbcb13c$export$2e2bcd8739ae039) } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$ae043ab23c0536cc$var$AlertLink.displayName = 'AlertLink';
var $ae043ab23c0536cc$export$2e2bcd8739ae039 = $ae043ab23c0536cc$var$AlertLink;







var $9kKA1 = parcelRequire("9kKA1");




var $9kKA1 = parcelRequire("9kKA1");

var $2d54aebc8547b967$export$2e2bcd8739ae039 = {
    disabled: false
};




var $9kKA1 = parcelRequire("9kKA1");
var $ca4b72cd57ffe35d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).createContext(null);


var $3b908b11a58ea229$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $4e14d0c61bb5db7f$export$bb38bb9a1161268 = 'unmounted';
var $4e14d0c61bb5db7f$export$84cbff306f539230 = 'exited';
var $4e14d0c61bb5db7f$export$df38205c966be359 = 'entering';
var $4e14d0c61bb5db7f$export$78e9e6e3e014d60a = 'entered';
var $4e14d0c61bb5db7f$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $4e14d0c61bb5db7f$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $b9068a85acbb8572$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $4e14d0c61bb5db7f$export$84cbff306f539230;
                _this.appearStatus = $4e14d0c61bb5db7f$export$df38205c966be359;
            } else initialStatus = $4e14d0c61bb5db7f$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $4e14d0c61bb5db7f$export$bb38bb9a1161268;
        else initialStatus = $4e14d0c61bb5db7f$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $4e14d0c61bb5db7f$export$bb38bb9a1161268) return {
            status: $4e14d0c61bb5db7f$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $4e14d0c61bb5db7f$export$df38205c966be359 && status !== $4e14d0c61bb5db7f$export$78e9e6e3e014d60a) nextStatus = $4e14d0c61bb5db7f$export$df38205c966be359;
            } else if (status === $4e14d0c61bb5db7f$export$df38205c966be359 || status === $4e14d0c61bb5db7f$export$78e9e6e3e014d60a) nextStatus = $4e14d0c61bb5db7f$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $4e14d0c61bb5db7f$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($aba877308eacd357$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $3b908b11a58ea229$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $4e14d0c61bb5db7f$export$84cbff306f539230) this.setState({
            status: $4e14d0c61bb5db7f$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($aba877308eacd357$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2d54aebc8547b967$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $4e14d0c61bb5db7f$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $4e14d0c61bb5db7f$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $4e14d0c61bb5db7f$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($aba877308eacd357$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2d54aebc8547b967$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $4e14d0c61bb5db7f$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $4e14d0c61bb5db7f$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $4e14d0c61bb5db7f$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($aba877308eacd357$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $4e14d0c61bb5db7f$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $6367fa4806eec091$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).createElement((0, $ca4b72cd57ffe35d$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).Component);
$4e14d0c61bb5db7f$var$Transition.contextType = (0, $ca4b72cd57ffe35d$export$2e2bcd8739ae039);
$4e14d0c61bb5db7f$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $4e14d0c61bb5db7f$var$noop() {}
$4e14d0c61bb5db7f$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $4e14d0c61bb5db7f$var$noop,
    onEntering: $4e14d0c61bb5db7f$var$noop,
    onEntered: $4e14d0c61bb5db7f$var$noop,
    onExit: $4e14d0c61bb5db7f$var$noop,
    onExiting: $4e14d0c61bb5db7f$var$noop,
    onExited: $4e14d0c61bb5db7f$var$noop
};
$4e14d0c61bb5db7f$var$Transition.UNMOUNTED = $4e14d0c61bb5db7f$export$bb38bb9a1161268;
$4e14d0c61bb5db7f$var$Transition.EXITED = $4e14d0c61bb5db7f$export$84cbff306f539230;
$4e14d0c61bb5db7f$var$Transition.ENTERING = $4e14d0c61bb5db7f$export$df38205c966be359;
$4e14d0c61bb5db7f$var$Transition.ENTERED = $4e14d0c61bb5db7f$export$78e9e6e3e014d60a;
$4e14d0c61bb5db7f$var$Transition.EXITING = $4e14d0c61bb5db7f$export$4aacc83d4d59139f;
var $4e14d0c61bb5db7f$export$2e2bcd8739ae039 = $4e14d0c61bb5db7f$var$Transition;



var $9kKA1 = parcelRequire("9kKA1");
function $4029778e671a2d75$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $4029778e671a2d75$export$13e065f3a74cfe36() {
    const parts = $9kKA1.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $4029778e671a2d75$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $4029778e671a2d75$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $f850eb4c28a0928f$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $e4cb7df6d18d350e$export$2e2bcd8739ae039(node) {
    var doc = (0, $f850eb4c28a0928f$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bcc55d4136de8cb6$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $e4cb7df6d18d350e$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $363899c5ecb851f3$var$rUpper = /([A-Z])/g;
function $363899c5ecb851f3$export$2e2bcd8739ae039(string) {
    return string.replace($363899c5ecb851f3$var$rUpper, '-$1').toLowerCase();
}


var $4ee93354b009b45c$var$msPattern = /^ms-/;
function $4ee93354b009b45c$export$2e2bcd8739ae039(string) {
    return (0, $363899c5ecb851f3$export$2e2bcd8739ae039)(string).replace($4ee93354b009b45c$var$msPattern, '-ms-');
}


var $47eef7d5a8167ec0$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $47eef7d5a8167ec0$export$2e2bcd8739ae039(value) {
    return !!(value && $47eef7d5a8167ec0$var$supportedTransforms.test(value));
}


function $da765e750ec11a91$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $4ee93354b009b45c$export$2e2bcd8739ae039)(property)) || (0, $bcc55d4136de8cb6$export$2e2bcd8739ae039)(node).getPropertyValue((0, $4ee93354b009b45c$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $4ee93354b009b45c$export$2e2bcd8739ae039)(key));
        else if ((0, $47eef7d5a8167ec0$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $4ee93354b009b45c$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $da765e750ec11a91$export$2e2bcd8739ae039 = $da765e750ec11a91$var$style;



/* eslint-disable no-return-assign */ var $495569d57101fa38$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $2e4800e85a6903ee$export$63fefd044b2bc624 = false;
var $2e4800e85a6903ee$export$a614c6b395900f69 = false;
try {
    var $2e4800e85a6903ee$var$options = {
        get passive () {
            return $2e4800e85a6903ee$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $2e4800e85a6903ee$export$a614c6b395900f69 = $2e4800e85a6903ee$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $495569d57101fa38$export$2e2bcd8739ae039) {
        window.addEventListener('test', $2e4800e85a6903ee$var$options, $2e4800e85a6903ee$var$options);
        window.removeEventListener('test', $2e4800e85a6903ee$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $2e4800e85a6903ee$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$2e4800e85a6903ee$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$2e4800e85a6903ee$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $2e4800e85a6903ee$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $2e4800e85a6903ee$export$2e2bcd8739ae039 = $2e4800e85a6903ee$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $a3b1f73e47160835$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $a3b1f73e47160835$export$2e2bcd8739ae039 = $a3b1f73e47160835$var$removeEventListener;


function $685d53a9cad0fb2a$var$listen(node, eventName, handler, options) {
    (0, $2e4800e85a6903ee$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $a3b1f73e47160835$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $685d53a9cad0fb2a$export$2e2bcd8739ae039 = $685d53a9cad0fb2a$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $7300368d44a59cfa$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $7e8c948d84e29f1f$var$parseDuration(node) {
    var str = (0, $da765e750ec11a91$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $7e8c948d84e29f1f$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $7300368d44a59cfa$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $685d53a9cad0fb2a$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $7e8c948d84e29f1f$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $7e8c948d84e29f1f$var$parseDuration(element) || 0;
    var removeEmulate = $7e8c948d84e29f1f$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $685d53a9cad0fb2a$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $c9e142ba72a01ec0$var$parseDuration(node, property) {
    const str = (0, $da765e750ec11a91$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $c9e142ba72a01ec0$export$2e2bcd8739ae039(element, handler) {
    const duration = $c9e142ba72a01ec0$var$parseDuration(element, 'transitionDuration');
    const delay = $c9e142ba72a01ec0$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $7e8c948d84e29f1f$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $5cafe25a36a1c581$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}






var $9kKA1 = parcelRequire("9kKA1");


var $9kKA1 = parcelRequire("9kKA1");
const $6c252888eab545c0$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $6c252888eab545c0$export$c9058316764c140e(refA, refB) {
    const a = $6c252888eab545c0$var$toFnRef(refA);
    const b = $6c252888eab545c0$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $6c252888eab545c0$var$useMergedRefs(refA, refB) {
    return (0, $9kKA1.useMemo)(()=>$6c252888eab545c0$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $6c252888eab545c0$export$2e2bcd8739ae039 = $6c252888eab545c0$var$useMergedRefs;



function $22dccc13c733eb14$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($aba877308eacd357$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $2bef307424b2bb39$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).forwardRef((_param, ref)=>{
    var { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited",
        "addEndListener",
        "children",
        "childRef"
    ]);
    const nodeRef = (0, $9kKA1.useRef)(null);
    const mergedRef = (0, $6c252888eab545c0$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $22dccc13c733eb14$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $9kKA1.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $9kKA1.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $9kKA1.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $9kKA1.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $9kKA1.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $9kKA1.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $9kKA1.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $4e14d0c61bb5db7f$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, innerProps), {
                ref: attachRef
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).cloneElement(children, {
            ref: attachRef
        })
    }));
});
$2bef307424b2bb39$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $2bef307424b2bb39$export$2e2bcd8739ae039 = $2bef307424b2bb39$var$TransitionWrapper;



const $1c98f6632da025f8$var$fadeStyles = {
    [(0, $4e14d0c61bb5db7f$export$df38205c966be359)]: 'show',
    [(0, $4e14d0c61bb5db7f$export$78e9e6e3e014d60a)]: 'show'
};
const $1c98f6632da025f8$var$Fade = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter } = _param, rest = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "children",
        "transitionClasses",
        "onEnter"
    ]);
    const props = (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false
    }, rest);
    const handleEnter = (0, $9kKA1.useCallback)((node, isAppearing)=>{
        (0, $5cafe25a36a1c581$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $2bef307424b2bb39$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        addEndListener: (0, $c9e142ba72a01ec0$export$2e2bcd8739ae039)
    }, props), {
        onEnter: handleEnter,
        childRef: (0, $4029778e671a2d75$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $9kKA1.cloneElement(children, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))('fade', className, children.props.className, $1c98f6632da025f8$var$fadeStyles[status], transitionClasses[status])
            }))
    }));
});
$1c98f6632da025f8$var$Fade.displayName = 'Fade';
var $1c98f6632da025f8$export$2e2bcd8739ae039 = $1c98f6632da025f8$var$Fade;




var $c67a02999523a9a4$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c67a02999523a9a4$var$ReactIs, $c67a02999523a9a4$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c67a02999523a9a4$exports = (parcelRequire("fE8jk"))();



var $9kKA1 = parcelRequire("9kKA1");


const $aa4497a16673cb1f$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).oneOf([
        'white'
    ])
};
const $aa4497a16673cb1f$var$CloseButton = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, variant: variant, 'aria-label': ariaLabel = 'Close' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "variant",
        'aria-label'
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("button", (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel
    }, props));
});
$aa4497a16673cb1f$var$CloseButton.displayName = 'CloseButton';
$aa4497a16673cb1f$var$CloseButton.propTypes = $aa4497a16673cb1f$var$propTypes;
var $aa4497a16673cb1f$export$2e2bcd8739ae039 = $aa4497a16673cb1f$var$CloseButton;



"use client";
const $98cf17248b47739d$var$Alert = /*#__PURE__*/ $9kKA1.forwardRef((uncontrolledProps, ref)=>{
    const _useUncontrolled = (0, $a88d4624e47843eb$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    }), { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $1c98f6632da025f8$export$2e2bcd8739ae039) } = _useUncontrolled, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_useUncontrolled, [
        "bsPrefix",
        "show",
        "closeLabel",
        "closeVariant",
        "className",
        "children",
        "variant",
        "onClose",
        "dismissible",
        "transition"
    ]);
    const prefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $e881a5f2f7c6fa3f$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $1c98f6632da025f8$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        role: "alert"
    }, !Transition ? props : undefined), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $aa4497a16673cb1f$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    }));
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Transition, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        unmountOnExit: true
    }, props), {
        ref: undefined,
        in: show,
        children: alert
    }));
});
$98cf17248b47739d$var$Alert.displayName = 'Alert';
var $98cf17248b47739d$export$2e2bcd8739ae039 = Object.assign($98cf17248b47739d$var$Alert, {
    Link: (0, $ae043ab23c0536cc$export$2e2bcd8739ae039),
    Heading: (0, $d36544d7672d4597$export$2e2bcd8739ae039)
});






var $9kKA1 = parcelRequire("9kKA1");


"use client";
function $8289c3e1dfc9e5a0$export$2ed43d61a0a9f5a3(_param) {
    var { as: as, bsPrefix: bsPrefix, className: className } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "as",
        "bsPrefix",
        "className"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $1ae26d1586ced64e$export$8970c8db816a5863)();
    const minBreakpoint = (0, $1ae26d1586ced64e$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, ...spans, ...classes)
        }),
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $8289c3e1dfc9e5a0$var$Col = /*#__PURE__*/ $9kKA1.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const _useCol = $8289c3e1dfc9e5a0$export$2ed43d61a0a9f5a3(props), [{ className: className }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = _useCol, colProps = (0, $347ca26438ba19a6$export$71511d61b312f219)(_useCol[0], [
        "className"
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, colProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, !spans.length && bsPrefix)
    }));
});
$8289c3e1dfc9e5a0$var$Col.displayName = 'Col';
var $8289c3e1dfc9e5a0$export$2e2bcd8739ae039 = $8289c3e1dfc9e5a0$var$Col;






var $9kKA1 = parcelRequire("9kKA1");


"use client";
const $f60af856adff6234$var$Container = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', className: className } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "fluid",
        "as",
        "className"
    ]);
    const prefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    }));
});
$f60af856adff6234$var$Container.displayName = 'Container';
var $f60af856adff6234$export$2e2bcd8739ae039 = $f60af856adff6234$var$Container;







var $9kKA1 = parcelRequire("9kKA1");





var $9kKA1 = parcelRequire("9kKA1");





var $9kKA1 = parcelRequire("9kKA1");


const $344042fea2345013$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).elementType
};
const $344042fea2345013$var$Feedback = /*#__PURE__*/ $9kKA1.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_param, ref)=>{
    var { as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "as",
        "className",
        "type",
        "tooltip"
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
});
$344042fea2345013$var$Feedback.displayName = 'Feedback';
$344042fea2345013$var$Feedback.propTypes = $344042fea2345013$var$propTypes;
var $344042fea2345013$export$2e2bcd8739ae039 = $344042fea2345013$var$Feedback;







var $9kKA1 = parcelRequire("9kKA1");

var $9kKA1 = parcelRequire("9kKA1");
"use client";
// TODO
const $18aba7a24f63876c$var$FormContext = /*#__PURE__*/ $9kKA1.createContext({});
var $18aba7a24f63876c$export$2e2bcd8739ae039 = $18aba7a24f63876c$var$FormContext;




"use client";
const $26365b926dc9158f$var$FormCheckInput = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'input' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "id",
        "bsPrefix",
        "className",
        "type",
        "isValid",
        "isInvalid",
        "as"
    ]);
    const { controlId: controlId } = (0, $9kKA1.useContext)((0, $18aba7a24f63876c$export$2e2bcd8739ae039));
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    }));
});
$26365b926dc9158f$var$FormCheckInput.displayName = 'FormCheckInput';
var $26365b926dc9158f$export$2e2bcd8739ae039 = $26365b926dc9158f$var$FormCheckInput;







var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $9dceed6fb0d0210c$var$FormCheckLabel = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, htmlFor: htmlFor } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "htmlFor"
    ]);
    const { controlId: controlId } = (0, $9kKA1.useContext)((0, $18aba7a24f63876c$export$2e2bcd8739ae039));
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("label", (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }));
});
$9dceed6fb0d0210c$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $9dceed6fb0d0210c$export$2e2bcd8739ae039 = $9dceed6fb0d0210c$var$FormCheckLabel;





var $9kKA1 = parcelRequire("9kKA1");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $bc9894d3f0acdbdc$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $9kKA1.Children.map(children, (child)=>/*#__PURE__*/ $9kKA1.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $bc9894d3f0acdbdc$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $9kKA1.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $9kKA1.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $bc9894d3f0acdbdc$export$500fd6099226ffae(children, type) {
    return $9kKA1.Children.toArray(children).some((child)=>/*#__PURE__*/ $9kKA1.isValidElement(child) && child.type === type);
}



"use client";
const $dda4b2d173c0f5d1$var$FormCheck = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'input' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "id",
        "bsPrefix",
        "bsSwitchPrefix",
        "inline",
        "reverse",
        "disabled",
        "isValid",
        "isInvalid",
        "feedbackTooltip",
        "feedback",
        "feedbackType",
        "className",
        "style",
        "title",
        "type",
        "label",
        "children",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $9kKA1.useContext)((0, $18aba7a24f63876c$export$2e2bcd8739ae039));
    const innerFormContext = (0, $9kKA1.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $bc9894d3f0acdbdc$export$500fd6099226ffae)(children, (0, $9dceed6fb0d0210c$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $26365b926dc9158f$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    }));
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $18aba7a24f63876c$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $9dceed6fb0d0210c$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $344042fea2345013$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$dda4b2d173c0f5d1$var$FormCheck.displayName = 'FormCheck';
var $dda4b2d173c0f5d1$export$2e2bcd8739ae039 = Object.assign($dda4b2d173c0f5d1$var$FormCheck, {
    Input: (0, $26365b926dc9158f$export$2e2bcd8739ae039),
    Label: (0, $9dceed6fb0d0210c$export$2e2bcd8739ae039)
});







var $9kKA1 = parcelRequire("9kKA1");
var $1490a610cd16bf26$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $1490a610cd16bf26$var$__DEV__ = false;
var $1490a610cd16bf26$var$warning = function() {};
if ($1490a610cd16bf26$var$__DEV__) {
    var $1490a610cd16bf26$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $1490a610cd16bf26$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $1490a610cd16bf26$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$1490a610cd16bf26$exports = $1490a610cd16bf26$var$warning;






"use client";
const $8c5900a05f58e705$var$FormControl = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'input' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "type",
        "size",
        "htmlSize",
        "id",
        "className",
        "isValid",
        "isInvalid",
        "plaintext",
        "readOnly",
        "as"
    ]);
    const { controlId: controlId } = (0, $9kKA1.useContext)((0, $18aba7a24f63876c$export$2e2bcd8739ae039));
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    }));
});
$8c5900a05f58e705$var$FormControl.displayName = 'FormControl';
var $8c5900a05f58e705$export$2e2bcd8739ae039 = Object.assign($8c5900a05f58e705$var$FormControl, {
    Feedback: $344042fea2345013$export$2e2bcd8739ae039
});





var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $477121f8651bdad5$var$FormFloating = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$477121f8651bdad5$var$FormFloating.displayName = 'FormFloating';
var $477121f8651bdad5$export$2e2bcd8739ae039 = $477121f8651bdad5$var$FormFloating;






var $9kKA1 = parcelRequire("9kKA1");


const $af52aeb4020ed239$var$FormGroup = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "controlId",
        "as"
    ]);
    const context = (0, $9kKA1.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $18aba7a24f63876c$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
            ref: ref
        }))
    });
});
$af52aeb4020ed239$var$FormGroup.displayName = 'FormGroup';
var $af52aeb4020ed239$export$2e2bcd8739ae039 = $af52aeb4020ed239$var$FormGroup;






var $9kKA1 = parcelRequire("9kKA1");





"use client";
const $61a33f88edd13c34$var$FormLabel = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "as",
        "bsPrefix",
        "column",
        "visuallyHidden",
        "className",
        "htmlFor"
    ]);
    const { controlId: controlId } = (0, $9kKA1.useContext)((0, $18aba7a24f63876c$export$2e2bcd8739ae039));
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $8289c3e1dfc9e5a0$export$2e2bcd8739ae039), (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor
    }, props));
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: classes,
        htmlFor: htmlFor
    }, props));
});
$61a33f88edd13c34$var$FormLabel.displayName = 'FormLabel';
var $61a33f88edd13c34$export$2e2bcd8739ae039 = $61a33f88edd13c34$var$FormLabel;







var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $7faf34ea23fcc520$var$FormRange = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, id: id } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "id"
    ]);
    const { controlId: controlId } = (0, $9kKA1.useContext)((0, $18aba7a24f63876c$export$2e2bcd8739ae039));
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("input", (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix),
        id: id || controlId
    }));
});
$7faf34ea23fcc520$var$FormRange.displayName = 'FormRange';
var $7faf34ea23fcc520$export$2e2bcd8739ae039 = $7faf34ea23fcc520$var$FormRange;







var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $99975ab641d74a8c$var$FormSelect = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "size",
        "htmlSize",
        "className",
        "isValid",
        "isInvalid",
        "id"
    ]);
    const { controlId: controlId } = (0, $9kKA1.useContext)((0, $18aba7a24f63876c$export$2e2bcd8739ae039));
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("select", (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    }));
});
$99975ab641d74a8c$var$FormSelect.displayName = 'FormSelect';
var $99975ab641d74a8c$export$2e2bcd8739ae039 = $99975ab641d74a8c$var$FormSelect;







var $9kKA1 = parcelRequire("9kKA1");


"use client";
const $6b7d41100a766cb7$var$FormText = /*#__PURE__*/ $9kKA1.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as",
        "muted"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix, muted && 'text-muted')
    }));
});
$6b7d41100a766cb7$var$FormText.displayName = 'FormText';
var $6b7d41100a766cb7$export$2e2bcd8739ae039 = $6b7d41100a766cb7$var$FormText;





var $9kKA1 = parcelRequire("9kKA1");


const $5fca99230cda454b$var$Switch = /*#__PURE__*/ $9kKA1.forwardRef((props, ref)=>/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $dda4b2d173c0f5d1$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        ref: ref,
        type: "switch"
    })));
$5fca99230cda454b$var$Switch.displayName = 'Switch';
var $5fca99230cda454b$export$2e2bcd8739ae039 = Object.assign($5fca99230cda454b$var$Switch, {
    Input: (0, $dda4b2d173c0f5d1$export$2e2bcd8739ae039).Input,
    Label: (0, $dda4b2d173c0f5d1$export$2e2bcd8739ae039).Label
});







var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $eeb31f855b5348eb$var$FloatingLabel = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "children",
        "controlId",
        "label"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $af52aeb4020ed239$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix),
        controlId: controlId
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    }));
});
$eeb31f855b5348eb$var$FloatingLabel.displayName = 'FloatingLabel';
var $eeb31f855b5348eb$export$2e2bcd8739ae039 = $eeb31f855b5348eb$var$FloatingLabel;



const $a4223ba6d68fcdb0$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).elementType
};
const $a4223ba6d68fcdb0$var$Form = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'form' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "validated",
        "as"
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, validated && 'was-validated')
    }));
});
$a4223ba6d68fcdb0$var$Form.displayName = 'Form';
$a4223ba6d68fcdb0$var$Form.propTypes = $a4223ba6d68fcdb0$var$propTypes;
var $a4223ba6d68fcdb0$export$2e2bcd8739ae039 = Object.assign($a4223ba6d68fcdb0$var$Form, {
    Group: (0, $af52aeb4020ed239$export$2e2bcd8739ae039),
    Control: (0, $8c5900a05f58e705$export$2e2bcd8739ae039),
    Floating: (0, $477121f8651bdad5$export$2e2bcd8739ae039),
    Check: (0, $dda4b2d173c0f5d1$export$2e2bcd8739ae039),
    Switch: $5fca99230cda454b$export$2e2bcd8739ae039,
    Label: (0, $61a33f88edd13c34$export$2e2bcd8739ae039),
    Text: (0, $6b7d41100a766cb7$export$2e2bcd8739ae039),
    Range: (0, $7faf34ea23fcc520$export$2e2bcd8739ae039),
    Select: (0, $99975ab641d74a8c$export$2e2bcd8739ae039),
    FloatingLabel: $eeb31f855b5348eb$export$2e2bcd8739ae039
});






var $9kKA1 = parcelRequire("9kKA1");



var $9kKA1 = parcelRequire("9kKA1");
"use client";
const $c18aca666331eeff$var$context = /*#__PURE__*/ $9kKA1.createContext(null);
$c18aca666331eeff$var$context.displayName = 'InputGroupContext';
var $c18aca666331eeff$export$2e2bcd8739ae039 = $c18aca666331eeff$var$context;





var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $4ce67e4b2fa2cd88$var$InputGroupText = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'span' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$4ce67e4b2fa2cd88$var$InputGroupText.displayName = 'InputGroupText';
var $4ce67e4b2fa2cd88$export$2e2bcd8739ae039 = $4ce67e4b2fa2cd88$var$InputGroupText;



"use client";
const $2e2d747203b83887$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $4ce67e4b2fa2cd88$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $26365b926dc9158f$export$2e2bcd8739ae039), (0, $639d0fc934b99f1e$export$71511d61b312f219)({
            type: "checkbox"
        }, props))
    });
const $2e2d747203b83887$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $4ce67e4b2fa2cd88$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $26365b926dc9158f$export$2e2bcd8739ae039), (0, $639d0fc934b99f1e$export$71511d61b312f219)({
            type: "radio"
        }, props))
    });
const $2e2d747203b83887$var$InputGroup = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "size",
        "hasValidation",
        "className",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $9kKA1.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $c18aca666331eeff$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        }))
    });
});
$2e2d747203b83887$var$InputGroup.displayName = 'InputGroup';
var $2e2d747203b83887$export$2e2bcd8739ae039 = Object.assign($2e2d747203b83887$var$InputGroup, {
    Text: (0, $4ce67e4b2fa2cd88$export$2e2bcd8739ae039),
    Radio: $2e2d747203b83887$var$InputGroupRadio,
    Checkbox: $2e2d747203b83887$var$InputGroupCheckbox
});






var $9kKA1 = parcelRequire("9kKA1");


"use client";
const $110f9e0274134f6c$var$Row = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    const decoratedBsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $1ae26d1586ced64e$export$8970c8db816a5863)();
    const minBreakpoint = (0, $1ae26d1586ced64e$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, decoratedBsPrefix, ...classes)
    }));
});
$110f9e0274134f6c$var$Row.displayName = 'Row';
var $110f9e0274134f6c$export$2e2bcd8739ae039 = $110f9e0274134f6c$var$Row;






var $9kKA1 = parcelRequire("9kKA1");


"use client";
const $f3b962eca0217e80$var$Spinner = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', className: className } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "variant",
        "animation",
        "size",
        "as",
        "className"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    }));
});
$f3b962eca0217e80$var$Spinner.displayName = 'Spinner';
var $f3b962eca0217e80$export$2e2bcd8739ae039 = $f3b962eca0217e80$var$Spinner;




var $9kKA1 = parcelRequire("9kKA1");





var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $d7919c8bc3912607$var$Button = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "as",
        "bsPrefix",
        "variant",
        "size",
        "active",
        "disabled",
        "className"
    ]);
    const prefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $1846bbec3b51e2a0$export$a0ee72f2c720a5c3)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        tagName: as,
        disabled: disabled
    }, props));
    const Component = tagName;
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, buttonProps, props), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    }));
});
$d7919c8bc3912607$var$Button.displayName = 'Button';
var $d7919c8bc3912607$export$2e2bcd8739ae039 = $d7919c8bc3912607$var$Button;






var $9kKA1 = parcelRequire("9kKA1");




var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $cac08039ce79d8fa$var$CardBody = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$cac08039ce79d8fa$var$CardBody.displayName = 'CardBody';
var $cac08039ce79d8fa$export$2e2bcd8739ae039 = $cac08039ce79d8fa$var$CardBody;





var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $00e933e8823186d0$var$CardFooter = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$00e933e8823186d0$var$CardFooter.displayName = 'CardFooter';
var $00e933e8823186d0$export$2e2bcd8739ae039 = $00e933e8823186d0$var$CardFooter;







var $9kKA1 = parcelRequire("9kKA1");


var $9kKA1 = parcelRequire("9kKA1");
"use client";
const $625a1bfdff3c0029$var$context = /*#__PURE__*/ $9kKA1.createContext(null);
$625a1bfdff3c0029$var$context.displayName = 'CardHeaderContext';
var $625a1bfdff3c0029$export$2e2bcd8739ae039 = $625a1bfdff3c0029$var$context;



"use client";
const $f7b6aa556a2b5916$var$CardHeader = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    const prefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $9kKA1.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $625a1bfdff3c0029$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, prefix)
        }))
    });
});
$f7b6aa556a2b5916$var$CardHeader.displayName = 'CardHeader';
var $f7b6aa556a2b5916$export$2e2bcd8739ae039 = $f7b6aa556a2b5916$var$CardHeader;






var $9kKA1 = parcelRequire("9kKA1");


"use client";
const $942173aa0f606dd4$var$CardImg = /*#__PURE__*/ $9kKA1.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "variant",
        "as"
    ]);
    const prefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(variant ? `${prefix}-${variant}` : prefix, className)
    }, props));
});
$942173aa0f606dd4$var$CardImg.displayName = 'CardImg';
var $942173aa0f606dd4$export$2e2bcd8739ae039 = $942173aa0f606dd4$var$CardImg;





var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $f7b16dfca950c364$var$CardImgOverlay = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$f7b16dfca950c364$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $f7b16dfca950c364$export$2e2bcd8739ae039 = $f7b16dfca950c364$var$CardImgOverlay;





var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $5c4c1c5a6b5b17be$var$CardLink = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'a' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$5c4c1c5a6b5b17be$var$CardLink.displayName = 'CardLink';
var $5c4c1c5a6b5b17be$export$2e2bcd8739ae039 = $5c4c1c5a6b5b17be$var$CardLink;





var $9kKA1 = parcelRequire("9kKA1");




"use client";
const $e6dcc4631701ff38$var$DivStyledAsH6 = (0, $99aaf3b630596b82$export$2e2bcd8739ae039)('h6');
const $e6dcc4631701ff38$var$CardSubtitle = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $e6dcc4631701ff38$var$DivStyledAsH6 } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$e6dcc4631701ff38$var$CardSubtitle.displayName = 'CardSubtitle';
var $e6dcc4631701ff38$export$2e2bcd8739ae039 = $e6dcc4631701ff38$var$CardSubtitle;





var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $fa412a54624ee900$var$CardText = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'p' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$fa412a54624ee900$var$CardText.displayName = 'CardText';
var $fa412a54624ee900$export$2e2bcd8739ae039 = $fa412a54624ee900$var$CardText;





var $9kKA1 = parcelRequire("9kKA1");




"use client";
const $1f33e42de4a3e968$var$DivStyledAsH5 = (0, $99aaf3b630596b82$export$2e2bcd8739ae039)('h5');
const $1f33e42de4a3e968$var$CardTitle = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $1f33e42de4a3e968$var$DivStyledAsH5 } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$1f33e42de4a3e968$var$CardTitle.displayName = 'CardTitle';
var $1f33e42de4a3e968$export$2e2bcd8739ae039 = $1f33e42de4a3e968$var$CardTitle;



"use client";
const $bd1a5c984f6db448$var$Card = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children",
        "as"
    ]);
    const prefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $cac08039ce79d8fa$export$2e2bcd8739ae039), {
            children: children
        }) : children
    }));
});
$bd1a5c984f6db448$var$Card.displayName = 'Card';
var $bd1a5c984f6db448$export$2e2bcd8739ae039 = Object.assign($bd1a5c984f6db448$var$Card, {
    Img: (0, $942173aa0f606dd4$export$2e2bcd8739ae039),
    Title: (0, $1f33e42de4a3e968$export$2e2bcd8739ae039),
    Subtitle: (0, $e6dcc4631701ff38$export$2e2bcd8739ae039),
    Body: (0, $cac08039ce79d8fa$export$2e2bcd8739ae039),
    Link: (0, $5c4c1c5a6b5b17be$export$2e2bcd8739ae039),
    Text: (0, $fa412a54624ee900$export$2e2bcd8739ae039),
    Header: (0, $f7b6aa556a2b5916$export$2e2bcd8739ae039),
    Footer: (0, $00e933e8823186d0$export$2e2bcd8739ae039),
    ImgOverlay: (0, $f7b16dfca950c364$export$2e2bcd8739ae039)
});




const $9265c9fe27c422aa$export$9bd698419030e459 = ({ movie: movie })=>{
    const isRemote = typeof movie.ImagePath === "string" && movie.ImagePath.startsWith("http");
    const favIncludes = (arr, id)=>Array.isArray(arr) && arr.some((x)=>String(x) === String(id));
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const [isFavorite, setIsFavorite] = (0, $9kKA1.useState)(favIncludes(storedUser === null || storedUser === void 0 ? void 0 : storedUser.FavoriteMovies, movie._id));
    const [busy, setBusy] = (0, $9kKA1.useState)(false);
    (0, $9kKA1.useEffect)(()=>{
        const handler = (e)=>{
            const updated = e.detail || JSON.parse(localStorage.getItem('user'));
            setIsFavorite(favIncludes(updated === null || updated === void 0 ? void 0 : updated.FavoriteMovies, movie._id));
        };
        window.addEventListener('userUpdated', handler);
        return ()=>window.removeEventListener('userUpdated', handler);
    }, [
        movie._id
    ]);
    const fetchUpdatedUser = async (username, token)=>{
        const url = `https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username)}`;
        console.log('[fav] refresh user GET', url);
        const resUser = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        });
        if (!resUser.ok) throw new Error(`Failed to refresh user (${resUser.status})`);
        return resUser.json();
    };
    const getAuth = ()=>{
        const tkn = localStorage.getItem('token');
        let username = null;
        try {
            var _JSON_parse;
            username = ((_JSON_parse = JSON.parse(localStorage.getItem('user'))) === null || _JSON_parse === void 0 ? void 0 : _JSON_parse.Username) || null;
        } catch (e) {}
        if (!username && tkn) try {
            const payload = JSON.parse(atob(tkn.split('.')[1] || ''));
            var _payload_sub;
            username = (_payload_sub = payload === null || payload === void 0 ? void 0 : payload.sub) !== null && _payload_sub !== void 0 ? _payload_sub : null;
        } catch (e) {}
        return {
            tkn: tkn,
            username: username
        };
    };
    const toggleFavorite = async ()=>{
        const { tkn: tkn, username: username } = getAuth();
        if (!tkn || !username || !(movie === null || movie === void 0 ? void 0 : movie._id)) {
            console.error('[fav] Missing token/username/movieId', {
                hasToken: !!tkn,
                username: username,
                movieId: movie === null || movie === void 0 ? void 0 : movie._id
            });
            return;
        }
        if (busy) return;
        setBusy(true);
        const method = isFavorite ? 'DELETE' : 'POST';
        const url = `https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username)}/favorites/${movie._id}`;
        console.log(`[fav] ${method} ${url}`);
        try {
            const res = await fetch(url, {
                method: method,
                headers: {
                    Authorization: `Bearer ${tkn}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: method === 'POST' ? '{}' : undefined
            });
            const text = await res.text().catch(()=>'');
            console.log('[fav] status:', res.status, 'body:', text);
            if (!res.ok) throw new Error(text || `Favorite update failed (${res.status})`);
            const updatedUser = await fetchUpdatedUser(username, tkn);
            localStorage.setItem('user', JSON.stringify(updatedUser));
            window.dispatchEvent(new CustomEvent('userUpdated', {
                detail: updatedUser
            }));
            setIsFavorite(favIncludes(updatedUser.FavoriteMovies, movie._id));
        } catch (e) {
            console.error('[fav] error:', e);
            alert(`Favorite action failed: ${e.message}`);
        } finally{
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039), {
        className: "h-100 text-center mb-4",
        children: [
            movie.ImagePath && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Img, {
                variant: "top",
                src: isRemote ? movie.ImagePath : `/images/${movie.ImagePath}`,
                className: "img-fluid",
                alt: movie.Title,
                onError: (e)=>{
                    e.target.onerror = null;
                    e.target.src = "https://placehold.co/300x450?text=No+Image";
                }
            }),
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Body, {
                className: "d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Title, {
                        className: "card-title",
                        children: movie.Title
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Text, {
                        className: "text-muted mb-3",
                        children: movie.Description
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                        variant: isFavorite ? "outline-danger" : "outline-primary",
                        onClick: toggleFavorite,
                        disabled: busy,
                        className: "mb-2 w-100",
                        children: busy ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f3b962eca0217e80$export$2e2bcd8739ae039), {
                                    as: "span",
                                    animation: "border",
                                    size: "sm",
                                    className: "me-2"
                                }),
                                "Updating..."
                            ]
                        }) : isFavorite ? "Remove Favorite" : "Add to Favorites"
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                        as: (0, $6c90d8a012cccc16$export$a6c7ac8248d6e38a),
                        to: `/movies/${movie._id}`,
                        variant: "primary",
                        className: "mt-auto w-100",
                        children: "Open"
                    })
                ]
            })
        ]
    });
};
$9265c9fe27c422aa$export$9bd698419030e459.propTypes = {
    movie: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).shape({
        _id: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).string.isRequired,
        Title: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).string.isRequired,
        Description: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).string.isRequired,
        ImagePath: (0, (/*@__PURE__*/$parcel$interopDefault($c67a02999523a9a4$exports))).string
    }).isRequired
};
var $9265c9fe27c422aa$export$2e2bcd8739ae039 = $9265c9fe27c422aa$export$9bd698419030e459;


const $e93e6abc17d7f60e$var$MainView = ({ token: token, onLogout: onLogout })=>{
    console.log("MainView rendered. Token:", token);
    const [movies, setMovies] = (0, $9kKA1.useState)([]);
    const [loading, setLoading] = (0, $9kKA1.useState)(true);
    const [error, setError] = (0, $9kKA1.useState)("");
    const [query, setQuery] = (0, $9kKA1.useState)("");
    const filteredMovies = (0, $9kKA1.useMemo)(()=>{
        const q = query.trim().toLowerCase();
        if (!q) return movies;
        return movies.filter((m)=>{
            var _m_Genre, _m_genre, _m_Director, _m_director;
            const title = (m.Title || m.title || "").toString().toLowerCase();
            const genre = (((_m_Genre = m.Genre) === null || _m_Genre === void 0 ? void 0 : _m_Genre.Name) || ((_m_genre = m.genre) === null || _m_genre === void 0 ? void 0 : _m_genre.name) || "").toString().toLowerCase();
            const director = (((_m_Director = m.Director) === null || _m_Director === void 0 ? void 0 : _m_Director.Name) || ((_m_director = m.director) === null || _m_director === void 0 ? void 0 : _m_director.name) || "").toString().toLowerCase();
            return title.includes(q) || genre.includes(q) || director.includes(q);
        });
    }, [
        movies,
        query
    ]);
    (0, $9kKA1.useEffect)(()=>{
        console.log("useEffect triggered. Token:", token);
        if (!token) return;
        setLoading(true);
        setError("");
        fetch("https://movieapi1-40cbbcb4b0ea.herokuapp.com/movies", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response)=>{
            if (!response.ok) throw new Error("Failed to load movies.");
            return response.json();
        }).then((data)=>{
            setMovies(data);
            setLoading(false);
        }).catch((error)=>{
            console.error("Error fetching movies:", error);
            setError(error.message || "Failed to load movies.");
            setLoading(false);
        });
    }, [
        token
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $558ca21e1ebcb642$exports.Fragment), {
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $f60af856adff6234$export$2e2bcd8739ae039), {
            className: "my-4",
            children: [
                loading && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", {
                    className: "py-5 d-flex justify-content-center",
                    children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f3b962eca0217e80$export$2e2bcd8739ae039), {
                        animation: "border",
                        role: "status"
                    })
                }),
                !loading && error && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $98cf17248b47739d$export$2e2bcd8739ae039), {
                    variant: "danger",
                    children: error
                }),
                !loading && !error && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $110f9e0274134f6c$export$2e2bcd8739ae039), {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $8289c3e1dfc9e5a0$export$2e2bcd8739ae039), {
                                xs: 12,
                                sm: 8,
                                md: 6,
                                lg: 4,
                                children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $2e2d747203b83887$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                        type: "search",
                                        placeholder: "Filter by title, genre, or director",
                                        value: query,
                                        onChange: (e)=>setQuery(e.target.value),
                                        "aria-label": "Filter movies"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $110f9e0274134f6c$export$2e2bcd8739ae039), {
                            className: "g-4",
                            children: filteredMovies.map((movie)=>/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $8289c3e1dfc9e5a0$export$2e2bcd8739ae039), {
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 3,
                                    children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $9265c9fe27c422aa$export$2e2bcd8739ae039), {
                                        movie: movie
                                    })
                                }, movie._id))
                        }),
                        filteredMovies.length === 0 && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                            className: "text-muted mt-3",
                            children: [
                                "No movies match \u201C",
                                query,
                                "\u201D."
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $e93e6abc17d7f60e$export$2e2bcd8739ae039 = $e93e6abc17d7f60e$var$MainView;




var $9kKA1 = parcelRequire("9kKA1");


const $dd924d4a82f2ca16$var$LoginView = ({ onLoggedIn: onLoggedIn })=>{
    const [username, setUsername] = (0, $9kKA1.useState)("");
    const [password, setPassword] = (0, $9kKA1.useState)("");
    const [error, setError] = (0, $9kKA1.useState)("");
    const [loading, setLoading] = (0, $9kKA1.useState)(false);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const res = await fetch("https://movieapi1-40cbbcb4b0ea.herokuapp.com/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    Username: username,
                    Password: password
                })
            });
            if (!res.ok) {
                const errorData = await res.text();
                throw new Error(`Server error: ${res.status} - ${errorData}`);
            }
            const data = await res.json();
            if (!(data === null || data === void 0 ? void 0 : data.token) || !(data === null || data === void 0 ? void 0 : data.user)) throw new Error((data === null || data === void 0 ? void 0 : data.message) || "Invalid response from server");
            // Persist auth
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("token", data.token);
            onLoggedIn(data.user, data.token);
        } catch (err) {
            console.error("Login failed:", err);
            setError(err.message || "Network error - please try again");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", {
        className: "container-fluid px-3 py-3",
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", {
            className: "row justify-content-center",
            children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                className: "col-12 col-sm-8 col-md-6 col-lg-4",
                children: [
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("h2", {
                            children: "Login"
                        })
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039), {
                        onSubmit: handleSubmit,
                        className: "p-3 p-md-4 border rounded bg-light shadow-sm",
                        children: [
                            error && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $98cf17248b47739d$export$2e2bcd8739ae039), {
                                variant: "danger",
                                children: error
                            }),
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                controlId: "formUsername",
                                children: [
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                        children: "Username"
                                    }),
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                        type: "text",
                                        value: username,
                                        onChange: (e)=>setUsername(e.target.value),
                                        required: true,
                                        autoFocus: true,
                                        className: "form-control-lg"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                controlId: "formPassword",
                                className: "mt-3",
                                children: [
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                        type: "password",
                                        value: password,
                                        onChange: (e)=>setPassword(e.target.value),
                                        required: true,
                                        className: "form-control-lg"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                                variant: "primary",
                                type: "submit",
                                className: "w-100 mt-4 btn-lg",
                                disabled: loading,
                                children: loading ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("span", {
                                            className: "spinner-border spinner-border-sm me-2",
                                            role: "status",
                                            "aria-hidden": "true"
                                        }),
                                        "Logging in..."
                                    ]
                                }) : "Login"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("p", {
                        className: "text-center mt-3",
                        children: [
                            "Don't have an account? ",
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $6c90d8a012cccc16$export$a6c7ac8248d6e38a), {
                                to: "/signup",
                                children: "Sign up here"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $dd924d4a82f2ca16$export$2e2bcd8739ae039 = $dd924d4a82f2ca16$var$LoginView;




var $9kKA1 = parcelRequire("9kKA1");


const $916186ad21c0fbbf$var$SignupView = ()=>{
    const [username, setUsername] = (0, $9kKA1.useState)("");
    const [password, setPassword] = (0, $9kKA1.useState)("");
    const [email, setEmail] = (0, $9kKA1.useState)("");
    const [birthday, setBirthday] = (0, $9kKA1.useState)("");
    const [error, setError] = (0, $9kKA1.useState)("");
    const [success, setSuccess] = (0, $9kKA1.useState)("");
    const [submitting, setSubmitting] = (0, $9kKA1.useState)(false);
    const handleSubmit = (event)=>{
        event.preventDefault();
        setError("");
        setSuccess("");
        setSubmitting(true);
        const data = {
            Username: username,
            Password: password,
            Email: email,
            Birthday: birthday
        };
        fetch("https://movieapi1-40cbbcb4b0ea.herokuapp.com/users", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) return response.text().then((text)=>{
                throw new Error(text || "Signup failed");
            });
            return response.json();
        }).then(()=>{
            setSuccess("Signup successful! You can now log in.");
            setUsername("");
            setPassword("");
            setEmail("");
            setBirthday("");
        }).catch((error)=>{
            console.error("Signup error:", error);
            setError(error.message || "Signup failed due to a network error.");
        }).finally(()=>setSubmitting(false));
    };
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f60af856adff6234$export$2e2bcd8739ae039), {
        className: "py-3 px-3",
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $110f9e0274134f6c$export$2e2bcd8739ae039), {
            className: "justify-content-center",
            children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $8289c3e1dfc9e5a0$export$2e2bcd8739ae039), {
                xs: 12,
                sm: 8,
                md: 6,
                lg: 4,
                children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039), {
                    className: "shadow-sm",
                    children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Body, {
                        className: "p-3 p-md-4",
                        children: [
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Title, {
                                className: "text-center mb-4",
                                children: "Sign Up"
                            }),
                            error && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $98cf17248b47739d$export$2e2bcd8739ae039), {
                                variant: "danger",
                                children: error
                            }),
                            success && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $98cf17248b47739d$export$2e2bcd8739ae039), {
                                variant: "success",
                                children: success
                            }),
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039), {
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                        className: "mb-3",
                                        controlId: "signupUsername",
                                        children: [
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                                children: "Username"
                                            }),
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                                type: "text",
                                                value: username,
                                                onChange: (e)=>setUsername(e.target.value),
                                                required: true,
                                                minLength: 3,
                                                disabled: submitting,
                                                className: "form-control-lg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                        className: "mb-3",
                                        controlId: "signupPassword",
                                        children: [
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                                type: "password",
                                                value: password,
                                                onChange: (e)=>setPassword(e.target.value),
                                                required: true,
                                                minLength: 6,
                                                disabled: submitting,
                                                className: "form-control-lg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                        className: "mb-3",
                                        controlId: "signupEmail",
                                        children: [
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                                type: "email",
                                                value: email,
                                                onChange: (e)=>setEmail(e.target.value),
                                                required: true,
                                                disabled: submitting,
                                                className: "form-control-lg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                        className: "mb-4",
                                        controlId: "signupBirthday",
                                        children: [
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                                children: "Birthday"
                                            }),
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                                type: "date",
                                                value: birthday,
                                                onChange: (e)=>setBirthday(e.target.value),
                                                required: true,
                                                disabled: submitting,
                                                className: "form-control-lg"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                                        type: "submit",
                                        variant: "success",
                                        className: "w-100 btn-lg",
                                        disabled: submitting,
                                        children: submitting ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f3b962eca0217e80$export$2e2bcd8739ae039), {
                                                    as: "span",
                                                    animation: "border",
                                                    size: "sm",
                                                    className: "me-2"
                                                }),
                                                "Signing Up..."
                                            ]
                                        }) : "Sign Up"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                                className: "text-center mt-3",
                                children: [
                                    "Already have an account? ",
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $6c90d8a012cccc16$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        children: "Login here"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $916186ad21c0fbbf$export$2e2bcd8739ae039 = $916186ad21c0fbbf$var$SignupView;




var $9kKA1 = parcelRequire("9kKA1");


const $8e5bf656842d3c0e$export$b378b4d12a0dcbde = ({ user: user, token: token, setUser: setUser })=>{
    const [profile, setProfile] = (0, $9kKA1.useState)(null);
    const [loading, setLoading] = (0, $9kKA1.useState)(true);
    const [error, setError] = (0, $9kKA1.useState)("");
    const [removingId, setRemovingId] = (0, $9kKA1.useState)(null);
    const [newUsername, setNewUsername] = (0, $9kKA1.useState)("");
    const [newEmail, setNewEmail] = (0, $9kKA1.useState)("");
    const [newPassword, setNewPassword] = (0, $9kKA1.useState)("");
    const [saving, setSaving] = (0, $9kKA1.useState)(false);
    const [message, setMessage] = (0, $9kKA1.useState)(null);
    const [favoriteMovies, setFavoriteMovies] = (0, $9kKA1.useState)([]); // added
    const navigate = (0, $7a35efd9976b1f32$export$9770f232ac06a008)();
    const resolveAuth = (0, $9kKA1.useCallback)(()=>{
        const tkn = token !== null && token !== void 0 ? token : localStorage.getItem("token");
        let storedUser = null;
        try {
            storedUser = JSON.parse(localStorage.getItem("user"));
        } catch (e) {}
        var _storedUser_Username, _ref;
        let username = (_ref = (_storedUser_Username = storedUser === null || storedUser === void 0 ? void 0 : storedUser.Username) !== null && _storedUser_Username !== void 0 ? _storedUser_Username : user === null || user === void 0 ? void 0 : user.Username) !== null && _ref !== void 0 ? _ref : null;
        if (!username && tkn) try {
            const payload = JSON.parse(atob(tkn.split(".")[1] || ""));
            var _payload_sub;
            username = (_payload_sub = payload === null || payload === void 0 ? void 0 : payload.sub) !== null && _payload_sub !== void 0 ? _payload_sub : null;
        } catch (e) {}
        return {
            tkn: tkn,
            username: username,
            storedUser: storedUser
        };
    }, [
        token,
        user
    ]);
    const fetchUpdatedUser = async (username, tkn)=>{
        const url = `https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username)}`;
        const resUser = await fetch(url, {
            headers: {
                Authorization: `Bearer ${tkn}`,
                Accept: 'application/json'
            }
        });
        if (!resUser.ok) throw new Error(`Failed to refresh user (${resUser.status})`);
        return resUser.json();
    };
    const fetchFavoriteDetails = (0, $9kKA1.useCallback)(async (tkn, favoriteIds)=>{
        try {
            const res = await fetch("https://movieapi1-40cbbcb4b0ea.herokuapp.com/movies", {
                headers: {
                    Authorization: `Bearer ${tkn}`,
                    Accept: "application/json"
                }
            });
            if (!res.ok) throw new Error(`Failed to load movies (${res.status})`);
            const allMovies = await res.json();
            const idSet = new Set((favoriteIds || []).map((x)=>String(typeof x === "string" ? x : x === null || x === void 0 ? void 0 : x._id)));
            const details = (allMovies || []).filter((m)=>idSet.has(String(m._id)));
            setFavoriteMovies(details);
        } catch (e) {
            console.error("[favorites] load error:", e);
            setFavoriteMovies([]);
        }
    }, []);
    const loadProfile = (0, $9kKA1.useCallback)(async ()=>{
        const { tkn: tkn, username: username, storedUser: storedUser } = resolveAuth();
        if (!tkn) {
            setError("Missing auth token.");
            setLoading(false);
            return;
        }
        setLoading(true);
        setError("");
        console.log('Fetching profile for user:', storedUser || user);
        console.log('Username:', username);
        console.log('Full URL:', `https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username || "")}`);
        if (!username) {
            setError("Username is missing; cannot fetch profile.");
            setLoading(false);
            return;
        }
        try {
            const data = await fetchUpdatedUser(username, tkn);
            var _data_user;
            const userObj = (_data_user = data.user) !== null && _data_user !== void 0 ? _data_user : data;
            setProfile(userObj);
            setNewUsername(userObj.Username || "");
            setNewEmail(userObj.Email || "");
            await fetchFavoriteDetails(tkn, userObj.FavoriteMovies); // added
        } catch (e) {
            setError(e.message || "Failed to load profile.");
        } finally{
            setLoading(false);
        }
    }, [
        resolveAuth,
        user,
        fetchFavoriteDetails
    ]);
    (0, $9kKA1.useEffect)(()=>{
        loadProfile();
    }, [
        loadProfile
    ]);
    const removeFavorite = async (movieId)=>{
        const { tkn: tkn, username: username } = resolveAuth();
        if (!tkn || !username || !movieId) {
            console.error("Missing auth or movie id", {
                hasToken: !!tkn,
                username: username,
                movieId: movieId
            });
            return;
        }
        setRemovingId(String(movieId));
        try {
            const res = await fetch(`https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username)}/favorites/${movieId}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${tkn}`,
                    Accept: "application/json"
                }
            });
            if (!res.ok) {
                const msg = await res.text().catch(()=>"");
                throw new Error(msg || `Failed to remove favorite (${res.status})`);
            }
            const updated = await fetchUpdatedUser(username, tkn);
            var _updated_user;
            const userObj = (_updated_user = updated.user) !== null && _updated_user !== void 0 ? _updated_user : updated;
            localStorage.setItem("user", JSON.stringify(userObj));
            window.dispatchEvent(new CustomEvent("userUpdated", {
                detail: userObj
            }));
            setProfile(userObj);
            setMessage({
                type: "success",
                text: "Favorite removed."
            });
            setFavoriteMovies((prev)=>prev.filter((m)=>String(m._id) !== String(movieId))); // added
        } catch (e) {
            console.error(e);
            setMessage({
                type: "danger",
                text: `Could not remove favorite: ${e.message}`
            });
        } finally{
            setRemovingId(null);
        }
    };
    const handleUpdate = async (e)=>{
        e.preventDefault();
        const { tkn: tkn, username: username } = resolveAuth();
        if (!tkn || !username) {
            setMessage({
                type: "danger",
                text: "Missing authentication."
            });
            return;
        }
        const body = {};
        if (newUsername && newUsername !== (profile === null || profile === void 0 ? void 0 : profile.Username)) body.Username = newUsername;
        if (newEmail && newEmail !== (profile === null || profile === void 0 ? void 0 : profile.Email)) body.Email = newEmail;
        if (newPassword) body.Password = newPassword;
        if (Object.keys(body).length === 0) {
            setMessage({
                type: "info",
                text: "No changes to save."
            });
            return;
        }
        setSaving(true);
        setMessage(null);
        try {
            const res = await fetch(`https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username)}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${tkn}`,
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const text = await res.text();
            let data;
            try {
                data = JSON.parse(text);
            } catch (e) {
                data = text;
            }
            if (!res.ok) {
                const msg = data && data.message ? data.message : `Update failed (${res.status})`;
                throw new Error(msg);
            }
            const updatedUser = data && data.user ? data.user : data && data.Username ? data : null;
            const newToken = data && data.token ? data.token : null;
            if (updatedUser) {
                localStorage.setItem("user", JSON.stringify(updatedUser));
                if (newToken) localStorage.setItem("token", newToken);
                window.dispatchEvent(new CustomEvent("userUpdated", {
                    detail: updatedUser
                }));
                setProfile(updatedUser);
                setMessage({
                    type: "success",
                    text: "Profile updated."
                });
            } else {
                var _body_Username;
                const refreshed = await fetchUpdatedUser((_body_Username = body.Username) !== null && _body_Username !== void 0 ? _body_Username : username, tkn);
                var _refreshed_user;
                const userObj = (_refreshed_user = refreshed.user) !== null && _refreshed_user !== void 0 ? _refreshed_user : refreshed;
                localStorage.setItem("user", JSON.stringify(userObj));
                window.dispatchEvent(new CustomEvent("userUpdated", {
                    detail: userObj
                }));
                setProfile(userObj);
                setMessage({
                    type: "success",
                    text: "Profile updated."
                });
            }
            if (newUsername && !newToken) setMessage({
                type: "warning",
                text: "Username changed. Please log in again."
            });
        } catch (err) {
            console.error(err);
            setMessage({
                type: "danger",
                text: err.message || "Update failed."
            });
        } finally{
            setSaving(false);
            setNewPassword("");
        }
    };
    const handleDeregister = async ()=>{
        const confirm = window.confirm("Are you sure you want to delete your account? This action cannot be undone.");
        if (!confirm) return;
        const { tkn: tkn, username: username } = resolveAuth();
        if (!tkn || !username) {
            setMessage({
                type: "danger",
                text: "Missing authentication."
            });
            return;
        }
        setSaving(true);
        try {
            const res = await fetch(`https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username)}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${tkn}`,
                    Accept: "application/json"
                }
            });
            if (!res.ok) {
                const txt = await res.text().catch(()=>"");
                throw new Error(txt || `Delete failed (${res.status})`);
            }
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            window.dispatchEvent(new CustomEvent("userUpdated", {
                detail: null
            }));
            if (setUser) setUser(null);
            navigate("/");
        } catch (err) {
            console.error(err);
            setMessage({
                type: "danger",
                text: err.message || "Account deletion failed."
            });
        } finally{
            setSaving(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
        className: "p-4",
        children: [
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f3b962eca0217e80$export$2e2bcd8739ae039), {
                animation: "border"
            }),
            " Loading profile..."
        ]
    });
    if (error) return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", {
        className: "p-4 text-danger",
        children: error
    });
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f60af856adff6234$export$2e2bcd8739ae039), {
        className: "py-4",
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039), {
            className: "shadow-sm",
            children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Body, {
                className: "p-4",
                children: [
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("h2", {
                        className: "mb-3",
                        children: "Your Profile"
                    }),
                    message && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $98cf17248b47739d$export$2e2bcd8739ae039), {
                        variant: message.type,
                        children: message.text
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $110f9e0274134f6c$export$2e2bcd8739ae039), {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $8289c3e1dfc9e5a0$export$2e2bcd8739ae039), {
                                md: 6,
                                children: [
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("strong", {
                                                children: "Username:"
                                            }),
                                            " ",
                                            profile === null || profile === void 0 ? void 0 : profile.Username
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("strong", {
                                                children: "Email:"
                                            }),
                                            " ",
                                            profile === null || profile === void 0 ? void 0 : profile.Email
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("strong", {
                                                children: "Birthday:"
                                            }),
                                            " ",
                                            (profile === null || profile === void 0 ? void 0 : profile.Birthday) ? new Date(profile.Birthday).toLocaleDateString() : "Not provided"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $8289c3e1dfc9e5a0$export$2e2bcd8739ae039), {
                                md: 6,
                                children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039), {
                                    onSubmit: handleUpdate,
                                    children: [
                                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                            className: "mb-2",
                                            controlId: "formUsername",
                                            children: [
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                                    children: "Change Username"
                                                }),
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                                    value: newUsername,
                                                    onChange: (e)=>setNewUsername(e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                            className: "mb-2",
                                            controlId: "formEmail",
                                            children: [
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                                    children: "Change Email"
                                                }),
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                                    type: "email",
                                                    value: newEmail,
                                                    onChange: (e)=>setNewEmail(e.target.value)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            controlId: "formPassword",
                                            children: [
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Label, {
                                                    children: "Change Password"
                                                }),
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $a4223ba6d68fcdb0$export$2e2bcd8739ae039).Control, {
                                                    type: "password",
                                                    value: newPassword,
                                                    onChange: (e)=>setNewPassword(e.target.value),
                                                    placeholder: "Leave blank to keep current password"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                                            className: "d-flex gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                                                    type: "submit",
                                                    variant: "primary",
                                                    disabled: saving,
                                                    children: saving ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f3b962eca0217e80$export$2e2bcd8739ae039), {
                                                                as: "span",
                                                                animation: "border",
                                                                size: "sm",
                                                                className: "me-2"
                                                            }),
                                                            "Saving..."
                                                        ]
                                                    }) : "Save changes"
                                                }),
                                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                                                    variant: "outline-danger",
                                                    onClick: handleDeregister,
                                                    disabled: saving,
                                                    children: "Delete account"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("strong", {
                                children: "Favorite Movies:"
                            }),
                            (favoriteMovies === null || favoriteMovies === void 0 ? void 0 : favoriteMovies.length) ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("ul", {
                                style: {
                                    listStyle: "none",
                                    padding: 0
                                },
                                children: favoriteMovies.map((movie)=>{
                                    var _movie_Genre, _movie_Director;
                                    const id = movie._id;
                                    const isRemote = typeof movie.ImagePath === "string" && movie.ImagePath.startsWith("http");
                                    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("li", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    (movie === null || movie === void 0 ? void 0 : movie.ImagePath) ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("img", {
                                                        src: isRemote ? movie.ImagePath : `/images/${movie.ImagePath}`,
                                                        alt: (movie === null || movie === void 0 ? void 0 : movie.Title) || "Movie",
                                                        style: {
                                                            width: "80px",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            marginRight: "15px"
                                                        },
                                                        onError: (e)=>{
                                                            e.currentTarget.src = "https://placehold.co/80x120?text=No+Image";
                                                        }
                                                    }) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("img", {
                                                        src: "https://placehold.co/80x120?text=No+Image",
                                                        alt: "No poster",
                                                        style: {
                                                            width: "80px",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            marginRight: "15px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("strong", {
                                                                children: (movie === null || movie === void 0 ? void 0 : movie.Title) || id
                                                            }),
                                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("br", {}),
                                                            "Genre: ",
                                                            (movie === null || movie === void 0 ? void 0 : (_movie_Genre = movie.Genre) === null || _movie_Genre === void 0 ? void 0 : _movie_Genre.Name) || "N/A",
                                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("br", {}),
                                                            "Director: ",
                                                            (movie === null || movie === void 0 ? void 0 : (_movie_Director = movie.Director) === null || _movie_Director === void 0 ? void 0 : _movie_Director.Name) || "N/A"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                                                variant: "outline-danger",
                                                size: "sm",
                                                onClick: ()=>removeFavorite(id),
                                                disabled: removingId === String(id),
                                                children: removingId === String(id) ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f3b962eca0217e80$export$2e2bcd8739ae039), {
                                                            as: "span",
                                                            animation: "border",
                                                            size: "sm",
                                                            className: "me-2"
                                                        }),
                                                        "Removing..."
                                                    ]
                                                }) : "Remove"
                                            })
                                        ]
                                    }, id);
                                })
                            }) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("p", {
                                children: "No favorite movies added yet."
                            })
                        ]
                    })
                ]
            })
        })
    });
};




var $9kKA1 = parcelRequire("9kKA1");



const $b3cd1832d0976658$export$78d497080ea8f89a = ({ token: token })=>{
    const { movieId: movieId } = (0, $7a35efd9976b1f32$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7a35efd9976b1f32$export$9770f232ac06a008)();
    const [movie, setMovie] = (0, $9kKA1.useState)(null);
    const [loading, setLoading] = (0, $9kKA1.useState)(true);
    const [isFavorite, setIsFavorite] = (0, $9kKA1.useState)(false);
    const [busy, setBusy] = (0, $9kKA1.useState)(false);
    (0, $9kKA1.useEffect)(()=>{
        if (!movieId) return;
        setLoading(true);
        fetch(`https://movieapi1-40cbbcb4b0ea.herokuapp.com/movies/${movieId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response)=>response.json()).then((movieData)=>{
            setMovie(movieData);
            setLoading(false);
        }).catch((error)=>{
            console.error('Error fetching movie:', error);
            setLoading(false);
        });
    }, [
        movieId,
        token
    ]);
    const favIncludes = (arr, id)=>Array.isArray(arr) && arr.some((x)=>String(x) === String(id));
    (0, $9kKA1.useEffect)(()=>{
        const stored = JSON.parse(localStorage.getItem('user'));
        setIsFavorite(favIncludes(stored === null || stored === void 0 ? void 0 : stored.FavoriteMovies, movie === null || movie === void 0 ? void 0 : movie._id));
    }, [
        movie
    ]);
    (0, $9kKA1.useEffect)(()=>{
        const handler = (e)=>{
            const updated = e.detail;
            if (updated && (movie === null || movie === void 0 ? void 0 : movie._id)) setIsFavorite(favIncludes(updated.FavoriteMovies, movie._id));
        };
        window.addEventListener('userUpdated', handler);
        return ()=>window.removeEventListener('userUpdated', handler);
    }, [
        movie === null || movie === void 0 ? void 0 : movie._id
    ]);
    const fetchUpdatedUser = async (username, tkn)=>{
        const url = `https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username)}`;
        const resUser = await fetch(url, {
            headers: {
                Authorization: `Bearer ${tkn}`,
                Accept: 'application/json'
            }
        });
        if (!resUser.ok) throw new Error('Failed to refresh user after favorite update');
        return resUser.json();
    };
    const getUsername = ()=>{
        try {
            var _JSON_parse;
            return ((_JSON_parse = JSON.parse(localStorage.getItem('user'))) === null || _JSON_parse === void 0 ? void 0 : _JSON_parse.Username) || null;
        } catch (e) {
            return null;
        }
    };
    const toggleFavorite = async ()=>{
        const tkn = localStorage.getItem('token');
        const username = getUsername();
        if (!tkn || !username || !(movie === null || movie === void 0 ? void 0 : movie._id)) return;
        setBusy(true);
        const method = isFavorite ? 'DELETE' : 'POST';
        try {
            const url = `https://movieapi1-40cbbcb4b0ea.herokuapp.com/users/${encodeURIComponent(username)}/favorites/${movie._id}`;
            const res = await fetch(url, {
                method: method,
                headers: {
                    Authorization: `Bearer ${tkn}`,
                    Accept: 'application/json'
                }
            });
            if (!res.ok) {
                const msg = await res.text().catch(()=>'');
                throw new Error(msg || 'Favorite update failed');
            }
            const updatedUser = await fetchUpdatedUser(username, tkn);
            localStorage.setItem('user', JSON.stringify(updatedUser));
            window.dispatchEvent(new CustomEvent('userUpdated', {
                detail: updatedUser
            }));
            setIsFavorite(favIncludes(updatedUser.FavoriteMovies, movie._id));
        } catch (e) {
            console.error(e);
        } finally{
            setBusy(false);
        }
    };
    const handleBackClick = ()=>navigate(-1);
    if (loading) return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f60af856adff6234$export$2e2bcd8739ae039), {
        className: "py-5 d-flex justify-content-center",
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f3b962eca0217e80$export$2e2bcd8739ae039), {
            animation: "border",
            role: "status"
        })
    });
    if (!movie) return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f60af856adff6234$export$2e2bcd8739ae039), {
        className: "py-5",
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $98cf17248b47739d$export$2e2bcd8739ae039), {
            variant: "warning",
            className: "mb-0",
            children: "Movie not found"
        })
    });
    const isRemote = typeof movie.ImagePath === "string" && movie.ImagePath.startsWith("http");
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f60af856adff6234$export$2e2bcd8739ae039), {
        className: "my-4",
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $110f9e0274134f6c$export$2e2bcd8739ae039), {
            className: "g-4",
            children: [
                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $8289c3e1dfc9e5a0$export$2e2bcd8739ae039), {
                    xs: 12,
                    md: 4,
                    children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039), {
                        className: "h-100",
                        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Img, {
                            variant: "top",
                            src: isRemote ? movie.ImagePath : `/images/${movie.ImagePath}`,
                            alt: movie.Title,
                            onError: (e)=>{
                                e.target.onerror = null;
                                e.target.src = "https://placehold.co/300x450?text=No+Image";
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $8289c3e1dfc9e5a0$export$2e2bcd8739ae039), {
                    xs: 12,
                    md: 8,
                    children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039), {
                        className: "h-100",
                        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Body, {
                            className: "d-flex flex-column",
                            children: [
                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Title, {
                                    children: movie.Title
                                }),
                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $bd1a5c984f6db448$export$2e2bcd8739ae039).Text, {
                                    className: "mb-3",
                                    children: movie.Description
                                }),
                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", {
                                    className: "d-flex flex-column flex-sm-row gap-2 mt-auto",
                                    children: [
                                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                                            variant: isFavorite ? "outline-danger" : "outline-primary",
                                            onClick: toggleFavorite,
                                            disabled: busy,
                                            children: busy ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f3b962eca0217e80$export$2e2bcd8739ae039), {
                                                        as: "span",
                                                        animation: "border",
                                                        size: "sm",
                                                        className: "me-2"
                                                    }),
                                                    "Updating..."
                                                ]
                                            }) : isFavorite ? "Remove Favorite" : "Add to Favorites"
                                        }),
                                        /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            onClick: handleBackClick,
                                            children: "Back"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $b3cd1832d0976658$export$2e2bcd8739ae039 = $b3cd1832d0976658$export$78d497080ea8f89a;



parcelRequire("9kKA1");




var $9kKA1 = parcelRequire("9kKA1");

var $0832d814c73969c1$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $0832d814c73969c1$export$2e2bcd8739ae039(element, selector) {
    return $0832d814c73969c1$var$toArray(element.querySelectorAll(selector));
}



var $9kKA1 = parcelRequire("9kKA1");

var $9kKA1 = parcelRequire("9kKA1");
function $6fcdc35a04622a56$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $9kKA1.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}



var $9kKA1 = parcelRequire("9kKA1");
const $ce8d3037a0dabc94$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $ce8d3037a0dabc94$export$c9058316764c140e(refA, refB) {
    const a = $ce8d3037a0dabc94$var$toFnRef(refA);
    const b = $ce8d3037a0dabc94$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $ce8d3037a0dabc94$var$useMergedRefs(refA, refB) {
    return (0, $9kKA1.useMemo)(()=>$ce8d3037a0dabc94$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $ce8d3037a0dabc94$export$2e2bcd8739ae039 = $ce8d3037a0dabc94$var$useMergedRefs;



var $9kKA1 = parcelRequire("9kKA1");
const $fca43189cd5251a5$var$NavContext = /*#__PURE__*/ $9kKA1.createContext(null);
$fca43189cd5251a5$var$NavContext.displayName = 'NavContext';
var $fca43189cd5251a5$export$2e2bcd8739ae039 = $fca43189cd5251a5$var$NavContext;



var $9kKA1 = parcelRequire("9kKA1");
const $15f48004d4168d8c$var$SelectableContext = /*#__PURE__*/ $9kKA1.createContext(null);
const $15f48004d4168d8c$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $15f48004d4168d8c$export$2e2bcd8739ae039 = $15f48004d4168d8c$var$SelectableContext;



var $9kKA1 = parcelRequire("9kKA1");
const $6dc886aaf0111a20$var$TabContext = /*#__PURE__*/ $9kKA1.createContext(null);
var $6dc886aaf0111a20$export$2e2bcd8739ae039 = $6dc886aaf0111a20$var$TabContext;


const $c596eb6171d96e96$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $c596eb6171d96e96$export$635202801f9383a0 = `rrUi`;
function $c596eb6171d96e96$export$5cc3b7b83e34ade7(property) {
    return `${$c596eb6171d96e96$export$fd7bcb7e9bef4e8a}${property}`;
}
function $c596eb6171d96e96$export$7776c0a7cd2eb3e0(property) {
    return `${$c596eb6171d96e96$export$635202801f9383a0}${property}`;
}



var $9kKA1 = parcelRequire("9kKA1");







const $531d61d39065ec19$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $531d61d39065ec19$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $531d61d39065ec19$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $9kKA1.useContext)((0, $15f48004d4168d8c$export$2e2bcd8739ae039));
    const navContext = (0, $9kKA1.useContext)((0, $fca43189cd5251a5$export$2e2bcd8739ae039));
    const tabContext = (0, $9kKA1.useContext)((0, $6dc886aaf0111a20$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $c596eb6171d96e96$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $531d61d39065ec19$var$NavItem = /*#__PURE__*/ $9kKA1.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $1846bbec3b51e2a0$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $531d61d39065ec19$var$_objectWithoutPropertiesLoose(_ref, $531d61d39065ec19$var$_excluded);
    const [props, meta] = $531d61d39065ec19$export$d7a68693710982a(Object.assign({
        key: (0, $15f48004d4168d8c$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $c596eb6171d96e96$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$531d61d39065ec19$var$NavItem.displayName = 'NavItem';
var $531d61d39065ec19$export$2e2bcd8739ae039 = $531d61d39065ec19$var$NavItem;



const $e2cd0edcce5d3d21$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $e2cd0edcce5d3d21$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $e2cd0edcce5d3d21$var$noop = ()=>{};
const $e2cd0edcce5d3d21$var$EVENT_KEY_ATTR = (0, $c596eb6171d96e96$export$5cc3b7b83e34ade7)('event-key');
const $e2cd0edcce5d3d21$var$Nav = /*#__PURE__*/ $9kKA1.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $e2cd0edcce5d3d21$var$_objectWithoutPropertiesLoose(_ref, $e2cd0edcce5d3d21$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $6fcdc35a04622a56$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $9kKA1.useRef)(false);
    const parentOnSelect = (0, $9kKA1.useContext)((0, $15f48004d4168d8c$export$2e2bcd8739ae039));
    const tabContext = (0, $9kKA1.useContext)((0, $6dc886aaf0111a20$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $9kKA1.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $0832d814c73969c1$export$2e2bcd8739ae039)(currentListNode, `[${$e2cd0edcce5d3d21$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $c596eb6171d96e96$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $9kKA1.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$e2cd0edcce5d3d21$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $ce8d3037a0dabc94$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $15f48004d4168d8c$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $fca43189cd5251a5$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $15f48004d4168d8c$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $e2cd0edcce5d3d21$var$noop,
                getControllerId: getControllerId || $e2cd0edcce5d3d21$var$noop
            },
            children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$e2cd0edcce5d3d21$var$Nav.displayName = 'Nav';
var $e2cd0edcce5d3d21$export$2e2bcd8739ae039 = Object.assign($e2cd0edcce5d3d21$var$Nav, {
    Item: (0, $531d61d39065ec19$export$2e2bcd8739ae039)
});




var $9kKA1 = parcelRequire("9kKA1");
"use client";
// TODO: check
const $f5cd3078242fa25d$var$context = /*#__PURE__*/ $9kKA1.createContext(null);
$f5cd3078242fa25d$var$context.displayName = 'NavbarContext';
var $f5cd3078242fa25d$export$2e2bcd8739ae039 = $f5cd3078242fa25d$var$context;






var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $56e436a03274f8a1$var$NavItem = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$56e436a03274f8a1$var$NavItem.displayName = 'NavItem';
var $56e436a03274f8a1$export$2e2bcd8739ae039 = $56e436a03274f8a1$var$NavItem;







var $9kKA1 = parcelRequire("9kKA1");





"use client";
const $49fbf9872b827e2a$var$NavLink = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, as: Component = (0, $31b3e00d6bbcb13c$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as",
        "active",
        "eventKey",
        "disabled"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $531d61d39065ec19$export$d7a68693710982a)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        key: (0, $15f48004d4168d8c$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props, navItemProps), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    }));
});
$49fbf9872b827e2a$var$NavLink.displayName = 'NavLink';
var $49fbf9872b827e2a$export$2e2bcd8739ae039 = $49fbf9872b827e2a$var$NavLink;



"use client";
const $e7db6bfb300bcf03$var$Nav = /*#__PURE__*/ $9kKA1.forwardRef((uncontrolledProps, ref)=>{
    const _useUncontrolled = (0, $a88d4624e47843eb$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    }), { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey } = _useUncontrolled, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_useUncontrolled, [
        "as",
        "bsPrefix",
        "variant",
        "fill",
        "justify",
        "navbar",
        "navbarScroll",
        "className",
        "activeKey"
    ]);
    const bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $9kKA1.useContext)((0, $f5cd3078242fa25d$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $9kKA1.useContext)((0, $625a1bfdff3c0029$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $e2cd0edcce5d3d21$export$2e2bcd8739ae039), (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        })
    }, props));
});
$e7db6bfb300bcf03$var$Nav.displayName = 'Nav';
var $e7db6bfb300bcf03$export$2e2bcd8739ae039 = Object.assign($e7db6bfb300bcf03$var$Nav, {
    Item: (0, $56e436a03274f8a1$export$2e2bcd8739ae039),
    Link: (0, $49fbf9872b827e2a$export$2e2bcd8739ae039)
});






var $9kKA1 = parcelRequire("9kKA1");







var $9kKA1 = parcelRequire("9kKA1");


"use client";
const $ff662cbfacb0f1f4$var$NavbarBrand = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, as: as } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }));
});
$ff662cbfacb0f1f4$var$NavbarBrand.displayName = 'NavbarBrand';
var $ff662cbfacb0f1f4$export$2e2bcd8739ae039 = $ff662cbfacb0f1f4$var$NavbarBrand;






var $9kKA1 = parcelRequire("9kKA1");






var $9kKA1 = parcelRequire("9kKA1");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $6965b3eadec3a25e$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $6965b3eadec3a25e$export$2e2bcd8739ae039 = $6965b3eadec3a25e$var$createChainedFunction;





const $294a9c626b061883$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $294a9c626b061883$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $294a9c626b061883$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $da765e750ec11a91$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $da765e750ec11a91$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $294a9c626b061883$var$collapseStyles = {
    [(0, $4e14d0c61bb5db7f$export$84cbff306f539230)]: 'collapse',
    [(0, $4e14d0c61bb5db7f$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $4e14d0c61bb5db7f$export$df38205c966be359)]: 'collapsing',
    [(0, $4e14d0c61bb5db7f$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $294a9c626b061883$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).forwardRef((_param, ref)=>{
    var { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $294a9c626b061883$var$getDefaultDimensionValue } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "className",
        "children",
        "dimension",
        "in",
        "timeout",
        "mountOnEnter",
        "unmountOnExit",
        "appear",
        "getDimensionValue"
    ]);
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $9kKA1.useMemo)(()=>(0, $6965b3eadec3a25e$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $9kKA1.useMemo)(()=>(0, $6965b3eadec3a25e$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $9kKA1.useMemo)(()=>(0, $6965b3eadec3a25e$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $9kKA1.useMemo)(()=>(0, $6965b3eadec3a25e$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $5cafe25a36a1c581$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $9kKA1.useMemo)(()=>(0, $6965b3eadec3a25e$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $2bef307424b2bb39$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        addEndListener: (0, $c9e142ba72a01ec0$export$2e2bcd8739ae039)
    }, props), {
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $4029778e671a2d75$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).cloneElement(children, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, children.props.className, $294a9c626b061883$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            }))
    }));
});
$294a9c626b061883$var$Collapse.displayName = 'Collapse';
var $294a9c626b061883$export$2e2bcd8739ae039 = $294a9c626b061883$var$Collapse;





"use client";
const $65f2c4d41b338be7$var$NavbarCollapse = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { children: children, bsPrefix: bsPrefix } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "children",
        "bsPrefix"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $9kKA1.useContext)((0, $f5cd3078242fa25d$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $294a9c626b061883$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        in: !!(context && context.expanded)
    }, props), {
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    }));
});
$65f2c4d41b338be7$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $65f2c4d41b338be7$export$2e2bcd8739ae039 = $65f2c4d41b338be7$var$NavbarCollapse;







var $9kKA1 = parcelRequire("9kKA1");




"use client";
const $73d4afa90a9b16ce$var$NavbarToggle = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'button', onClick: onClick } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "children",
        "label",
        "as",
        "onClick"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $9kKA1.useContext)((0, $f5cd3078242fa25d$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $e881a5f2f7c6fa3f$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props), {
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    }));
});
$73d4afa90a9b16ce$var$NavbarToggle.displayName = 'NavbarToggle';
var $73d4afa90a9b16ce$export$2e2bcd8739ae039 = $73d4afa90a9b16ce$var$NavbarToggle;






var $9kKA1 = parcelRequire("9kKA1");






var $9kKA1 = parcelRequire("9kKA1");
const $36fa20552ebd1c7e$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $36fa20552ebd1c7e$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $36fa20552ebd1c7e$export$2e2bcd8739ae039 = $36fa20552ebd1c7e$var$isDOM || $36fa20552ebd1c7e$var$isReactNative ? (0, $9kKA1.useLayoutEffect) : (0, $9kKA1.useEffect);



var $9kKA1 = parcelRequire("9kKA1");
const $0da83dc02f0b2b9e$var$matchersByWindow = new WeakMap();
const $0da83dc02f0b2b9e$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $0da83dc02f0b2b9e$var$matchersByWindow.get(targetWindow) || new Map();
    $0da83dc02f0b2b9e$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $0da83dc02f0b2b9e$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $0da83dc02f0b2b9e$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $9kKA1.useState)(()=>mql ? mql.matches : false);
    (0, $36fa20552ebd1c7e$export$2e2bcd8739ae039)(()=>{
        let mql = $0da83dc02f0b2b9e$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $0da83dc02f0b2b9e$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $9kKA1 = parcelRequire("9kKA1");
function $9e9340977b60aada$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $9kKA1.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $0da83dc02f0b2b9e$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $9e9340977b60aada$var$useBreakpoint = $9e9340977b60aada$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $9e9340977b60aada$export$2e2bcd8739ae039 = $9e9340977b60aada$var$useBreakpoint;




var $9kKA1 = parcelRequire("9kKA1");

function $fc3084cb386a842c$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $f850eb4c28a0928f$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $8fe0add61b58df58$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $9kKA1 = parcelRequire("9kKA1");



var $9kKA1 = parcelRequire("9kKA1");
function $bbc4c3aed08dd083$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $9kKA1.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $9kKA1 = parcelRequire("9kKA1");
function $fcb9ad245322b16a$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $bbc4c3aed08dd083$export$2e2bcd8739ae039)(fn);
    (0, $9kKA1.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $90d46bb5a43d3542$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $7dda944739a188cc$export$1a88c12b8b979fa0 = (0, $c596eb6171d96e96$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $7dda944739a188cc$var$ModalManager {
    getScrollbarWidth() {
        return (0, $90d46bb5a43d3542$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $da765e750ec11a91$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($7dda944739a188cc$export$1a88c12b8b979fa0, '');
        (0, $da765e750ec11a91$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($7dda944739a188cc$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
}
var $7dda944739a188cc$export$2e2bcd8739ae039 = $7dda944739a188cc$var$ModalManager;





var $9kKA1 = parcelRequire("9kKA1");

var $9kKA1 = parcelRequire("9kKA1");

const $b5582e8ac6b87b68$var$Context = /*#__PURE__*/ (0, $9kKA1.createContext)((0, $495569d57101fa38$export$2e2bcd8739ae039) ? window : undefined);
const $b5582e8ac6b87b68$export$f7d306aeb1cf5fbc = $b5582e8ac6b87b68$var$Context.Provider;
function $b5582e8ac6b87b68$export$2e2bcd8739ae039() {
    return (0, $9kKA1.useContext)($b5582e8ac6b87b68$var$Context);
}


const $63533fa2617148e5$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $495569d57101fa38$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $f850eb4c28a0928f$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $63533fa2617148e5$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $b5582e8ac6b87b68$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $9kKA1.useState)(()=>$63533fa2617148e5$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $63533fa2617148e5$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $9kKA1.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $9kKA1.useEffect)(()=>{
        const nextRef = $63533fa2617148e5$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $9kKA1 = parcelRequire("9kKA1");



var $9kKA1 = parcelRequire("9kKA1");

function $cf2134d389d82569$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $9kKA1.useRef)(null);
    const hasEnteredRef = (0, $9kKA1.useRef)(inProp);
    const handleExited = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)(onExited);
    (0, $9kKA1.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $ce8d3037a0dabc94$export$2e2bcd8739ae039)(ref, (0, $4029778e671a2d75$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $9kKA1.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $cf2134d389d82569$export$2e2bcd8739ae039 = $cf2134d389d82569$var$NoopTransition;



var $9kKA1 = parcelRequire("9kKA1");

var $9kKA1 = parcelRequire("9kKA1");


const $f10ee9a6dca006fc$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $f10ee9a6dca006fc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $f10ee9a6dca006fc$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $f10ee9a6dca006fc$var$_objectWithoutPropertiesLoose(_ref, $f10ee9a6dca006fc$var$_excluded);
    const nodeRef = (0, $9kKA1.useRef)(null);
    const mergedRef = (0, $ce8d3037a0dabc94$export$2e2bcd8739ae039)(nodeRef, (0, $4029778e671a2d75$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $9kKA1.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $9kKA1.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $9kKA1.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $9kKA1.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $9kKA1.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $9kKA1.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $9kKA1.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $9kKA1.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $ca0a2a77326bcf83$var$_excluded = [
    "component"
];
function $ca0a2a77326bcf83$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $ca0a2a77326bcf83$var$RTGTransition = /*#__PURE__*/ $9kKA1.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $ca0a2a77326bcf83$var$_objectWithoutPropertiesLoose(_ref, $ca0a2a77326bcf83$var$_excluded);
    const transitionProps = (0, $f10ee9a6dca006fc$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $ca0a2a77326bcf83$export$2e2bcd8739ae039 = $ca0a2a77326bcf83$var$RTGTransition;




function $7159d7064b4aba41$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $9kKA1.useRef)(null);
    const isInitialRef = (0, $9kKA1.useRef)(true);
    const handleTransition = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)(onTransition);
    (0, $ab176e261f0aa93b$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $ab176e261f0aa93b$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $7159d7064b4aba41$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $9kKA1.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $7159d7064b4aba41$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $ce8d3037a0dabc94$export$2e2bcd8739ae039)(ref, (0, $4029778e671a2d75$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $9kKA1.cloneElement)(children, {
        ref: combinedRef
    });
}
function $7159d7064b4aba41$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $ca0a2a77326bcf83$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)($7159d7064b4aba41$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $cf2134d389d82569$export$2e2bcd8739ae039), Object.assign({}, props));
}




const $b05486e225c30d03$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $b05486e225c30d03$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $b05486e225c30d03$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $b05486e225c30d03$var$getManager(window) {
    if (!$b05486e225c30d03$var$manager) $b05486e225c30d03$var$manager = new (0, $7dda944739a188cc$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $b05486e225c30d03$var$manager;
}
function $b05486e225c30d03$var$useModalManager(provided) {
    const window = (0, $b5582e8ac6b87b68$export$2e2bcd8739ae039)();
    const modalManager = provided || $b05486e225c30d03$var$getManager(window);
    const modal = (0, $9kKA1.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $9kKA1.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $9kKA1.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $b05486e225c30d03$var$Modal = /*#__PURE__*/ (0, $9kKA1.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $b05486e225c30d03$var$_objectWithoutPropertiesLoose(_ref, $b05486e225c30d03$var$_excluded);
    const ownerWindow = (0, $b5582e8ac6b87b68$export$2e2bcd8739ae039)();
    const container = (0, $63533fa2617148e5$export$2e2bcd8739ae039)(containerRef);
    const modal = $b05486e225c30d03$var$useModalManager(providedManager);
    const isMounted = (0, $59e2e539dfd21728$export$2e2bcd8739ae039)();
    const prevShow = (0, $91d3da1183e3460e$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $9kKA1.useState)(!show);
    const lastFocusRef = (0, $9kKA1.useRef)(null);
    (0, $9kKA1.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $495569d57101fa38$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $fc3084cb386a842c$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $685d53a9cad0fb2a$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $685d53a9cad0fb2a$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $fc3084cb386a842c$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $8fe0add61b58df58$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $9kKA1.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $9kKA1.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $fcb9ad245322b16a$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $fc3084cb386a842c$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $8fe0add61b58df58$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $9aaec398347e0c17$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $4029778e671a2d75$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $9kKA1.useRef)();
    const removeKeydownListenerRef = (0, $9kKA1.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $9kKA1.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $7159d7064b4aba41$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $7159d7064b4aba41$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $558ca21e1ebcb642$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aba877308eacd357$exports))).createPortal(/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$b05486e225c30d03$var$Modal.displayName = 'Modal';
var $b05486e225c30d03$export$2e2bcd8739ae039 = Object.assign($b05486e225c30d03$var$Modal, {
    Manager: (0, $7dda944739a188cc$export$2e2bcd8739ae039)
});






var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $5629d0097ff3dfcc$var$OffcanvasBody = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$5629d0097ff3dfcc$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $5629d0097ff3dfcc$export$2e2bcd8739ae039 = $5629d0097ff3dfcc$var$OffcanvasBody;







var $9kKA1 = parcelRequire("9kKA1");






"use client";
const $0b4310772ef17809$var$transitionStyles = {
    [(0, $4e14d0c61bb5db7f$export$df38205c966be359)]: 'show',
    [(0, $4e14d0c61bb5db7f$export$78e9e6e3e014d60a)]: 'show'
};
const $0b4310772ef17809$var$OffcanvasToggling = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "children",
        "in",
        "mountOnEnter",
        "unmountOnExit",
        "appear"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $2bef307424b2bb39$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        addEndListener: (0, $c9e142ba72a01ec0$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear
    }, props), {
        childRef: (0, $4029778e671a2d75$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $9kKA1.cloneElement(children, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, children.props.className, (status === (0, $4e14d0c61bb5db7f$export$df38205c966be359) || status === (0, $4e14d0c61bb5db7f$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $0b4310772ef17809$var$transitionStyles[status])
            }))
    }));
});
$0b4310772ef17809$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $0b4310772ef17809$export$2e2bcd8739ae039 = $0b4310772ef17809$var$OffcanvasToggling;



var $9kKA1 = parcelRequire("9kKA1");
"use client";
const $9029a3df03ae2d85$var$ModalContext = /*#__PURE__*/ $9kKA1.createContext({
    onHide () {}
});
var $9029a3df03ae2d85$export$2e2bcd8739ae039 = $9029a3df03ae2d85$var$ModalContext;







var $9kKA1 = parcelRequire("9kKA1");





var $9kKA1 = parcelRequire("9kKA1");




"use client";
const $5fa75ad8a9c1dde9$var$AbstractModalHeader = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "closeLabel",
        "closeVariant",
        "closeButton",
        "onHide",
        "children"
    ]);
    const context = (0, $9kKA1.useContext)((0, $9029a3df03ae2d85$export$2e2bcd8739ae039));
    const handleClick = (0, $e881a5f2f7c6fa3f$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)("div", (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $aa4497a16673cb1f$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    }));
});
$5fa75ad8a9c1dde9$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $5fa75ad8a9c1dde9$export$2e2bcd8739ae039 = $5fa75ad8a9c1dde9$var$AbstractModalHeader;



"use client";
const $5ca00ae2b3a346d9$var$OffcanvasHeader = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $5fa75ad8a9c1dde9$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$5ca00ae2b3a346d9$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $5ca00ae2b3a346d9$export$2e2bcd8739ae039 = $5ca00ae2b3a346d9$var$OffcanvasHeader;





var $9kKA1 = parcelRequire("9kKA1");




"use client";
const $d807e634af12ddd7$var$DivStyledAsH5 = (0, $99aaf3b630596b82$export$2e2bcd8739ae039)('h5');
const $d807e634af12ddd7$var$OffcanvasTitle = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $d807e634af12ddd7$var$DivStyledAsH5 } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$d807e634af12ddd7$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $d807e634af12ddd7$export$2e2bcd8739ae039 = $d807e634af12ddd7$var$OffcanvasTitle;



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $b55f8a9c8964532a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $c8573247fedd0ad9$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $b55f8a9c8964532a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $06d78491a1ecacee$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $06d78491a1ecacee$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $06d78491a1ecacee$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $06d78491a1ecacee$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $a0c747f8b8f4b9b8$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $a0c747f8b8f4b9b8$var$BootstrapModalManager extends (0, $7dda944739a188cc$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $da765e750ec11a91$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $da765e750ec11a91$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $da765e750ec11a91$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $c8573247fedd0ad9$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $0832d814c73969c1$export$2e2bcd8739ae039)(container, $a0c747f8b8f4b9b8$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $0832d814c73969c1$export$2e2bcd8739ae039)(container, $a0c747f8b8f4b9b8$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $0832d814c73969c1$export$2e2bcd8739ae039)(container, $a0c747f8b8f4b9b8$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $06d78491a1ecacee$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $0832d814c73969c1$export$2e2bcd8739ae039)(container, $a0c747f8b8f4b9b8$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $0832d814c73969c1$export$2e2bcd8739ae039)(container, $a0c747f8b8f4b9b8$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $0832d814c73969c1$export$2e2bcd8739ae039)(container, $a0c747f8b8f4b9b8$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $a0c747f8b8f4b9b8$var$sharedManager;
function $a0c747f8b8f4b9b8$export$a03641438014b436(options) {
    if (!$a0c747f8b8f4b9b8$var$sharedManager) $a0c747f8b8f4b9b8$var$sharedManager = new $a0c747f8b8f4b9b8$var$BootstrapModalManager(options);
    return $a0c747f8b8f4b9b8$var$sharedManager;
}
var $a0c747f8b8f4b9b8$export$2e2bcd8739ae039 = $a0c747f8b8f4b9b8$var$BootstrapModalManager;



"use client";
function $9c0fa6dbf8a903c4$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $0b4310772ef17809$export$2e2bcd8739ae039), (0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props));
}
function $9c0fa6dbf8a903c4$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $1c98f6632da025f8$export$2e2bcd8739ae039), (0, $639d0fc934b99f1e$export$71511d61b312f219)({}, props));
}
const $9c0fa6dbf8a903c4$var$Offcanvas = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "children",
        'aria-labelledby',
        "placement",
        "responsive",
        "show",
        "backdrop",
        "keyboard",
        "scroll",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager",
        "renderStaticNode"
    ]);
    const modalManager = (0, $9kKA1.useRef)();
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $9kKA1.useState)(false);
    const handleHide = (0, $e881a5f2f7c6fa3f$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $9e9340977b60aada$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $9kKA1.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $9kKA1.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $a0c747f8b8f4b9b8$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $a0c747f8b8f4b9b8$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $9kKA1.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        })), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({}, dialogProps, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        }));
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $9029a3df03ae2d85$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $b05486e225c30d03$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $9c0fa6dbf8a903c4$var$DialogTransition,
                    backdropTransition: $9c0fa6dbf8a903c4$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$9c0fa6dbf8a903c4$var$Offcanvas.displayName = 'Offcanvas';
var $9c0fa6dbf8a903c4$export$2e2bcd8739ae039 = Object.assign($9c0fa6dbf8a903c4$var$Offcanvas, {
    Body: (0, $5629d0097ff3dfcc$export$2e2bcd8739ae039),
    Header: (0, $5ca00ae2b3a346d9$export$2e2bcd8739ae039),
    Title: (0, $d807e634af12ddd7$export$2e2bcd8739ae039)
});




"use client";
const $2e666fbc6bd3efed$var$NavbarOffcanvas = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { onHide: onHide } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "onHide"
    ]);
    const context = (0, $9kKA1.useContext)((0, $f5cd3078242fa25d$export$2e2bcd8739ae039));
    const handleHide = (0, $e881a5f2f7c6fa3f$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $9c0fa6dbf8a903c4$export$2e2bcd8739ae039), (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        show: !!(context != null && context.expanded)
    }, props), {
        renderStaticNode: true,
        onHide: handleHide
    }));
});
$2e666fbc6bd3efed$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $2e666fbc6bd3efed$export$2e2bcd8739ae039 = $2e666fbc6bd3efed$var$NavbarOffcanvas;







var $9kKA1 = parcelRequire("9kKA1");



"use client";
const $4795efe2fdae7487$var$NavbarText = /*#__PURE__*/ $9kKA1.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'span' } = _param, props = (0, $347ca26438ba19a6$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $639d0fc934b99f1e$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix)
    }, props));
});
$4795efe2fdae7487$var$NavbarText.displayName = 'NavbarText';
var $4795efe2fdae7487$export$2e2bcd8739ae039 = $4795efe2fdae7487$var$NavbarText;



"use client";
const $4d88f7cd9ef1c74d$var$Navbar = /*#__PURE__*/ $9kKA1.forwardRef((props, ref)=>{
    const _useUncontrolled = (0, $a88d4624e47843eb$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    }), { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false } = _useUncontrolled, controlledProps = (0, $347ca26438ba19a6$export$71511d61b312f219)(_useUncontrolled, [
        "bsPrefix",
        "expand",
        "variant",
        "bg",
        "fixed",
        "sticky",
        "className",
        "as",
        "expanded",
        "onToggle",
        "onSelect",
        "collapseOnSelect"
    ]);
    const bsPrefix = (0, $1ae26d1586ced64e$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $9kKA1.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $9kKA1.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $f5cd3078242fa25d$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $15f48004d4168d8c$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)(Component, (0, $fbaa68106cb8822c$export$71511d61b312f219)((0, $639d0fc934b99f1e$export$71511d61b312f219)({
                ref: ref
            }, controlledProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a22cae3fcc50759c$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            }))
        })
    });
});
$4d88f7cd9ef1c74d$var$Navbar.displayName = 'Navbar';
var $4d88f7cd9ef1c74d$export$2e2bcd8739ae039 = Object.assign($4d88f7cd9ef1c74d$var$Navbar, {
    Brand: (0, $ff662cbfacb0f1f4$export$2e2bcd8739ae039),
    Collapse: (0, $65f2c4d41b338be7$export$2e2bcd8739ae039),
    Offcanvas: (0, $2e666fbc6bd3efed$export$2e2bcd8739ae039),
    Text: (0, $4795efe2fdae7487$export$2e2bcd8739ae039),
    Toggle: (0, $73d4afa90a9b16ce$export$2e2bcd8739ae039)
});




const $5676a9454d66ae87$var$NavigationBar = ({ user: user, onLogout: onLogout })=>{
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $4d88f7cd9ef1c74d$export$2e2bcd8739ae039), {
        bg: "secondary-subtle",
        variant: "light",
        "data-bs-theme": "light",
        expand: "md",
        className: "mb-4 w-100 py-2",
        sticky: "top",
        children: [
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $4d88f7cd9ef1c74d$export$2e2bcd8739ae039).Brand, {
                as: (0, $6c90d8a012cccc16$export$a6c7ac8248d6e38a),
                to: "/",
                className: "px-3",
                children: "myFlix"
            }),
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $4d88f7cd9ef1c74d$export$2e2bcd8739ae039).Toggle, {
                "aria-controls": "app-navbar"
            }),
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $4d88f7cd9ef1c74d$export$2e2bcd8739ae039).Collapse, {
                id: "app-navbar",
                className: "px-3",
                children: [
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $e7db6bfb300bcf03$export$2e2bcd8739ae039), {
                        className: "me-auto",
                        children: user ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $e7db6bfb300bcf03$export$2e2bcd8739ae039).Link, {
                                    as: (0, $6c90d8a012cccc16$export$a6c7ac8248d6e38a),
                                    to: "/",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $e7db6bfb300bcf03$export$2e2bcd8739ae039).Link, {
                                    as: (0, $6c90d8a012cccc16$export$a6c7ac8248d6e38a),
                                    to: "/profile",
                                    children: "Profile"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $558ca21e1ebcb642$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $e7db6bfb300bcf03$export$2e2bcd8739ae039).Link, {
                                    as: (0, $6c90d8a012cccc16$export$a6c7ac8248d6e38a),
                                    to: "/login",
                                    children: "Login"
                                }),
                                /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $e7db6bfb300bcf03$export$2e2bcd8739ae039).Link, {
                                    as: (0, $6c90d8a012cccc16$export$a6c7ac8248d6e38a),
                                    to: "/signup",
                                    children: "Signup"
                                })
                            ]
                        })
                    }),
                    user && /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)("div", {
                        className: "d-flex gap-2",
                        children: /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $d7919c8bc3912607$export$2e2bcd8739ae039), {
                            variant: "outline-dark",
                            onClick: onLogout,
                            children: "Logout"
                        })
                    })
                ]
            })
        ]
    });
};
var $5676a9454d66ae87$export$2e2bcd8739ae039 = $5676a9454d66ae87$var$NavigationBar;


const $e540ab2351391e28$var$App = ()=>{
    const [user, setUser] = (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).useState(JSON.parse(localStorage.getItem('user')) || null);
    const [token, setToken] = (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).useState(localStorage.getItem('token') || null);
    console.log("App rendered. Token:", token);
    const handleLogout = ()=>{
        setUser(null);
        setToken(null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($9kKA1))).useEffect(()=>{
        const onUserUpdated = (e)=>{
            const updated = e.detail;
            if (updated) {
                setUser(updated);
                localStorage.setItem('user', JSON.stringify(updated));
            }
        };
        window.addEventListener('userUpdated', onUserUpdated);
        return ()=>window.removeEventListener('userUpdated', onUserUpdated);
    }, []);
    return /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $6c90d8a012cccc16$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $5676a9454d66ae87$export$2e2bcd8739ae039), {
                user: user,
                onLogout: handleLogout
            }),
            /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsxs)((0, $7a35efd9976b1f32$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$e7b0ac011bb776c6), {
                        path: "/login",
                        element: user ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$444b3ab0cb9aec40), {
                            to: "/"
                        }) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $dd924d4a82f2ca16$export$2e2bcd8739ae039), {
                            onLoggedIn: (user, token)=>{
                                setUser(user);
                                setToken(token);
                                localStorage.setItem('user', JSON.stringify(user));
                                localStorage.setItem('token', token);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$e7b0ac011bb776c6), {
                        path: "/signup",
                        element: user ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$444b3ab0cb9aec40), {
                            to: "/"
                        }) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $916186ad21c0fbbf$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$e7b0ac011bb776c6), {
                        path: "/profile",
                        element: user ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $8e5bf656842d3c0e$export$b378b4d12a0dcbde), {
                            user: user,
                            token: token,
                            setUser: setUser,
                            onLogout: handleLogout
                        }) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$444b3ab0cb9aec40), {
                            to: "/login"
                        })
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$e7b0ac011bb776c6), {
                        path: "/movies/:movieId",
                        element: user ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $b3cd1832d0976658$export$2e2bcd8739ae039), {
                            token: token
                        }) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$444b3ab0cb9aec40), {
                            to: "/login"
                        })
                    }),
                    /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: user ? /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $e93e6abc17d7f60e$export$2e2bcd8739ae039), {
                            token: token,
                            onLogout: handleLogout
                        }) : /*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)((0, $7a35efd9976b1f32$export$444b3ab0cb9aec40), {
                            to: "/login"
                        })
                    })
                ]
            })
        ]
    });
};
const $e540ab2351391e28$var$container = document.getElementById('root');
const $e540ab2351391e28$var$root = (0, $ed66448760126aed$export$882461b6382ed46c)($e540ab2351391e28$var$container);
$e540ab2351391e28$var$root.render(/*#__PURE__*/ (0, $558ca21e1ebcb642$exports.jsx)($e540ab2351391e28$var$App, {}));


//# sourceMappingURL=repo.ed317276.js.map
